import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  /** A float that can be equal or greater than zero */
  NonNegativeFloat: { input: number; output: number; }
  /** Integer that is greater than or equal to zero */
  NonNegativeInt: { input: number; output: number; }
  /** Value between 0 and 1 */
  Percent: { input: number; output: number; }
  /** Integer that is greater than zero */
  PositiveInt: { input: number; output: number; }
};

/** Represents a bounding box that is aligned with x and y axes */
export type Aabb = {
  __typename?: 'AABB';
  height: Scalars['Percent']['output'];
  left: Scalars['Percent']['output'];
  top: Scalars['Percent']['output'];
  width: Scalars['Percent']['output'];
};

export type AddAuthorInput = {
  documentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type AddAuthorPayload = Payload & {
  __typename?: 'AddAuthorPayload';
  author?: Maybe<MetadataAuthor>;
  userErrors?: Maybe<Array<UserError>>;
};

export type AddDocumentTagInput = {
  documentId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};

export type AddDocumentTagPayload = Payload & {
  __typename?: 'AddDocumentTagPayload';
  document?: Maybe<Document>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type AddSubjectInput = {
  documentId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};

export type AddSubjectPayload = Payload & {
  __typename?: 'AddSubjectPayload';
  subject?: Maybe<MetadataSubject>;
  userErrors?: Maybe<Array<UserError>>;
};

export type AddTableGroupInput = {
  /** Initial description may be absent, if so, an empty string will be used */
  description?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  /** Initial name of the TableGroup has to be present. While it may technically be empty or a duplicate, an appropriate warning to the user may be helpful */
  name: Scalars['String']['input'];
};

export type AddTableGroupPayload = Payload & {
  __typename?: 'AddTableGroupPayload';
  tableGroup?: Maybe<TableGroup>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type AddTitleInput = {
  documentId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AddTitlePayload = Payload & {
  __typename?: 'AddTitlePayload';
  title?: Maybe<MetadataTitle>;
  userErrors?: Maybe<Array<UserError>>;
};

/** An Attribute that represents an alternative text for the content outlined by the region */
export type AlternativeTextAttribute = Attribute & Node & {
  __typename?: 'AlternativeTextAttribute';
  /** The alternative text of the attribute */
  alternativeText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<AlternativeTextAttribute>;
  region: Region;
};

/** An artifact that can be downloaded and is generated from a document */
export type Artifact = Node & {
  __typename?: 'Artifact';
  /** Whether the artifact is available for download */
  available: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** When the artifact will be deleted from the server automatically */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The class name of the exporter that was used to export the artifact */
  exporter: Exporter;
  id: Scalars['ID']['output'];
  /** How far the generation of the artifact has progressed */
  progress: Scalars['Percent']['output'];
  /** The document used to create this artifact */
  source: Document;
};

/** Connection type for artifacts */
export type ArtifactConnection = Connection & {
  __typename?: 'ArtifactConnection';
  /** The list of artifacts */
  artifacts: Array<Artifact>;
  /** A list of edges */
  edges: Array<ArtifactEdge>;
  pageInfo: PageInfo;
  total: Scalars['NonNegativeInt']['output'];
};

/** Edge type for artifacts for pagination */
export type ArtifactEdge = Edge & {
  __typename?: 'ArtifactEdge';
  /** The cursor that identifies this artifact */
  cursor: Scalars['String']['output'];
  /** The artifact */
  node: Artifact;
};

/** Base type for all Attributes a region can have */
export type Attribute = {
  id: Scalars['ID']['output'];
  region: Region;
};

/** Specifies for which regions attributes to recieve events for */
export type AttributeSubscriptionInput = {
  /** Only updates of the attributes belonging to the given region will be listened to */
  regionId: Scalars['ID']['input'];
};

/** An Attribute that marks the region as a caption for the linked region */
export type CaptionAttribute = Attribute & Node & {
  __typename?: 'CaptionAttribute';
  id: Scalars['ID']['output'];
  linkedRegion?: Maybe<Region>;
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<CaptionAttribute>;
  region: Region;
};

export type ChangeSubjectInput = {
  subject: Scalars['String']['input'];
  subjectId: Scalars['ID']['input'];
};

export type ChangeSubjectPayload = Payload & {
  __typename?: 'ChangeSubjectPayload';
  subject?: Maybe<MetadataSubject>;
  userErrors?: Maybe<Array<UserError>>;
};

export type ChangeTableGroupDescriptionInput = {
  description: Scalars['String']['input'];
  tableGroupId: Scalars['ID']['input'];
};

export type ChangeTableGroupDescriptionPayload = Payload & {
  __typename?: 'ChangeTableGroupDescriptionPayload';
  tableGroup?: Maybe<TableGroup>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type ChangeTitleLanguageInput = {
  language: Scalars['String']['input'];
  titleId: Scalars['ID']['input'];
};

export type ChangeTitleLanguagePayload = Payload & {
  __typename?: 'ChangeTitleLanguagePayload';
  title?: Maybe<MetadataTitle>;
  userErrors?: Maybe<Array<UserError>>;
};

/** Metadata for lists of child Nodes */
export type Connection = {
  /** Metadata for the current Page */
  pageInfo: PageInfo;
  total: Scalars['NonNegativeInt']['output'];
};

/** Input type for creating an alternative text attribute */
export type CreateAlternativeTextAttributeInput = {
  alternativeText: Scalars['String']['input'];
  /** The id of the region to create the attribute on */
  regionId: Scalars['ID']['input'];
};

/** Payload returned when creating an alternative text attribute */
export type CreateAlternativeTextAttributePayload = Payload & {
  __typename?: 'CreateAlternativeTextAttributePayload';
  /** The created alternative text attribute if no errors occured */
  attribute?: Maybe<AlternativeTextAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for creating an artifact */
export type CreateArtifactInput = {
  documentId: Scalars['ID']['input'];
  /** The Exporter to use to export the document */
  type: ExporterType;
};

/** Payload returned when creating an artifact */
export type CreateArtifactPayload = Payload & {
  __typename?: 'CreateArtifactPayload';
  /** The created artifact if no errors occurred */
  artifact?: Maybe<Artifact>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for creating a caption attribute */
export type CreateCaptionAttributeInput = {
  linkedRegionId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the region to create the attribute on */
  regionId: Scalars['ID']['input'];
};

/** Payload returned when creating a caption attribute */
export type CreateCaptionAttributePayload = Payload & {
  __typename?: 'CreateCaptionAttributePayload';
  /** The created caption attribute if no errors occured */
  attribute?: Maybe<CaptionAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type CreateExcludeReadingOrderAttributeInput = {
  /** The id of the region to create the attribute on */
  regionId: Scalars['ID']['input'];
};

export type CreateExcludeReadingOrderAttributePayload = Payload & {
  __typename?: 'CreateExcludeReadingOrderAttributePayload';
  attribute?: Maybe<ExcludeReadingOrderAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for creating an expression attribute */
export type CreateExpressionAttributeInput = {
  /** The latex code that produces the expression marked by the region */
  expressionLatex: Scalars['String']['input'];
  /** The id of the region to create the attribute on */
  regionId: Scalars['ID']['input'];
};

/** Payload returned when creating an expression attribute */
export type CreateExpressionAttributePayload = Payload & {
  __typename?: 'CreateExpressionAttributePayload';
  /** The created expression attribute if no errors occured */
  attribute?: Maybe<ExpressionAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for creating a figure attribute */
export type CreateFigureAttributeInput = {
  /** The id of the region to create the attribute on */
  regionId: Scalars['ID']['input'];
};

/** Payload returned when creating a figure attribute */
export type CreateFigureAttributePayload = Payload & {
  __typename?: 'CreateFigureAttributePayload';
  /** The created figure attribute if no errors occured */
  attribute?: Maybe<FigureAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type CreateFootnoteAttributeInput = {
  regionId: Scalars['ID']['input'];
};

export type CreateFootnoteAttributePayload = Payload & {
  __typename?: 'CreateFootnoteAttributePayload';
  attribute?: Maybe<FootnoteAttribute>;
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for creating a header level attribute */
export type CreateHeaderLevelAttributeInput = {
  level: Scalars['PositiveInt']['input'];
  /** The id of the region to create the attribute on */
  regionId: Scalars['ID']['input'];
};

/** Payload returned when creating a header level attribute */
export type CreateHeaderLevelAttributePayload = Payload & {
  __typename?: 'CreateHeaderLevelAttributePayload';
  /** The created header level attribute if no errors occured */
  attribute?: Maybe<HeaderLevelAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type CreateImageAttributeInput = {
  regionId: Scalars['ID']['input'];
};

export type CreateImageAttributePayload = Payload & {
  __typename?: 'CreateImageAttributePayload';
  attribute?: Maybe<ImageAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type CreateListAttributeInput = {
  /** The type of the list inside the region */
  listType: ListType;
  /** The id of the region the attribute is to be created in */
  regionId: Scalars['ID']['input'];
};

export type CreateListAttributePayload = Payload & {
  __typename?: 'CreateListAttributePayload';
  attribute?: Maybe<ListAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type CreateListItemAttributeInput = {
  ordinal: Scalars['NonNegativeInt']['input'];
  regionId: Scalars['ID']['input'];
};

export type CreateListItemAttributePayload = Payload & {
  __typename?: 'CreateListItemAttributePayload';
  attribute?: Maybe<ListItemAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type CreateListItemLabelAttributeInput = {
  regionId: Scalars['ID']['input'];
};

export type CreateListItemLabelAttributePayload = Payload & {
  __typename?: 'CreateListItemLabelAttributePayload';
  attribute?: Maybe<ListItemLabelAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type CreatePaginationArtifactAttributeInput = {
  regionId: Scalars['ID']['input'];
  type: PaginationArtifactType;
};

export type CreatePaginationArtifactAttributePayload = Payload & {
  __typename?: 'CreatePaginationArtifactAttributePayload';
  attribute?: Maybe<PaginationArtifactAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for creating a region */
export type CreateRegionInput = {
  /** The id of the page to create the region on */
  pageId: Scalars['ID']['input'];
  shape: InputPolygon;
};

/** Payload returned when creating a region */
export type CreateRegionPayload = Payload & {
  __typename?: 'CreateRegionPayload';
  /** The created region if no errors occured */
  region?: Maybe<Region>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for creating a table attribute */
export type CreateTableAttributeInput = {
  /** The width of the columns of the table */
  columns: Array<Scalars['NonNegativeFloat']['input']>;
  /** Column offset into imaginary parent table */
  parentColumnOffset: Scalars['NonNegativeInt']['input'];
  /** Row offset into imaginary parent table */
  parentRowOffset: Scalars['NonNegativeInt']['input'];
  parentTableGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the region to create the attribute on */
  regionId: Scalars['ID']['input'];
  /** The height of the columns of the table */
  rows: Array<Scalars['NonNegativeFloat']['input']>;
};

/** Payload returned when creating a table attribute */
export type CreateTableAttributePayload = Payload & {
  __typename?: 'CreateTableAttributePayload';
  /** The created table attribute if no errors occured */
  attribute?: Maybe<TableAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for creating a table cell attribute */
export type CreateTableCellAttributeInput = {
  columnSpan: Scalars['PositiveInt']['input'];
  /** The id of the region to create the attribute on */
  regionId: Scalars['ID']['input'];
  rowSpan: Scalars['PositiveInt']['input'];
};

/** Payload returned when creating a table cell attribute */
export type CreateTableCellAttributePayload = Payload & {
  __typename?: 'CreateTableCellAttributePayload';
  /** The created table cell attribute if no errors occured */
  attribute?: Maybe<TableCellAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for creating a TableHeaderCellAttribute */
export type CreateTableHeaderCellAttributeInput = {
  /** The id of the region the new attribute belongs to */
  regionId: Scalars['ID']['input'];
  scopes: Array<TableHeaderCellScopeInput>;
};

/** Payload returned when creating a TableHeaderCellAttribute */
export type CreateTableHeaderCellAttributePayload = Payload & {
  __typename?: 'CreateTableHeaderCellAttributePayload';
  attribute?: Maybe<TableHeaderCellAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type CreateTableOfContentsAttributeInput = {
  regionId: Scalars['ID']['input'];
};

export type CreateTableOfContentsAttributePayload = Payload & {
  __typename?: 'CreateTableOfContentsAttributePayload';
  attribute?: Maybe<TableOfContentsAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type CreateTableOfContentsHeadingAttributeInput = {
  regionId: Scalars['ID']['input'];
};

export type CreateTableOfContentsHeadingAttributePayload = Payload & {
  __typename?: 'CreateTableOfContentsHeadingAttributePayload';
  attribute?: Maybe<TableOfContentsHeadingAttribute>;
  userErrors?: Maybe<Array<UserError>>;
};

export type CreateTableOfContentsItemAttributeInput = {
  linkedRegionId?: InputMaybe<Scalars['ID']['input']>;
  regionId: Scalars['ID']['input'];
};

export type CreateTableOfContentsItemAttributePayload = Payload & {
  __typename?: 'CreateTableOfContentsItemAttributePayload';
  attribute?: Maybe<TableOfContentsItemAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type CreateTableOfContentsPageNumberAttributeInput = {
  regionId: Scalars['ID']['input'];
};

export type CreateTableOfContentsPageNumberAttributePayload = Payload & {
  __typename?: 'CreateTableOfContentsPageNumberAttributePayload';
  attribute?: Maybe<TableOfContentsPageNumberAttribute>;
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for creating a text attribute */
export type CreateTextAttributeInput = {
  /** The id of the region to create the attribute on */
  regionId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

/** Payload returned when creating a text attribute */
export type CreateTextAttributePayload = Payload & {
  __typename?: 'CreateTextAttributePayload';
  /** The created text attribute if no errors occured */
  attribute?: Maybe<TextAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type DeleteArtifactInput = {
  artifactId: Scalars['ID']['input'];
};

export type DeleteArtifactPayload = Payload & {
  __typename?: 'DeleteArtifactPayload';
  artifact?: Maybe<Artifact>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type DeleteAttributeInput = {
  attributeId: Scalars['ID']['input'];
};

export type DeleteAttributePayload = Payload & {
  __typename?: 'DeleteAttributePayload';
  attribute?: Maybe<Attribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type DeleteAttributesInput = {
  attributeIds: Array<Scalars['ID']['input']>;
};

export type DeleteAttributesPayload = Payload & {
  __typename?: 'DeleteAttributesPayload';
  attributeIds: Array<Maybe<Scalars['ID']['output']>>;
  userErrors?: Maybe<Array<UserError>>;
};

export type DeleteDocumentInput = {
  documentId: Scalars['ID']['input'];
};

export type DeleteDocumentPayload = Payload & {
  __typename?: 'DeleteDocumentPayload';
  /** The deleted document if any was deleted */
  document?: Maybe<Document>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type DeleteRegionInput = {
  regionId: Scalars['ID']['input'];
};

/** Payload returned when deleting a region */
export type DeleteRegionPayload = Payload & {
  __typename?: 'DeleteRegionPayload';
  /** The deleted region if any */
  region?: Maybe<Region>;
  userErrors?: Maybe<Array<UserError>>;
};

export type Deployment = {
  __typename?: 'Deployment';
  vcsRef?: Maybe<Scalars['String']['output']>;
  vcsUrl?: Maybe<Scalars['String']['output']>;
};

/** A document that contains pages and can be downloaded */
export type Document = Node & {
  __typename?: 'Document';
  /** The list of artifacts for this document */
  artifacts: ArtifactConnection;
  /** Whether the children of the document are available (when uploading the document there is a short period where we extract the document metadata during which time this data is not available (e.g. pages etc)) */
  available: Scalars['Boolean']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** When this document will be automatically removed from the server (optional) */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  extension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastModifiedAt: Scalars['DateTime']['output'];
  lastModifiedBy: User;
  /** Which users have access to the document */
  members: MembershipConnection;
  /** Metadata that is given to the document exporter */
  metadata: Metadata;
  name: Scalars['String']['output'];
  pageCount: Scalars['Int']['output'];
  /**
   * The list of pages in this document
   * Only valid after #available is true
   */
  pages: PageConnection;
  /** Other tags used by the same user but in different documents */
  possibleTags: Array<Scalars['String']['output']>;
  /** All regions in this document */
  regions: RegionConnection;
  /** A list of all table groups in the document */
  tableGroups: TableGroupConnection;
  /** Tags that are given to a document for organization in the system. These tags are not given to the document exporter */
  tags: Array<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy: User;
  /** The permission the viewing user has on the document */
  viewerMembership: Membership;
};


/** A document that contains pages and can be downloaded */
export type DocumentArtifactsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  next?: InputMaybe<Scalars['PositiveInt']['input']>;
  previous?: InputMaybe<Scalars['PositiveInt']['input']>;
};


/** A document that contains pages and can be downloaded */
export type DocumentMembersArgs = {
  constraint?: InputMaybe<Array<UserConstraint>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  next?: InputMaybe<Scalars['PositiveInt']['input']>;
  previous?: InputMaybe<Scalars['PositiveInt']['input']>;
  sort?: InputMaybe<Array<UserSort>>;
};


/** A document that contains pages and can be downloaded */
export type DocumentPagesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  next?: InputMaybe<Scalars['PositiveInt']['input']>;
  previous?: InputMaybe<Scalars['PositiveInt']['input']>;
};


/** A document that contains pages and can be downloaded */
export type DocumentRegionsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  next?: InputMaybe<Scalars['PositiveInt']['input']>;
  previous?: InputMaybe<Scalars['PositiveInt']['input']>;
};


/** A document that contains pages and can be downloaded */
export type DocumentTableGroupsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  next?: InputMaybe<Scalars['PositiveInt']['input']>;
  previous?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/** A constraint for a document to match */
export type DocumentConstraint = {
  /** Which aspect to check against */
  category: DocumentConstraintCategory;
  /** Optional String used by some ConstraintCategories (will be switched to enum once extensions are done using enums) */
  extension?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include or exclude documents that match the constraint (true means include) */
  include: Scalars['Boolean']['input'];
  /** Optional String used by some ConstraintCategories */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Categories of Constraints for documents to match */
export enum DocumentConstraintCategory {
  /** The extension must match the given extension */
  Extension = 'EXTENSION',
  /** The name must partially match a given value string */
  Name = 'NAME',
  /** The document must be tagged with the given value string */
  Tag = 'TAG'
}

/** A specification on how to sort a list of documents */
export type DocumentSort = {
  /** Whether to sort them in ascending or descending order */
  ascending: Scalars['Boolean']['input'];
  /** The category to sort the documents by */
  category: DocumentSortCategory;
};

/** Categories to sort documents by */
export enum DocumentSortCategory {
  /** Sorts the documents by their creation date (ascending means newer documents show up earlier) */
  CreatedAt = 'CREATED_AT',
  /** Sorts the documents alphabetically by extension */
  Extension = 'EXTENSION',
  /** Sorts the documents by the date they have last been modified (ascending means documents newly edited documents show up earlier) */
  LastModifiedAt = 'LAST_MODIFIED_AT',
  /** Sorts the documents alphabetically by name */
  Name = 'NAME'
}

/** An edge of a paginated Connection */
export type Edge = {
  cursor: Scalars['String']['output'];
};

/** Marks the content of the region to be excluded from the reading order */
export type ExcludeReadingOrderAttribute = Attribute & Node & {
  __typename?: 'ExcludeReadingOrderAttribute';
  id: Scalars['ID']['output'];
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<ExcludeReadingOrderAttribute>;
  region: Region;
};

export enum Exporter {
  Docx = 'DOCX',
  Latex = 'LATEX',
  Pdf = 'PDF'
}

/** All possible types of exporters */
export enum ExporterType {
  Docx = 'DOCX',
  Latex = 'LATEX',
  Pdf = 'PDF'
}

/** An Attribute that represents a mathematical expression */
export type ExpressionAttribute = Attribute & Node & {
  __typename?: 'ExpressionAttribute';
  /** The latex code that produces the expression marked by the region */
  expressionLatex: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<ExpressionAttribute>;
  region: Region;
};

/** An Attribute that marks the content outlined by the region as a figure */
export type FigureAttribute = Attribute & Node & {
  __typename?: 'FigureAttribute';
  id: Scalars['ID']['output'];
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<FigureAttribute>;
  region: Region;
};

export type FootnoteAttribute = Attribute & Node & {
  __typename?: 'FootnoteAttribute';
  id: Scalars['ID']['output'];
  /** The ordinal in the list */
  ordinal: Scalars['NonNegativeInt']['output'];
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<FootnoteAttribute>;
  region: Region;
};

/** An Attribute that marks the content outlined by the region as a header with the given level */
export type HeaderLevelAttribute = Attribute & Node & {
  __typename?: 'HeaderLevelAttribute';
  id: Scalars['ID']['output'];
  level: Scalars['PositiveInt']['output'];
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<HeaderLevelAttribute>;
  region: Region;
};

/** Marks the region as an image */
export type ImageAttribute = Attribute & Node & {
  __typename?: 'ImageAttribute';
  id: Scalars['ID']['output'];
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<ImageAttribute>;
  region: Region;
};

/** A polygon to pass as a parameter (AABB is calculated on the backend) */
export type InputPolygon = {
  /** The list of corners of the polygon in clockwise order */
  vertices: Array<InputVertex>;
};

export type InputVertex = {
  left: Scalars['Percent']['input'];
  top: Scalars['Percent']['input'];
};

/** An issue that is present on a document */
export type Issue = Node & {
  __typename?: 'Issue';
  id: Scalars['ID']['output'];
  page: Page;
  region: Region;
  /** The ids of the conflicting attributes */
  targets: Array<Attribute>;
  /** The type of the issue */
  type: IssueType;
};

/** Possible types of issues */
export enum IssueType {
  BlankAlternativeText = 'BlankAlternativeText',
  BlankText = 'BlankText',
  CaptionedElementMissing = 'CaptionedElementMissing',
  ExpressionBlank = 'ExpressionBlank',
  IncompleteList = 'IncompleteList',
  IncompleteTable = 'IncompleteTable',
  IncompleteTableOfContents = 'IncompleteTableOfContents',
  InvalidListChild = 'InvalidListChild',
  InvalidTableChild = 'InvalidTableChild',
  InvalidTableOfContentsChild = 'InvalidTableOfContentsChild',
  InvalidTableOfContentsItemLink = 'InvalidTableOfContentsItemLink',
  MalformedExpression = 'MalformedExpression',
  MalformedTableOfContentsItem = 'MalformedTableOfContentsItem',
  NoPrimaryContentAttribute = 'NoPrimaryContentAttribute',
  OrphanTableCell = 'OrphanTableCell',
  OrphanTableOfContentsHeading = 'OrphanTableOfContentsHeading',
  OrphanTableOfContentsItem = 'OrphanTableOfContentsItem',
  OrphanTableOfContentsPageNumber = 'OrphanTableOfContentsPageNumber',
  TableCellHeaderWithoutTableCell = 'TableCellHeaderWithoutTableCell',
  TooManyFigure = 'TooManyFigure',
  TooManyHeader = 'TooManyHeader',
  TooManyListItem = 'TooManyListItem',
  TooManyListItemLabel = 'TooManyListItemLabel',
  TooManyPaginationArtifact = 'TooManyPaginationArtifact',
  TooManyPrimaryContentAttributes = 'TooManyPrimaryContentAttributes',
  TooManyTableCell = 'TooManyTableCell',
  TooManyTableCellHeader = 'TooManyTableCellHeader',
  TooManyTableOfContentsHeading = 'TooManyTableOfContentsHeading',
  TooManyTableOfContentsPageNumber = 'TooManyTableOfContentsPageNumber'
}

/** Marks the region as a list container */
export type ListAttribute = Attribute & Node & {
  __typename?: 'ListAttribute';
  id: Scalars['ID']['output'];
  /** The type of list */
  listType: ListType;
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<ListAttribute>;
  region: Region;
};

/** Marks the region as a list item */
export type ListItemAttribute = Attribute & Node & {
  __typename?: 'ListItemAttribute';
  id: Scalars['ID']['output'];
  /** The ordinal in the list */
  ordinal: Scalars['NonNegativeInt']['output'];
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<ListItemAttribute>;
  region: Region;
};

export type ListItemLabelAttribute = Attribute & Node & {
  __typename?: 'ListItemLabelAttribute';
  id: Scalars['ID']['output'];
  originalAttribute?: Maybe<ListItemLabelAttribute>;
  region: Region;
};

/** Valid types of list */
export enum ListType {
  Circle = 'CIRCLE',
  Decimal = 'DECIMAL',
  Description = 'DESCRIPTION',
  Disc = 'DISC',
  LowerAlpha = 'LOWER_ALPHA',
  LowerRoman = 'LOWER_ROMAN',
  None = 'NONE',
  Ordered = 'ORDERED',
  Square = 'SQUARE',
  Unordered = 'UNORDERED',
  UpperAlpha = 'UPPER_ALPHA',
  UpperRoman = 'UPPER_ROMAN'
}

/** Relationship between a user and a document */
export type Membership = {
  __typename?: 'Membership';
  /** The document the user has access to */
  document: Document;
  /** The level of permissions the user of this membership has on the given document */
  permission: Permission;
  /** The user that has this membership */
  user: User;
};

export type MembershipConnection = Connection & {
  __typename?: 'MembershipConnection';
  /** The fetched elements with their corresponding cursors */
  edges: Array<MembershipEdge>;
  /** A list of all extensions any of documents that could be referenced by a membership in this context might have */
  extensions: Array<Scalars['String']['output']>;
  /** The fetched elements without cursors */
  memberships: Array<Membership>;
  /** Info about the currently fetched page */
  pageInfo: PageInfo;
  /** A list of all tags that any of the documents that could be referenced by a membership in this context might have */
  tags: Array<Scalars['String']['output']>;
  /** The total number of memberships (not just the fetched ones) */
  total: Scalars['NonNegativeInt']['output'];
};

export type MembershipEdge = Edge & {
  __typename?: 'MembershipEdge';
  cursor: Scalars['String']['output'];
  node: Membership;
};

export type Metadata = {
  __typename?: 'Metadata';
  /** Who wrote the document (multiple authors allowed) */
  authors: Array<MetadataAuthor>;
  /** Date associated with an important event in the */
  date?: Maybe<Scalars['DateTime']['output']>;
  document: Document;
  language: Scalars['String']['output'];
  /** Subject of the document as a list of keywords */
  subject: Array<MetadataSubject>;
  /** A collection of titles and their corresponding languages */
  titles: Array<MetadataTitle>;
};

export type MetadataAuthor = Node & {
  __typename?: 'MetadataAuthor';
  id: Scalars['ID']['output'];
  metadata: Metadata;
  name: Scalars['String']['output'];
};

export type MetadataSubject = Node & {
  __typename?: 'MetadataSubject';
  id: Scalars['ID']['output'];
  metadata: Metadata;
  subject: Scalars['String']['output'];
};

export type MetadataTitle = Node & {
  __typename?: 'MetadataTitle';
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  metadata: Metadata;
  title: Scalars['String']['output'];
};

/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Adds an author to the given documents metadata.
   * The name of the author must be a not null, not blank string.
   */
  addAuthor: AddAuthorPayload;
  /** Adds a given tag to the document. No duplicates allowed. */
  addDocumentTag: AddDocumentTagPayload;
  /**
   * Adds the given subject to the given documents metadata.
   * The subject must be a not null, not blank string.
   */
  addSubject: AddSubjectPayload;
  /**
   * Adds a table group with the given name and description to the given document
   * TableGroups are used to mark regions with table attributes that belong to the same conceptual parent table
   */
  addTableGroup: AddTableGroupPayload;
  /**
   * Adds a title to the given documents metadata.
   * The title must be a not null, not blank string.
   * The language must be a not null, not blank string.
   */
  addTitle: AddTitlePayload;
  /**
   * Changes the given subject.
   * The subject must be a not null, not blank string.
   */
  changeSubject: ChangeSubjectPayload;
  /** Changes the description of the table group */
  changeTableGroupDescription: ChangeTableGroupDescriptionPayload;
  /**
   * Changes the language of the given MetadataTitle.
   * The language must be a not null, not blank string.
   */
  changeTitleLanguage: ChangeTitleLanguagePayload;
  /** Creates a new alternative text attribute on the given region */
  createAlternativeTextAttribute: CreateAlternativeTextAttributePayload;
  /** Creates a new artifact for a given document and exporter type */
  createArtifact: CreateArtifactPayload;
  /** Creates a new Caption attribute on the given region */
  createCaptionAttribute: CreateCaptionAttributePayload;
  /** Creates a new ExcludeReadingOrderAttribute on the given region */
  createExcludeReadingOrderAttribute: CreateExcludeReadingOrderAttributePayload;
  /** Creates a new expression attribute on the given region */
  createExpressionAttribute: CreateExpressionAttributePayload;
  /** Creates a new figure attribute on the given region */
  createFigureAttribute: CreateFigureAttributePayload;
  createFootnoteAttribute: CreateFootnoteAttributePayload;
  /** Creates a new header level attribute on the given region */
  createHeaderLevelAttribute: CreateHeaderLevelAttributePayload;
  /** Creates a new image attribute on the given region */
  createImageAttribute: CreateImageAttributePayload;
  /** Creates a new list attribute on the given region */
  createListAttribute: CreateListAttributePayload;
  /** Creates a new list item attribute on the given region */
  createListItemAttribute: CreateListItemAttributePayload;
  /** Creates a list item label attribute on the given region */
  createListItemLabelAttribute: CreateListItemLabelAttributePayload;
  /** Creates pagination artifact attribute on the given region */
  createPaginationArtifactAttribute: CreatePaginationArtifactAttributePayload;
  /** Creates a new region on a given page with the given dimensions */
  createRegion: CreateRegionPayload;
  /** Creates a new table attribute on the given region */
  createTableAttribute: CreateTableAttributePayload;
  /** Creates a new table cell attribute on the given region */
  createTableCellAttribute: CreateTableCellAttributePayload;
  /** Creates a new header cell attribute on the given region */
  createTableHeaderCellAttribute: CreateTableHeaderCellAttributePayload;
  /** Creates a table of contents attribute on the given region */
  createTableOfContentsAttribute: CreateTableOfContentsAttributePayload;
  /** Creates a table of contents heading attribute on a given region */
  createTableOfContentsHeadingAttribute: CreateTableOfContentsHeadingAttributePayload;
  /** Creates a table of contents item attribute on the given region */
  createTableOfContentsItemAttribute: CreateTableOfContentsItemAttributePayload;
  /** Creates a table of contents page number attribute on a given region */
  createTableOfContentsPageNumberAttribute: CreateTableOfContentsPageNumberAttributePayload;
  /** Creates a new text attribute on the given region */
  createTextAttribute: CreateTextAttributePayload;
  /** Deletes an artifact */
  deleteArtifact: DeleteArtifactPayload;
  /** Delete the Attribute with the given ID */
  deleteAttribute: DeleteAttributePayload;
  /** Deletes the attributes with the given ids */
  deleteAttributes: DeleteAttributesPayload;
  /** Deletes a document, its associated artifacts and all its pages, regions and attributes */
  deleteDocument: DeleteDocumentPayload;
  /** Deletes a region and all its attributes */
  deleteRegion: DeleteRegionPayload;
  /** Removes the given author. */
  removeAuthor: RemoveAuthorPayload;
  /** Removes the given tag from the document. A tag must exist to be removed. */
  removeDocumentTag: RemoveDocumentTagPayload;
  /** Removes the given subject. */
  removeSubject: RemoveSubjectPayload;
  /** Removes the table group from the document and sets all references to the table group back to null */
  removeTableGroup: RemoveTableGroupPayload;
  /** Removes the given MetadataTitle. */
  removeTitle: RemoveTitlePayload;
  /**
   * Renames the given author.
   * The name of the author must be a not null, not blank string.
   */
  renameAuthor: RenameAuthorPayload;
  /** Updates the name of a given document */
  renameDocument: RenameDocumentPayload;
  /** Changes the name of the table group */
  renameTableGroup: RenameTableGroupPayload;
  /**
   * Changes the title of the given MetadataTitle.
   * The title must be a not null, not blank string.
   */
  renameTitle: RenameTitlePayload;
  /**
   * Sets the date field of the given documents metadata to the given value.
   * The date can be either a valid DateTime or null (in which case the field is set to null)
   */
  setDate: SetDatePayload;
  /**
   * Sets the language of the given documents metadata.
   * The given language needs to conform to the specifications of IETF BCP 47 language tags.
   */
  setLanguage: SetLanguagePayload;
  /** Sets the table group of the table (may be null) */
  setTableAttributeTableGroup: SetTableAttributeTableGroupPayload;
  /** Updates the alternative text of an existing alternative text attribute */
  updateAlternativeTextAttribute: UpdateAlternativeTextAttributePayload;
  /** Updates the index of an existing caption attribute */
  updateCaptionAttribute: UpdateCaptionAttributePayload;
  /** Updates the permission of a document for a given user */
  updateDocumentPermission: UpdateDocumentPermissionPayload;
  /** Updates the expression latex of an existing expression attribute */
  updateExpressionAttribute: UpdateExpressionAttributePayload;
  /** Updates the level of an existing header level attribute */
  updateHeaderLevelAttribute: UpdateHeaderLevelAttributePayload;
  /** Updates a given list attributes type */
  updateListAttribute: UpdateListAttributePayload;
  /** Updates a given list item attributes ordinal */
  updateListItemAttribute: UpdateListItemAttributePayload;
  /** Updates the type of the given pagination artifact attribute */
  updatePaginationArtifactAttribute: UpdatePaginationArtifactAttributePayload;
  /** Updates the regions next region field. */
  updateRegionNextRegion: UpdateRegionNextRegionPayload;
  /** Updates the given regions reading order index */
  updateRegionReadingOrderIndex: UpdateRegionReadingOrderIndexPayload;
  /** Updates the shape of the region */
  updateRegionShape: UpdateRegionShapePayload;
  /** Updates the parentRowOffset, parentColumnOffset and rows and columns of an existing table attribute */
  updateTableAttribute: UpdateTableAttributePayload;
  /** Updates the row and column size of an existing table cell attribute */
  updateTableCellAttribute: UpdateTableCellAttributePayload;
  /** Updates a new header cell attribute on the given region */
  updateTableHeaderCellAttribute: UpdateTableHeaderCellAttributePayload;
  /** Updates the given table of contents item attributes linked region */
  updateTableOfContentsItemAttribute: UpdateTableOfContentsItemAttributePayload;
  /** Updates the text of an existing text attribute */
  updateTextAttribute: UpdateTextAttributePayload;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationAddAuthorArgs = {
  input: AddAuthorInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationAddDocumentTagArgs = {
  input: AddDocumentTagInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationAddSubjectArgs = {
  input: AddSubjectInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationAddTableGroupArgs = {
  input: AddTableGroupInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationAddTitleArgs = {
  input: AddTitleInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationChangeSubjectArgs = {
  input: ChangeSubjectInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationChangeTableGroupDescriptionArgs = {
  input: ChangeTableGroupDescriptionInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationChangeTitleLanguageArgs = {
  input: ChangeTitleLanguageInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateAlternativeTextAttributeArgs = {
  input: CreateAlternativeTextAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateArtifactArgs = {
  input: CreateArtifactInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateCaptionAttributeArgs = {
  input: CreateCaptionAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateExcludeReadingOrderAttributeArgs = {
  input: CreateExcludeReadingOrderAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateExpressionAttributeArgs = {
  input: CreateExpressionAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateFigureAttributeArgs = {
  input: CreateFigureAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateFootnoteAttributeArgs = {
  input: CreateFootnoteAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateHeaderLevelAttributeArgs = {
  input: CreateHeaderLevelAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateImageAttributeArgs = {
  input: CreateImageAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateListAttributeArgs = {
  input: CreateListAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateListItemAttributeArgs = {
  input: CreateListItemAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateListItemLabelAttributeArgs = {
  input: CreateListItemLabelAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreatePaginationArtifactAttributeArgs = {
  input: CreatePaginationArtifactAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateRegionArgs = {
  input: CreateRegionInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateTableAttributeArgs = {
  input: CreateTableAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateTableCellAttributeArgs = {
  input: CreateTableCellAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateTableHeaderCellAttributeArgs = {
  input: CreateTableHeaderCellAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateTableOfContentsAttributeArgs = {
  input: CreateTableOfContentsAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateTableOfContentsHeadingAttributeArgs = {
  input: CreateTableOfContentsHeadingAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateTableOfContentsItemAttributeArgs = {
  input: CreateTableOfContentsItemAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateTableOfContentsPageNumberAttributeArgs = {
  input: CreateTableOfContentsPageNumberAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationCreateTextAttributeArgs = {
  input: CreateTextAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationDeleteArtifactArgs = {
  input: DeleteArtifactInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationDeleteAttributeArgs = {
  input: DeleteAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationDeleteAttributesArgs = {
  input: DeleteAttributesInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationDeleteDocumentArgs = {
  input: DeleteDocumentInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationDeleteRegionArgs = {
  input: DeleteRegionInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationRemoveAuthorArgs = {
  input: RemoveAuthorInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationRemoveDocumentTagArgs = {
  input: RemoveDocumentTagInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationRemoveSubjectArgs = {
  input: RemoveSubjectInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationRemoveTableGroupArgs = {
  input: RemoveTableGroupInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationRemoveTitleArgs = {
  input: RemoveTitleInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationRenameAuthorArgs = {
  input: RenameAuthorNameInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationRenameDocumentArgs = {
  input: RenameDocumentInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationRenameTableGroupArgs = {
  input: RenameTableGroupInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationRenameTitleArgs = {
  input: RenameTitleInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationSetDateArgs = {
  input: SetDateInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationSetLanguageArgs = {
  input: SetLanguageInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationSetTableAttributeTableGroupArgs = {
  input: SetTableAttributeTableGroupInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateAlternativeTextAttributeArgs = {
  input: UpdateAlternativeTextAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateCaptionAttributeArgs = {
  input: UpdateCaptionAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateDocumentPermissionArgs = {
  input?: InputMaybe<UpdateDocumentPermissionInput>;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateExpressionAttributeArgs = {
  input: UpdateExpressionAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateHeaderLevelAttributeArgs = {
  input: UpdateHeaderLevelAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateListAttributeArgs = {
  input: UpdateListAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateListItemAttributeArgs = {
  input: UpdateListItemAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdatePaginationArtifactAttributeArgs = {
  input: UpdatePaginationArtifactAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateRegionNextRegionArgs = {
  input: UpdateRegionNextRegionInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateRegionReadingOrderIndexArgs = {
  input: UpdateRegionReadingOrderIndexInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateRegionShapeArgs = {
  input: UpdateRegionShapeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateTableAttributeArgs = {
  input: UpdateTableAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateTableCellAttributeArgs = {
  input: UpdateTableCellAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateTableHeaderCellAttributeArgs = {
  input: UpdateTableHeaderCellAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateTableOfContentsItemAttributeArgs = {
  input: UpdateTableOfContentsItemAttributeInput;
};


/**
 * All Possible Mutations go here.
 * Note that creating a document or pages is not possible through this API, since a document upload is required.
 */
export type MutationUpdateTextAttributeArgs = {
  input: UpdateTextAttributeInput;
};

/** An error that occurred and has no suggestion on how to fix it */
export type NoFixError = UserError & {
  __typename?: 'NoFixError';
  code: UserErrorCode;
  path: Scalars['String']['output'];
};

/** A globally uniquely identified object */
export type Node = {
  id: Scalars['ID']['output'];
};

/** A page of a document */
export type Page = Node & {
  __typename?: 'Page';
  /** Whether the pages children (regions and attributes) are available */
  available: Scalars['Boolean']['output'];
  document: Document;
  /** The height of the page in inches only valid after #available is true */
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** The index of the page (1 based) */
  index: Scalars['PositiveInt']['output'];
  /** The list of issues on the page, only valid after #available is true */
  issues: Array<Issue>;
  nextPage?: Maybe<Page>;
  /** Url for retrieving a png of this page (if null, the page cannot be rendered as png) */
  pngUrl?: Maybe<Scalars['String']['output']>;
  previousPage?: Maybe<Page>;
  /** The list of regions on the page, only valid after #available is true */
  regions: Array<Region>;
  /** The progress of the segmentation of the page (if not yet available) */
  segmentationProgress: Scalars['Percent']['output'];
  /** Url for retrieving a svg of this page (if null, the page cannot be rendered as svg) */
  svgUrl?: Maybe<Scalars['String']['output']>;
  /** The width of the page in inches, only valid after #available is true */
  width: Scalars['Float']['output'];
};

/** Connection type for pages */
export type PageConnection = Connection & {
  __typename?: 'PageConnection';
  /** A list of edges */
  edges: Array<PageEdge>;
  pageInfo: PageInfo;
  /** The list of pages */
  pages: Array<Page>;
  /** The total number of available Pages (not just the ones that were fetched) */
  total: Scalars['NonNegativeInt']['output'];
};

/** Edge type for pages for pagination */
export type PageEdge = Edge & {
  __typename?: 'PageEdge';
  /** The cursor that identifies this page */
  cursor: Scalars['String']['output'];
  /** The page */
  node: Page;
};

/** Metadata for pagination */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the last element on the page */
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor of the first element on the page */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationArtifactAttribute = Attribute & Node & {
  __typename?: 'PaginationArtifactAttribute';
  id: Scalars['ID']['output'];
  originalAttribute?: Maybe<PaginationArtifactAttribute>;
  region: Region;
  type: PaginationArtifactType;
};

export enum PaginationArtifactType {
  BatesNumber = 'BATES_NUMBER',
  Footer = 'FOOTER',
  Header = 'HEADER',
  LineNumber = 'LINE_NUMBER',
  PageNumber = 'PAGE_NUMBER',
  RedactionIndicator = 'REDACTION_INDICATOR',
  Watermark = 'WATERMARK'
}

/** Base return type for all mutations. Contains a list of errors that is only present if any errors occurred */
export type Payload = {
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Possible permissions a user can have on a document, its pages and its attributes and artifacts */
export enum Permission {
  Admin = 'ADMIN',
  None = 'NONE',
  Read = 'READ',
  Write = 'WRITE'
}

/** Represents an arbitrary shape without holes that can be described only through its corners */
export type Polygon = {
  __typename?: 'Polygon';
  /** The axis aligned bounding box of the polygon */
  aabb: Aabb;
  /** The list of corners that make up the polygon (clockwise) */
  vertices: Array<Vertex>;
};

export type Query = {
  __typename?: 'Query';
  /** Access metadata of the currently deployed backend version. */
  deployment: Deployment;
  /**
   * Fetch a single node by its ID
   * returns null if the node does not exist
   */
  node?: Maybe<Node>;
  /**
   * Fetch multiple nodes by their IDs
   * Spaces for invalid ids will be filled with a null value
   */
  nodes: Array<Maybe<Node>>;
  /** Entry point for accessing all the data available to the currently logged in user */
  viewer: User;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

/** A region on a page that contains a list of attributes */
export type Region = Node & {
  __typename?: 'Region';
  /** The list of attributes of the region */
  attributes: Array<Attribute>;
  document: Document;
  id: Scalars['ID']['output'];
  /** Whether the region was not originally created by a user */
  isGenerated: Scalars['Boolean']['output'];
  issues: Array<Issue>;
  /** Link a region with remaining content belonging to this region in case of a pagebreak or columnbreak or similar */
  nextRegion?: Maybe<Region>;
  /** The original list of attributes and their values without any user made changes */
  originalAttributes?: Maybe<Array<Attribute>>;
  /** The next region with remaining content belonging to this region as specified by our algorithms (if one was originally linked */
  originalNextRegion?: Maybe<Region>;
  originalReadingOrderIndex: Scalars['NonNegativeInt']['output'];
  /** The original shape of the region, without any user made changes */
  originalShape?: Maybe<Polygon>;
  page: Page;
  /** The index in the reading order of the parent region or page */
  readingOrderIndex: Scalars['NonNegativeInt']['output'];
  /** The shape of the region */
  shape: Polygon;
};

export type RegionConnection = Connection & {
  __typename?: 'RegionConnection';
  edges: Array<RegionEdge>;
  pageInfo: PageInfo;
  regions: Array<Region>;
  total: Scalars['NonNegativeInt']['output'];
};

export type RegionEdge = Edge & {
  __typename?: 'RegionEdge';
  cursor: Scalars['String']['output'];
  node: Region;
};

/** Input type for region subscriptions */
export type RegionSubscriptionInput = {
  /** Only events of regions on the given page will be listened to */
  pageId: Scalars['ID']['input'];
};

export type RemoveAuthorInput = {
  authorId: Scalars['ID']['input'];
};

export type RemoveAuthorPayload = Payload & {
  __typename?: 'RemoveAuthorPayload';
  author?: Maybe<MetadataAuthor>;
  userErrors?: Maybe<Array<UserError>>;
};

export type RemoveDocumentTagInput = {
  documentId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};

export type RemoveDocumentTagPayload = Payload & {
  __typename?: 'RemoveDocumentTagPayload';
  document?: Maybe<Document>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type RemoveSubjectInput = {
  subjectId: Scalars['ID']['input'];
};

export type RemoveSubjectPayload = Payload & {
  __typename?: 'RemoveSubjectPayload';
  subject?: Maybe<MetadataSubject>;
  userErrors?: Maybe<Array<UserError>>;
};

export type RemoveTableGroupInput = {
  tableGroupId: Scalars['ID']['input'];
};

export type RemoveTableGroupPayload = Payload & {
  __typename?: 'RemoveTableGroupPayload';
  tableGroup?: Maybe<TableGroup>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type RemoveTitleInput = {
  titleId: Scalars['ID']['input'];
};

export type RemoveTitlePayload = Payload & {
  __typename?: 'RemoveTitlePayload';
  title?: Maybe<MetadataTitle>;
  userErrors?: Maybe<Array<UserError>>;
};

export type RenameAuthorNameInput = {
  authorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type RenameAuthorPayload = Payload & {
  __typename?: 'RenameAuthorPayload';
  author?: Maybe<MetadataAuthor>;
  userErrors?: Maybe<Array<UserError>>;
};

export type RenameDocumentInput = {
  documentId: Scalars['ID']['input'];
  /** The new name of the document, may not be empty or blank */
  name: Scalars['String']['input'];
};

export type RenameDocumentPayload = Payload & {
  __typename?: 'RenameDocumentPayload';
  /** The updated document if no errors occured */
  document?: Maybe<Document>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type RenameTableGroupInput = {
  name: Scalars['String']['input'];
  tableGroupId: Scalars['ID']['input'];
};

export type RenameTableGroupPayload = Payload & {
  __typename?: 'RenameTableGroupPayload';
  tableGroup?: Maybe<TableGroup>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type RenameTitleInput = {
  title: Scalars['String']['input'];
  titleId: Scalars['ID']['input'];
};

export type RenameTitlePayload = Payload & {
  __typename?: 'RenameTitlePayload';
  title?: Maybe<MetadataTitle>;
  userErrors?: Maybe<Array<UserError>>;
};

export type SetDateInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  documentId: Scalars['ID']['input'];
};

export type SetDatePayload = Payload & {
  __typename?: 'SetDatePayload';
  metadata?: Maybe<Metadata>;
  userErrors?: Maybe<Array<UserError>>;
};

export type SetLanguageInput = {
  documentId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
};

export type SetLanguagePayload = Payload & {
  __typename?: 'SetLanguagePayload';
  metadata?: Maybe<Metadata>;
  userErrors?: Maybe<Array<UserError>>;
};

export type SetTableAttributeTableGroupInput = {
  attributeId: Scalars['ID']['input'];
  tableGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetTableAttributeTableGroupPayload = Payload & {
  __typename?: 'SetTableAttributeTableGroupPayload';
  attribute?: Maybe<TableAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type StartPageSegmentationInput = {
  pageIds: Array<Scalars['ID']['input']>;
};

export type StartPageSegmentationPayload = Payload & {
  __typename?: 'StartPageSegmentationPayload';
  /** The pages for which the segmenation was started */
  pages?: Maybe<Array<Page>>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Receive notifications any time an attribute is created successfully on a given region */
  attributeCreated: Attribute;
  /** Receive notifications any time an attribute is deleted successfully on a given region */
  attributeDeleted: Attribute;
  /** Receive notifications any time an attribute is updated successfully on a given region */
  attributeUpdated: Attribute;
  /** Receive notifications any time a region is created successfully on a given page */
  regionCreated: Region;
  /** Receive notifications any time a region is deleted successfully on a given page */
  regionDeleted: Region;
  /** Receive notifications any time a region is updated successfully on a given page */
  regionUpdated: Region;
};


export type SubscriptionAttributeCreatedArgs = {
  input: AttributeSubscriptionInput;
};


export type SubscriptionAttributeDeletedArgs = {
  input: AttributeSubscriptionInput;
};


export type SubscriptionAttributeUpdatedArgs = {
  input: AttributeSubscriptionInput;
};


export type SubscriptionRegionCreatedArgs = {
  input: RegionSubscriptionInput;
};


export type SubscriptionRegionDeletedArgs = {
  input: RegionSubscriptionInput;
};


export type SubscriptionRegionUpdatedArgs = {
  input: RegionSubscriptionInput;
};

/** An Attribute that marks the region as a table */
export type TableAttribute = Attribute & Node & {
  __typename?: 'TableAttribute';
  /** The width of the columns of the table */
  columns: Array<Scalars['NonNegativeFloat']['output']>;
  id: Scalars['ID']['output'];
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<TableAttribute>;
  /** Column offset into imaginary parent table */
  parentColumnOffset: Scalars['NonNegativeInt']['output'];
  /** Row offset into imaginary parent table */
  parentRowOffset: Scalars['NonNegativeInt']['output'];
  /** Optional conceptual parent table this table is a part of */
  parentTable?: Maybe<TableGroup>;
  region: Region;
  /** The height of the columns of the table */
  rows: Array<Scalars['NonNegativeFloat']['output']>;
};

/** An Attribute that marks the region as a table cell */
export type TableCellAttribute = Attribute & Node & {
  __typename?: 'TableCellAttribute';
  columnSpan: Scalars['PositiveInt']['output'];
  id: Scalars['ID']['output'];
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<TableCellAttribute>;
  region: Region;
  rowSpan: Scalars['PositiveInt']['output'];
};

/** Groups tables throughout a document that belong to the same conceptual parent table */
export type TableGroup = Node & {
  __typename?: 'TableGroup';
  /** A description for the group that may be used by exporters when exporting an artifact */
  description: Scalars['String']['output'];
  document: Document;
  id: Scalars['ID']['output'];
  /** A name for the group that can be shown to the user (and set by the user) */
  name: Scalars['String']['output'];
  /** The tables currently assigned to this group */
  tables: Array<TableAttribute>;
};

export type TableGroupConnection = Connection & {
  __typename?: 'TableGroupConnection';
  edges: Array<TableGroupEdge>;
  /** Metadata for the current Page */
  pageInfo: PageInfo;
  tableGroups: Array<TableGroup>;
  total: Scalars['NonNegativeInt']['output'];
};

export type TableGroupEdge = Edge & {
  __typename?: 'TableGroupEdge';
  cursor: Scalars['String']['output'];
  node: TableGroup;
};

/** Marks the region as a header cell (TODO: add attribute for scope of the header) */
export type TableHeaderCellAttribute = Attribute & Node & {
  __typename?: 'TableHeaderCellAttribute';
  id: Scalars['ID']['output'];
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<TableHeaderCellAttribute>;
  region: Region;
  scopes: Array<TableHeaderCellScope>;
};

export type TableHeaderCellScope = {
  __typename?: 'TableHeaderCellScope';
  /** Whether the scope applies to cells in its parent region only or could affect all cells in the imaginary parent table */
  isLocal: Scalars['Boolean']['output'];
  /** Optional linked cell region id (only for cell scope) */
  link?: Maybe<Scalars['ID']['output']>;
  /** How the scope selects the affected cells */
  type: TableHeaderCellScopeType;
};

export type TableHeaderCellScopeInput = {
  isLocal: Scalars['Boolean']['input'];
  link?: InputMaybe<Scalars['ID']['input']>;
  type: TableHeaderCellScopeType;
};

export enum TableHeaderCellScopeType {
  /** A specific linked cell (linked with ID of the region with the TableCell attribute) */
  Cell = 'CELL',
  /** Other cells on the same column */
  Column = 'COLUMN',
  /** Cells on the same column above the header cell */
  ColumnAbove = 'COLUMN_ABOVE',
  /** Cells on the same column below the header cell */
  ColumnBelow = 'COLUMN_BELOW',
  /** All other cells in the same row */
  Row = 'ROW',
  /** Cells on the same row after the header cell */
  RowAfter = 'ROW_AFTER',
  /** Cells on the same row before the header cell */
  RowBefore = 'ROW_BEFORE'
}

export type TableOfContentsAttribute = Attribute & Node & {
  __typename?: 'TableOfContentsAttribute';
  id: Scalars['ID']['output'];
  originalAttribute?: Maybe<TableOfContentsAttribute>;
  region: Region;
};

export type TableOfContentsHeadingAttribute = Attribute & Node & {
  __typename?: 'TableOfContentsHeadingAttribute';
  id: Scalars['ID']['output'];
  originalAttribute?: Maybe<TableOfContentsHeadingAttribute>;
  region: Region;
};

export type TableOfContentsItemAttribute = Attribute & Node & {
  __typename?: 'TableOfContentsItemAttribute';
  id: Scalars['ID']['output'];
  linkedRegion?: Maybe<Region>;
  originalAttribute?: Maybe<TableOfContentsItemAttribute>;
  region: Region;
};

/** Marks content as a page number in a table of contents item */
export type TableOfContentsPageNumberAttribute = Attribute & Node & {
  __typename?: 'TableOfContentsPageNumberAttribute';
  id: Scalars['ID']['output'];
  originalAttribute?: Maybe<TableOfContentsPageNumberAttribute>;
  region: Region;
};

export type Task = Node & {
  __typename?: 'Task';
  associatedId: Node;
  finished: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  parent?: Maybe<Task>;
  progress: Scalars['Percent']['output'];
  successful: Scalars['Boolean']['output'];
  type: TaskType;
};

export type TaskMessage = Node & {
  __typename?: 'TaskMessage';
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pageId: Page;
  severity: TaskMessageSeverity;
  taskId: Task;
  text: Scalars['String']['output'];
};

export enum TaskMessageSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum TaskType {
  /** A task that is used to export a document */
  Export = 'EXPORT',
  /** A task that is used to import a document */
  Import = 'IMPORT',
  /** A task that is used to segment a page */
  Segmentation = 'SEGMENTATION'
}

/** An Attribute that represents a piece of text */
export type TextAttribute = Attribute & Node & {
  __typename?: 'TextAttribute';
  id: Scalars['ID']['output'];
  /** The attribute as it was filled by the auto-fill services */
  originalAttribute?: Maybe<TextAttribute>;
  region: Region;
  text: Scalars['String']['output'];
};

/** Input type for updating an alternative text attribute */
export type UpdateAlternativeTextAttributeInput = {
  alternativeText: Scalars['String']['input'];
  /** The id of the attribute to update */
  attributeId: Scalars['ID']['input'];
};

/** Payload returned when updating an alternative text attribute */
export type UpdateAlternativeTextAttributePayload = Payload & {
  __typename?: 'UpdateAlternativeTextAttributePayload';
  /** The updated alternative text attribute if no errors occured */
  attribute?: Maybe<AlternativeTextAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for updating a caption attribute */
export type UpdateCaptionAttributeInput = {
  attributeId: Scalars['ID']['input'];
  linkedRegionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Payload returned when updating a caption attribute */
export type UpdateCaptionAttributePayload = Payload & {
  __typename?: 'UpdateCaptionAttributePayload';
  /** The updated caption attribute if no errors occured */
  attribute?: Maybe<CaptionAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type UpdateDocumentPermissionInput = {
  documentId: Scalars['ID']['input'];
  permission: Permission;
  userId: Scalars['ID']['input'];
};

export type UpdateDocumentPermissionPayload = Payload & {
  __typename?: 'UpdateDocumentPermissionPayload';
  membership?: Maybe<Membership>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for updating an expression attribute */
export type UpdateExpressionAttributeInput = {
  /** The id of the attribute to update */
  attributeId: Scalars['ID']['input'];
  /** The latex code that produces the expression marked by the region */
  expressionLatex: Scalars['String']['input'];
};

/** Payload returned when updating an expression attribute */
export type UpdateExpressionAttributePayload = Payload & {
  __typename?: 'UpdateExpressionAttributePayload';
  /** The updated expression attribute if no errors occurred */
  attribute?: Maybe<ExpressionAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for updating a header level attribute */
export type UpdateHeaderLevelAttributeInput = {
  /** The id of the attribute to update */
  attributeId: Scalars['ID']['input'];
  level: Scalars['PositiveInt']['input'];
};

/** Payload returned when updating a header level attribute */
export type UpdateHeaderLevelAttributePayload = Payload & {
  __typename?: 'UpdateHeaderLevelAttributePayload';
  /** The updated header level attribute if no errors occurred */
  attribute?: Maybe<HeaderLevelAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type UpdateListAttributeInput = {
  attributeId: Scalars['ID']['input'];
  listType: ListType;
};

export type UpdateListAttributePayload = Payload & {
  __typename?: 'UpdateListAttributePayload';
  attribute?: Maybe<ListAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type UpdateListItemAttributeInput = {
  attributeId: Scalars['ID']['input'];
  ordinal: Scalars['NonNegativeInt']['input'];
};

export type UpdateListItemAttributePayload = Payload & {
  __typename?: 'UpdateListItemAttributePayload';
  attribute?: Maybe<ListItemAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type UpdatePaginationArtifactAttributeInput = {
  attributeId: Scalars['ID']['input'];
  type: PaginationArtifactType;
};

export type UpdatePaginationArtifactAttributePayload = Payload & {
  __typename?: 'UpdatePaginationArtifactAttributePayload';
  attribute?: Maybe<PaginationArtifactAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input for updating a regions nextRegion field */
export type UpdateRegionNextRegionInput = {
  /** The next region to link. Null is a valid value here and will be saved to the database. */
  nextRegionId?: InputMaybe<Scalars['ID']['input']>;
  /** The region to set the field on */
  regionId: Scalars['ID']['input'];
};

/** Payload returned when setting a regions nextRegion field. */
export type UpdateRegionNextRegionPayload = Payload & {
  __typename?: 'UpdateRegionNextRegionPayload';
  region?: Maybe<Region>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type UpdateRegionReadingOrderIndexInput = {
  readingOrderIndex: Scalars['NonNegativeInt']['input'];
  regionId: Scalars['ID']['input'];
};

export type UpdateRegionReadingOrderIndexPayload = Payload & {
  __typename?: 'UpdateRegionReadingOrderIndexPayload';
  region?: Maybe<Region>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for updating a region */
export type UpdateRegionShapeInput = {
  /** The id of the region to update */
  regionId: Scalars['ID']['input'];
  /** The new shape of the polygon */
  shape: InputPolygon;
};

/** Payload returned when updating a region */
export type UpdateRegionShapePayload = Payload & {
  __typename?: 'UpdateRegionShapePayload';
  region?: Maybe<Region>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for updating a table attribute */
export type UpdateTableAttributeInput = {
  /** The id of the attribute to update */
  attributeId: Scalars['ID']['input'];
  /** The width of the columns of the table */
  columns?: InputMaybe<Array<Scalars['NonNegativeFloat']['input']>>;
  /** Column offset into imaginary parent table */
  parentColumnOffset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  /** Row offset into imaginary parent table */
  parentRowOffset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  /** The height of the columns of the table */
  rows?: InputMaybe<Array<Scalars['NonNegativeFloat']['input']>>;
};

/** Payload returned when updating a table attribute */
export type UpdateTableAttributePayload = Payload & {
  __typename?: 'UpdateTableAttributePayload';
  /** The updated table attribute if no errors occured */
  attribute?: Maybe<TableAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for updating a table cell attribute */
export type UpdateTableCellAttributeInput = {
  /** The id of the attribute to update */
  attributeId: Scalars['ID']['input'];
  columnSpan?: InputMaybe<Scalars['PositiveInt']['input']>;
  rowSpan?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/** Payload returned when updating a table cell attribute */
export type UpdateTableCellAttributePayload = Payload & {
  __typename?: 'UpdateTableCellAttributePayload';
  /** The updated table cell attribute if no errors occured */
  attribute?: Maybe<TableCellAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type UpdateTableHeaderCellAttributeInput = {
  attributeId: Scalars['ID']['input'];
  scopes: Array<TableHeaderCellScopeInput>;
};

export type UpdateTableHeaderCellAttributePayload = Payload & {
  __typename?: 'UpdateTableHeaderCellAttributePayload';
  attribute?: Maybe<TableHeaderCellAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type UpdateTableOfContentsItemAttributeInput = {
  attributeId: Scalars['ID']['input'];
  linkedRegionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTableOfContentsItemAttributePayload = Payload & {
  __typename?: 'UpdateTableOfContentsItemAttributePayload';
  attribute?: Maybe<TableOfContentsItemAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

/** Input type for updating a text attribute */
export type UpdateTextAttributeInput = {
  attributeId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

/** Payload returned when updating a text attribute */
export type UpdateTextAttributePayload = Payload & {
  __typename?: 'UpdateTextAttributePayload';
  /** The updated text attribute if no errors occured */
  attribute?: Maybe<TextAttribute>;
  /** The list of errors that occurred during the mutation if any */
  userErrors?: Maybe<Array<UserError>>;
};

export type User = Node & {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Other users visible to the logged in user */
  colleagues: UserConnection;
  id: Scalars['ID']['output'];
  /** All documents visible to the logged in user */
  memberships: MembershipConnection;
  username: Scalars['String']['output'];
};


export type UserColleaguesArgs = {
  constraint?: InputMaybe<Array<UserConstraint>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  next?: InputMaybe<Scalars['PositiveInt']['input']>;
  previous?: InputMaybe<Scalars['PositiveInt']['input']>;
  sort?: InputMaybe<Array<UserSort>>;
};


export type UserMembershipsArgs = {
  constraints?: InputMaybe<Array<DocumentConstraint>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  next?: InputMaybe<Scalars['PositiveInt']['input']>;
  previous?: InputMaybe<Scalars['PositiveInt']['input']>;
  sort?: InputMaybe<Array<DocumentSort>>;
};

export type UserConnection = Connection & {
  __typename?: 'UserConnection';
  /** A list of edges */
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  total: Scalars['NonNegativeInt']['output'];
  /** The list of users */
  users: Array<User>;
};

/** Specifies a criteria to filter users by */
export type UserConstraint = {
  /** The category by which to filter the user */
  category: UserConstraintCategory;
  /** Whether to include users that match the criteria */
  include: Scalars['Boolean']['input'];
  /** A value given to the filter category */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Different ways to filter users */
export enum UserConstraintCategory {
  /** "Fuzzily" filter users by matching the given value string with the nickname */
  Nickname = 'NICKNAME'
}

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

/** Data of an error that occurred during a mutation */
export type UserError = {
  /** The type of error that occurred */
  code: UserErrorCode;
  /** The path of the field in the input that caused the error */
  path: Scalars['String']['output'];
};

/** All errors that exist */
export enum UserErrorCode {
  /** Occurs if the user tries to delete an attribute that is itself an "original" attribute */
  AttributeIsOriginalError = 'ATTRIBUTE_IS_ORIGINAL_ERROR',
  /** Occurs when a string is null, blank or empty */
  BlankStringError = 'BLANK_STRING_ERROR',
  /** Occurs if a caption attribute is set to caption the region it itself is being created on or exists on */
  CaptionedRegionIsSelfError = 'CAPTIONED_REGION_IS_SELF_ERROR',
  /** Occurs if the clearDate flag is explicitly set to false (it should be omitted instead) */
  ClearDateExplicitFalseError = 'CLEAR_DATE_EXPLICIT_FALSE_ERROR',
  /** Occurs if a table header cell scope of type CELL is marked as local */
  HeaderCellScopeIsLocalOnCellError = 'HEADER_CELL_SCOPE_IS_LOCAL_ON_CELL_ERROR',
  /** Occurs if a table header cell scope is not of type CELL but has the link field set */
  HeaderCellScopeLinkNotNullError = 'HEADER_CELL_SCOPE_LINK_NOT_NULL_ERROR',
  /** Occurs if a table header cell scope is of type CELL but has the link field not set */
  HeaderCellScopeLinkNullError = 'HEADER_CELL_SCOPE_LINK_NULL_ERROR',
  /** Occurs if a table header cell scope of type CELL references the region the attribute itself is on */
  HeaderCellScopeReferencesSelfError = 'HEADER_CELL_SCOPE_REFERENCES_SELF_ERROR',
  /** Occurs when the logged in user does not have the required permissions to make the query/mutation */
  InsufficientPermissionError = 'INSUFFICIENT_PERMISSION_ERROR',
  /** Occurs when a provided language is not a valid IETF BCP 47 code. */
  InvalidLanguageCode = 'INVALID_LANGUAGE_CODE',
  /** Occurs if a table of contents item attribute references the region it is on as the linked region */
  LinkedRegionIsSelfError = 'LINKED_REGION_IS_SELF_ERROR',
  /** Occurs if a next region to be set is already referenced by a different region as its next region */
  NextRegionAlreadyReferencedError = 'NEXT_REGION_ALREADY_REFERENCED_ERROR',
  /** Occurs if a next region to be set would cause a cycle */
  NextRegionIsCycleError = 'NEXT_REGION_IS_CYCLE_ERROR',
  /** Occurs if a next region to be set is the region is itself */
  NextRegionIsSelfError = 'NEXT_REGION_IS_SELF_ERROR',
  /** Occurs when a referenced element does not exist or is not the correct type */
  NoSuchElementError = 'NO_SUCH_ELEMENT_ERROR',
  /** The boundary path of the given polygon is not counter clockwise */
  PolygonNotCounterClockwiseError = 'POLYGON_NOT_COUNTER_CLOCKWISE_ERROR',
  /** The provided polygon has self-intersections not at vertices */
  PolygonNotSimpleError = 'POLYGON_NOT_SIMPLE_ERROR',
  /** Occurs when an InputPolygon has less than three vertices */
  PolygonTooFewVerticesError = 'POLYGON_TOO_FEW_VERTICES_ERROR',
  /** Occurs if a user tries to adjust their own permission using updateDocumentPermission */
  SettingOwnPermissionError = 'SETTING_OWN_PERMISSION_ERROR',
  /** Occurs if the clearDate flag and a date field is set (cannot clear and write date at the same time) */
  SimultaneousClearDateAndDateError = 'SIMULTANEOUS_CLEAR_DATE_AND_DATE_ERROR',
  /** Occurs if a table attributes columns array sums to greater than one (with a little tolerance because floats) */
  TableColumnsSumGreaterOneError = 'TABLE_COLUMNS_SUM_GREATER_ONE_ERROR',
  /** Occurs if a table attributes columns array sums to less than one (with a little tolerance because floats) */
  TableColumnsSumLessOneError = 'TABLE_COLUMNS_SUM_LESS_ONE_ERROR',
  /** Occurs if a table attributes rows array sums to greater than one (with a little tolerance because floats) */
  TableRowsSumGreaterOneError = 'TABLE_ROWS_SUM_GREATER_ONE_ERROR',
  /** Occurs if a table attributes rows array sums to less than one (with a little tolerance because floats) */
  TableRowsSumLessOneError = 'TABLE_ROWS_SUM_LESS_ONE_ERROR',
  /** An error occurred that is not further specified */
  UnknownError = 'UNKNOWN_ERROR'
}

/** Specifies a sort criteria for users */
export type UserSort = {
  /** Whether to sort ascending or not */
  ascending: Scalars['Boolean']['input'];
  /** The category to sort users by */
  category: UserSortCategory;
};

/** Different ways to sort users */
export enum UserSortCategory {
  /** Sort users alphabetically by nickname */
  Nickname = 'NICKNAME'
}

/** A corner point of a polygon. Coordinates are relative to page width and height */
export type Vertex = {
  __typename?: 'Vertex';
  left: Scalars['Percent']['output'];
  top: Scalars['Percent']['output'];
};

type AttributeDeleteButton_AlternativeTextAttribute_Fragment = { __typename?: 'AlternativeTextAttribute', id: string };

type AttributeDeleteButton_CaptionAttribute_Fragment = { __typename?: 'CaptionAttribute', id: string };

type AttributeDeleteButton_ExcludeReadingOrderAttribute_Fragment = { __typename?: 'ExcludeReadingOrderAttribute', id: string };

type AttributeDeleteButton_ExpressionAttribute_Fragment = { __typename?: 'ExpressionAttribute', id: string };

type AttributeDeleteButton_FigureAttribute_Fragment = { __typename?: 'FigureAttribute', id: string };

type AttributeDeleteButton_FootnoteAttribute_Fragment = { __typename?: 'FootnoteAttribute', id: string };

type AttributeDeleteButton_HeaderLevelAttribute_Fragment = { __typename?: 'HeaderLevelAttribute', id: string };

type AttributeDeleteButton_ImageAttribute_Fragment = { __typename?: 'ImageAttribute', id: string };

type AttributeDeleteButton_ListAttribute_Fragment = { __typename?: 'ListAttribute', id: string };

type AttributeDeleteButton_ListItemAttribute_Fragment = { __typename?: 'ListItemAttribute', id: string };

type AttributeDeleteButton_ListItemLabelAttribute_Fragment = { __typename?: 'ListItemLabelAttribute', id: string };

type AttributeDeleteButton_PaginationArtifactAttribute_Fragment = { __typename?: 'PaginationArtifactAttribute', id: string };

type AttributeDeleteButton_TableAttribute_Fragment = { __typename?: 'TableAttribute', id: string };

type AttributeDeleteButton_TableCellAttribute_Fragment = { __typename?: 'TableCellAttribute', id: string };

type AttributeDeleteButton_TableHeaderCellAttribute_Fragment = { __typename?: 'TableHeaderCellAttribute', id: string };

type AttributeDeleteButton_TableOfContentsAttribute_Fragment = { __typename?: 'TableOfContentsAttribute', id: string };

type AttributeDeleteButton_TableOfContentsHeadingAttribute_Fragment = { __typename?: 'TableOfContentsHeadingAttribute', id: string };

type AttributeDeleteButton_TableOfContentsItemAttribute_Fragment = { __typename?: 'TableOfContentsItemAttribute', id: string };

type AttributeDeleteButton_TableOfContentsPageNumberAttribute_Fragment = { __typename?: 'TableOfContentsPageNumberAttribute', id: string };

type AttributeDeleteButton_TextAttribute_Fragment = { __typename?: 'TextAttribute', id: string };

export type AttributeDeleteButtonFragment = AttributeDeleteButton_AlternativeTextAttribute_Fragment | AttributeDeleteButton_CaptionAttribute_Fragment | AttributeDeleteButton_ExcludeReadingOrderAttribute_Fragment | AttributeDeleteButton_ExpressionAttribute_Fragment | AttributeDeleteButton_FigureAttribute_Fragment | AttributeDeleteButton_FootnoteAttribute_Fragment | AttributeDeleteButton_HeaderLevelAttribute_Fragment | AttributeDeleteButton_ImageAttribute_Fragment | AttributeDeleteButton_ListAttribute_Fragment | AttributeDeleteButton_ListItemAttribute_Fragment | AttributeDeleteButton_ListItemLabelAttribute_Fragment | AttributeDeleteButton_PaginationArtifactAttribute_Fragment | AttributeDeleteButton_TableAttribute_Fragment | AttributeDeleteButton_TableCellAttribute_Fragment | AttributeDeleteButton_TableHeaderCellAttribute_Fragment | AttributeDeleteButton_TableOfContentsAttribute_Fragment | AttributeDeleteButton_TableOfContentsHeadingAttribute_Fragment | AttributeDeleteButton_TableOfContentsItemAttribute_Fragment | AttributeDeleteButton_TableOfContentsPageNumberAttribute_Fragment | AttributeDeleteButton_TextAttribute_Fragment;

export type DeleteAttributeMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteAttributeMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type AlternativeTextCreationPanelFragment = { __typename?: 'Region', id: string, document: { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', language: string, document: { __typename?: 'Document', id: string } } }, page: { __typename?: 'Page', id: string, pngUrl?: string | null }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } };

export type CreateAlternativeTextFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  alternativeText: Scalars['String']['input'];
}>;


export type CreateAlternativeTextFromPanelMutation = { __typename?: 'Mutation', createAlternativeTextAttribute: { __typename?: 'CreateAlternativeTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type AlternativeTextFormFieldFragment = { __typename?: 'Region', id: string, document: { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', language: string, document: { __typename?: 'Document', id: string } } }, page: { __typename?: 'Page', id: string, pngUrl?: string | null }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } };

export type AlternativeTextPredictionButtonFragment = { __typename?: 'Region', id: string, document: { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', language: string, document: { __typename?: 'Document', id: string } } }, page: { __typename?: 'Page', id: string, pngUrl?: string | null }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } };

export type AlternativeTextUpdatePanelFragment = { __typename?: 'AlternativeTextAttribute', id: string, alternativeText: string, region: { __typename?: 'Region', id: string, document: { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', language: string, document: { __typename?: 'Document', id: string } } }, page: { __typename?: 'Page', id: string, pngUrl?: string | null }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } };

export type DeleteAlternativeTextFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteAlternativeTextFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type UpdateAlternativeTextFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  alternativeText: Scalars['String']['input'];
}>;


export type UpdateAlternativeTextFromPanelMutation = { __typename?: 'Mutation', updateAlternativeTextAttribute: { __typename?: 'UpdateAlternativeTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string, alternativeText: string } | null } };

export type CaptionCreationPanelFragment = { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } } };

export type CreateCaptionFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  linkedRegionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateCaptionFromPanelMutation = { __typename?: 'Mutation', createCaptionAttribute: { __typename?: 'CreateCaptionAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'CaptionAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null } | null } };

export type CaptionFormFieldFragment = { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } } };

export type CaptionUpdatePanelFragment = { __typename?: 'CaptionAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } } } };

export type DeleteCaptionFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteCaptionFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type UpdateCaptionFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  linkedRegionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateCaptionFromPanelMutation = { __typename?: 'Mutation', updateCaptionAttribute: { __typename?: 'UpdateCaptionAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'CaptionAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null } | null } };

export type ExcludeReadingOrderCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateExcludeReadingOrderFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type CreateExcludeReadingOrderFromPanelMutation = { __typename?: 'Mutation', createExcludeReadingOrderAttribute: { __typename?: 'CreateExcludeReadingOrderAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ExcludeReadingOrderAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type ExcludeReadingOrderUpdatePanelFragment = { __typename?: 'ExcludeReadingOrderAttribute', id: string };

export type DeleteExcludeReadingOrderFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteExcludeReadingOrderFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type ExpressionCreationPanelFragment = { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, pngUrl?: string | null } };

export type CreateExpressionFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  expressionLatex: Scalars['String']['input'];
}>;


export type CreateExpressionFromPanelMutation = { __typename?: 'Mutation', createExpressionAttribute: { __typename?: 'CreateExpressionAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ExpressionAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type ExpressionFormFieldFragment = { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } };

export type ExpressionPredictionButtonFragment = { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } };

export type ExpressionReferenceFormFieldFragment = { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } };

export type ExpressionUpdatePanelFragment = { __typename?: 'ExpressionAttribute', id: string, expressionLatex: string, region: { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, pngUrl?: string | null } } };

export type DeleteExpressionFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteExpressionFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type UpdateExpressionFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  expressionLatex: Scalars['String']['input'];
}>;


export type UpdateExpressionFromPanelMutation = { __typename?: 'Mutation', updateExpressionAttribute: { __typename?: 'UpdateExpressionAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ExpressionAttribute', id: string, expressionLatex: string } | null } };

export type FigureCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateFigureFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type CreateFigureFromPanelMutation = { __typename?: 'Mutation', createFigureAttribute: { __typename?: 'CreateFigureAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'FigureAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type FigureUpdatePanelFragment = { __typename?: 'FigureAttribute', id: string };

export type DeleteFigureFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteFigureFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type HeadingLevelCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateHeadingLevelFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  level: Scalars['PositiveInt']['input'];
}>;


export type CreateHeadingLevelFromPanelMutation = { __typename?: 'Mutation', createHeaderLevelAttribute: { __typename?: 'CreateHeaderLevelAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'HeaderLevelAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type HeadingLevelUpdatePanelFragment = { __typename?: 'HeaderLevelAttribute', id: string, level: number };

export type DeleteHeadingLevelFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteHeadingLevelFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type UpdateHeadingLevelFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  level: Scalars['PositiveInt']['input'];
}>;


export type UpdateHeadingLevelFromPanelMutation = { __typename?: 'Mutation', updateHeaderLevelAttribute: { __typename?: 'UpdateHeaderLevelAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'HeaderLevelAttribute', id: string, level: number } | null } };

export type ImageCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateImageFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type CreateImageFromPanelMutation = { __typename?: 'Mutation', createImageAttribute: { __typename?: 'CreateImageAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ImageAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type ImageUpdatePanelFragment = { __typename?: 'ImageAttribute', id: string };

export type DeleteImageFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteImageFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type ListItemLabelCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateListItemLabelFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type CreateListItemLabelFromPanelMutation = { __typename?: 'Mutation', createListItemLabelAttribute: { __typename?: 'CreateListItemLabelAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListItemLabelAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type ListItemLabelUpdatePanelFragment = { __typename?: 'ListItemLabelAttribute', id: string };

export type DeleteListItemLabelFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteListItemLabelFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type ListItemCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateListItemFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  ordinal: Scalars['NonNegativeInt']['input'];
}>;


export type CreateListItemFromPanelMutation = { __typename?: 'Mutation', createListItemAttribute: { __typename?: 'CreateListItemAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListItemAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type ListItemUpdatePanelFragment = { __typename?: 'ListItemAttribute', id: string, ordinal: number };

export type DeleteListItemFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteListItemFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type UpdateListItemFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  ordinal: Scalars['NonNegativeInt']['input'];
}>;


export type UpdateListItemFromPanelMutation = { __typename?: 'Mutation', updateListItemAttribute: { __typename?: 'UpdateListItemAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListItemAttribute', id: string, ordinal: number } | null } };

export type ListCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateListFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  listType: ListType;
}>;


export type CreateListFromPanelMutation = { __typename?: 'Mutation', createListAttribute: { __typename?: 'CreateListAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type ListUpdatePanelFragment = { __typename?: 'ListAttribute', id: string, listType: ListType };

export type DeleteListFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteListFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type UpdateListFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  listType: ListType;
}>;


export type UpdateListFromPanelMutation = { __typename?: 'Mutation', updateListAttribute: { __typename?: 'UpdateListAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListAttribute', id: string, listType: ListType } | null } };

export type PaginationArtifactCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreatePaginationArtifactFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  type: PaginationArtifactType;
}>;


export type CreatePaginationArtifactFromPanelMutation = { __typename?: 'Mutation', createPaginationArtifactAttribute: { __typename?: 'CreatePaginationArtifactAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'PaginationArtifactAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type PaginationArtifactUpdatePanelFragment = { __typename?: 'PaginationArtifactAttribute', id: string, type: PaginationArtifactType };

export type DeletePaginationArtifactFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeletePaginationArtifactFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type UpdatePaginationArtifactFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  type: PaginationArtifactType;
}>;


export type UpdatePaginationArtifactFromPanelMutation = { __typename?: 'Mutation', updatePaginationArtifactAttribute: { __typename?: 'UpdatePaginationArtifactAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'PaginationArtifactAttribute', id: string, type: PaginationArtifactType } | null } };

export type TableCellCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateTableCellFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  columnSpan: Scalars['PositiveInt']['input'];
  rowSpan: Scalars['PositiveInt']['input'];
}>;


export type CreateTableCellFromPanelMutation = { __typename?: 'Mutation', createTableCellAttribute: { __typename?: 'CreateTableCellAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableCellAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type TableCellUpdatePanelFragment = { __typename?: 'TableCellAttribute', id: string, rowSpan: number, columnSpan: number };

export type DeleteTableCellFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteTableCellFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type UpdateTableCellFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  rowSpan: Scalars['PositiveInt']['input'];
  columnSpan: Scalars['PositiveInt']['input'];
}>;


export type UpdateTableCellFromPanelMutation = { __typename?: 'Mutation', updateTableCellAttribute: { __typename?: 'UpdateTableCellAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableCellAttribute', id: string, rowSpan: number, columnSpan: number } | null } };

export type TableHeaderCellCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateTableHeaderCellFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type CreateTableHeaderCellFromPanelMutation = { __typename?: 'Mutation', createTableHeaderCellAttribute: { __typename?: 'CreateTableHeaderCellAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableHeaderCellAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type TableHeaderCellUpdatePanelFragment = { __typename?: 'TableHeaderCellAttribute', id: string };

export type DeleteTableHeaderCellFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteTableHeaderCellFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type TableOfContentsHeadingCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateTableOfContentsHeadingFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type CreateTableOfContentsHeadingFromPanelMutation = { __typename?: 'Mutation', createTableOfContentsHeadingAttribute: { __typename?: 'CreateTableOfContentsHeadingAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableOfContentsHeadingAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type TableOfContentsHeadingUpdatePanelFragment = { __typename?: 'TableOfContentsHeadingAttribute', id: string };

export type DeleteTableOfContentsHeadingFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteTableOfContentsHeadingFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type TableOfContentsItemCreationPanelFragment = { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } } };

export type CreateTableOfContentsItemFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  linkedRegionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateTableOfContentsItemFromPanelMutation = { __typename?: 'Mutation', createTableOfContentsItemAttribute: { __typename?: 'CreateTableOfContentsItemAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableOfContentsItemAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null } | null } };

export type TableOfContentsItemFormFieldFragment = { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } } };

export type TableOfContentsItemUpdatePanelFragment = { __typename?: 'TableOfContentsItemAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } } } };

export type DeleteTableOfContentsItemFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteTableOfContentsItemFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type UpdateTableOfContentsItemFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  linkedRegionId: Scalars['ID']['input'];
}>;


export type UpdateTableOfContentsItemFromPanelMutation = { __typename?: 'Mutation', updateTableOfContentsItemAttribute: { __typename?: 'UpdateTableOfContentsItemAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableOfContentsItemAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null } | null } };

export type TableOfContentsPageNumberCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateTableOfContentsPageNumberFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type CreateTableOfContentsPageNumberFromPanelMutation = { __typename?: 'Mutation', createTableOfContentsPageNumberAttribute: { __typename?: 'CreateTableOfContentsPageNumberAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableOfContentsPageNumberAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type TableOfContentsPageNumberUpdatePanelFragment = { __typename?: 'TableOfContentsPageNumberAttribute', id: string };

export type DeleteTableOfContentsPageNumberFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteTableOfContentsPageNumberFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type TableOfContentsCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateTableOfContentsFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type CreateTableOfContentsFromPanelMutation = { __typename?: 'Mutation', createTableOfContentsAttribute: { __typename?: 'CreateTableOfContentsAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableOfContentsAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type TableOfContentsUpdatePanelFragment = { __typename?: 'TableOfContentsAttribute', id: string };

export type DeleteTableOfContentsFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteTableOfContentsFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type TableCreationPanelFragment = { __typename?: 'Region', id: string };

export type CreateTableFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  rows: Array<Scalars['NonNegativeFloat']['input']> | Scalars['NonNegativeFloat']['input'];
  columns: Array<Scalars['NonNegativeFloat']['input']> | Scalars['NonNegativeFloat']['input'];
  parentRowOffset: Scalars['NonNegativeInt']['input'];
  parentColumnOffset: Scalars['NonNegativeInt']['input'];
}>;


export type CreateTableFromPanelMutation = { __typename?: 'Mutation', createTableAttribute: { __typename?: 'CreateTableAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type TableUpdatePanelFragment = { __typename?: 'TableAttribute', id: string, parentRowOffset: number, parentColumnOffset: number, rows: Array<number>, columns: Array<number> };

export type DeleteTableFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteTableFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type UpdateTableFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  rowOffset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  columnOffset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  rows: Array<Scalars['NonNegativeFloat']['input']> | Scalars['NonNegativeFloat']['input'];
  columns: Array<Scalars['NonNegativeFloat']['input']> | Scalars['NonNegativeFloat']['input'];
}>;


export type UpdateTableFromPanelMutation = { __typename?: 'Mutation', updateTableAttribute: { __typename?: 'UpdateTableAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableAttribute', id: string, parentRowOffset: number, parentColumnOffset: number, rows: Array<number>, columns: Array<number> } | null } };

export type TextCreationPanelFragment = { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } };

export type CreateTextFromPanelMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type CreateTextFromPanelMutation = { __typename?: 'Mutation', createTextAttribute: { __typename?: 'CreateTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TextAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null } };

export type TextFormFieldFragment = { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } };

export type TextPredictionButtonFragment = { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } };

export type TextUpdatePanelFragment = { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } };

export type DeleteTextFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
}>;


export type DeleteTextFromPanelMutation = { __typename?: 'Mutation', deleteAttribute: { __typename?: 'DeleteAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string } | null } };

export type UpdateTextFromPanelMutationVariables = Exact<{
  attributeId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateTextFromPanelMutation = { __typename?: 'Mutation', updateTextAttribute: { __typename?: 'UpdateTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TextAttribute', id: string, text: string } | null } };

export type DocumentDeleteDialogContentFragment = { __typename?: 'Document', id: string, name: string };

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument: { __typename?: 'DeleteDocumentPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, document?: { __typename?: 'Document', id: string } | null } };

export type DocumentDeleteDropdownMenuItemFragment = { __typename?: 'Document', id: string, name: string };

export type DocumentExportArtifactFragment = { __typename?: 'Artifact', id: string, progress: number, createdAt: string, downloadUrl?: string | null, exporter: Exporter, createdBy: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null }, source: { __typename?: 'Document', id: string, name: string } };

export type DocumentExportArtifactOptionsFragment = { __typename?: 'Artifact', id: string, downloadUrl?: string | null, exporter: Exporter, source: { __typename?: 'Document', id: string, name: string } };

export type DeleteArtifactMutationVariables = Exact<{
  artifactId: Scalars['ID']['input'];
}>;


export type DeleteArtifactMutation = { __typename?: 'Mutation', deleteArtifact: { __typename?: 'DeleteArtifactPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, artifact?: { __typename?: 'Artifact', id: string } | null } };

export type DocumentExportDialogContentFragment = { __typename?: 'Document', id: string };

export type DocumentExportDialogContentQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type DocumentExportDialogContentQuery = { __typename?: 'Query', document?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document', id: string, name: string, artifacts: { __typename?: 'ArtifactConnection', artifacts: Array<{ __typename?: 'Artifact', id: string, progress: number, createdAt: string, downloadUrl?: string | null, exporter: Exporter, createdBy: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null }, source: { __typename?: 'Document', id: string, name: string } }> } } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type CreateArtifactMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  exportType: ExporterType;
}>;


export type CreateArtifactMutation = { __typename?: 'Mutation', createArtifact: { __typename?: 'CreateArtifactPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, artifact?: { __typename?: 'Artifact', id: string, source: { __typename?: 'Document', id: string, artifacts: { __typename?: 'ArtifactConnection', artifacts: Array<{ __typename?: 'Artifact', id: string, progress: number, createdAt: string, downloadUrl?: string | null, exporter: Exporter, createdBy: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null }, source: { __typename?: 'Document', id: string, name: string } }> } } } | null } };

export type DocumentExportDropdownMenuItemFragment = { __typename?: 'Document', id: string };

export type DocumentExtensionTableCellFragment = { __typename?: 'Document', id: string, extension: string };

export type DocumentModifiedAtTableCellFragment = { __typename?: 'Document', id: string, lastModifiedAt: string };

export type DocumentModifiedByTableCellFragment = { __typename?: 'Document', id: string, lastModifiedBy: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null } };

export type DocumentNameTableCellFragment = { __typename?: 'Document', id: string, name: string, tags: Array<string>, members: { __typename?: 'MembershipConnection', total: number } };

export type DocumentRenameDialogContentFragment = { __typename?: 'Document', id: string, name: string };

export type RenameDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
}>;


export type RenameDocumentMutation = { __typename?: 'Mutation', renameDocument: { __typename?: 'RenameDocumentPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, document?: { __typename?: 'Document', id: string, name: string } | null } };

export type DocumentRenameDropdownMenuItemFragment = { __typename?: 'Document', id: string, name: string };

export type DocumentShareCollaboratorFragment = { __typename?: 'User', id: string, username: string, avatarUrl?: string | null };

export type DocumentShareComboxboxFragment = { __typename?: 'UserConnection', users: Array<{ __typename?: 'User', id: string, username: string, avatarUrl?: string | null }> };

export type DocumentShareDialogContentFragment = { __typename?: 'Document', id: string };

export type DocumentShareDialogContentQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type DocumentShareDialogContentQuery = { __typename?: 'Query', document?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document', id: string, name: string, members: { __typename?: 'MembershipConnection', memberships: Array<{ __typename?: 'Membership', permission: Permission, document: { __typename?: 'Document', id: string }, user: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null } }> }, viewerMembership: { __typename?: 'Membership', user: { __typename?: 'User', id: string, colleagues: { __typename?: 'UserConnection', users: Array<{ __typename?: 'User', id: string, username: string, avatarUrl?: string | null }> } }, document: { __typename?: 'Document', id: string } } } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type ShareDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type ShareDocumentMutation = { __typename?: 'Mutation', updateDocumentPermission: { __typename?: 'UpdateDocumentPermissionPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, membership?: { __typename?: 'Membership', permission: Permission, document: { __typename?: 'Document', id: string, members: { __typename?: 'MembershipConnection', memberships: Array<{ __typename?: 'Membership', permission: Permission, document: { __typename?: 'Document', id: string }, user: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null } }> } }, user: { __typename?: 'User', id: string } } | null } };

export type DocumentShareDrowdownMenuItemFragment = { __typename?: 'Document', id: string };

export type DocumentSharePermissionFragment = { __typename?: 'Membership', permission: Permission, document: { __typename?: 'Document', id: string }, user: { __typename?: 'User', id: string } };

export type UpdateDocumentPermissionMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  permission: Permission;
}>;


export type UpdateDocumentPermissionMutation = { __typename?: 'Mutation', updateDocumentPermission: { __typename?: 'UpdateDocumentPermissionPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, membership?: { __typename?: 'Membership', permission: Permission, document: { __typename?: 'Document', id: string }, user: { __typename?: 'User', id: string } } | null } };

export type DocumentTableFragment = { __typename?: 'MembershipConnection', memberships: Array<{ __typename?: 'Membership', document: { __typename?: 'Document', id: string, tags: Array<string>, extension: string, name: string, uploadedAt: string, lastModifiedAt: string, uploadedBy: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null }, members: { __typename?: 'MembershipConnection', total: number }, lastModifiedBy: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null } }, user: { __typename?: 'User', id: string } }> };

export type DocumentRowFragment = { __typename?: 'Membership', document: { __typename?: 'Document', id: string, name: string, uploadedAt: string, lastModifiedAt: string, extension: string, tags: Array<string>, members: { __typename?: 'MembershipConnection', total: number }, uploadedBy: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null }, lastModifiedBy: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null } } };

export type DocumentTableActionsDropdownMenuFragment = { __typename?: 'Document', id: string, name: string };

export type DocumentTableToolbarFragment = { __typename?: 'MembershipConnection', memberships: Array<{ __typename?: 'Membership', document: { __typename?: 'Document', id: string, tags: Array<string>, extension: string, uploadedBy: { __typename?: 'User', id: string, username: string } }, user: { __typename?: 'User', id: string } }> };

export type DocumentTagsFragment = { __typename?: 'Document', id: string, tags: Array<string> };

export type DocumentTagsDialogContentFragment = { __typename?: 'Document', id: string };

export type DocumentTagsDialogContentQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type DocumentTagsDialogContentQuery = { __typename?: 'Query', document?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document', id: string, name: string, tags: Array<string>, possibleTags: Array<string> } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type TagDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
}>;


export type TagDocumentMutation = { __typename?: 'Mutation', addDocumentTag: { __typename?: 'AddDocumentTagPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, document?: { __typename?: 'Document', id: string, tags: Array<string>, possibleTags: Array<string> } | null } };

export type UntagDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
}>;


export type UntagDocumentMutation = { __typename?: 'Mutation', removeDocumentTag: { __typename?: 'RemoveDocumentTagPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, document?: { __typename?: 'Document', id: string, tags: Array<string>, possibleTags: Array<string> } | null } };

export type DocumentTagsDropdownMenuItemFragment = { __typename?: 'Document', id: string };

export type DocumentTagsInputFragment = { __typename?: 'Document', id: string, tags: Array<string> };

export type DocumentTagsSuggestionsFragment = { __typename?: 'Document', id: string, possibleTags: Array<string> };

export type DocumentTagsTableCellFragment = { __typename?: 'Document', id: string, tags: Array<string> };

export type DocumentUploadedAtTableCellFragment = { __typename?: 'Document', id: string, uploadedAt: string };

export type DocumentUploadedByTableCellFragment = { __typename?: 'Document', id: string, uploadedBy: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null } };

export type NavbarExportTabContentFragment = { __typename?: 'Document', id: string };

export type NavbarExportTabContentQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type NavbarExportTabContentQuery = { __typename?: 'Query', document?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document', id: string, name: string, artifacts: { __typename?: 'ArtifactConnection', artifacts: Array<{ __typename?: 'Artifact', id: string, progress: number, createdAt: string, downloadUrl?: string | null, exporter: Exporter, createdBy: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null }, source: { __typename?: 'Document', id: string, name: string } }> } } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type NavbarMetadataTabContentFragment = { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', language: string, date?: string | null, document: { __typename?: 'Document', id: string }, titles: Array<{ __typename?: 'MetadataTitle', id: string, title: string, language: string }>, authors: Array<{ __typename?: 'MetadataAuthor', id: string, name: string }>, subject: Array<{ __typename?: 'MetadataSubject', id: string, subject: string }> } };

export type NavbarNextPageButtonFragment = { __typename?: 'Page', id: string, document: { __typename?: 'Document', id: string }, nextPage?: { __typename?: 'Page', id: string } | null };

export type NavbarOverviewButtonFragment = { __typename?: 'Document', id: string };

export type NavbarPagesTabContentFragment = { __typename?: 'Page', id: string, index: number, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', total: number, pages: Array<{ __typename?: 'Page', id: string, index: number, pngUrl?: string | null, width: number, height: number, document: { __typename?: 'Document', id: string }, issues: Array<{ __typename?: 'Issue', id: string }> }> } } };

export type NavbarPreviousPageButtonFragment = { __typename?: 'Page', id: string, document: { __typename?: 'Document', id: string }, previousPage?: { __typename?: 'Page', id: string } | null };

export type NavbarRegionsTabContentFragment = { __typename?: 'Page', id: string, available: boolean, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> }> };

export type UpdateReadingOrderMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  readingOrderIndex: Scalars['NonNegativeInt']['input'];
}>;


export type UpdateReadingOrderMutation = { __typename?: 'Mutation', updateRegionReadingOrderIndex: { __typename?: 'UpdateRegionReadingOrderIndexPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, region?: { __typename?: 'Region', id: string, readingOrderIndex: number } | null } };

export type PageFragment = { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } }> };

export type PageEditorFragment = { __typename?: 'Page', id: string, index: number, width: number, height: number, svgUrl?: string | null, document: { __typename?: 'Document', id: string }, nextPage?: { __typename?: 'Page', id: string } | null, previousPage?: { __typename?: 'Page', id: string } | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> }> };

export type PageMinimapFragment = { __typename?: 'Page', id: string, index: number, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } }> };

export type PageOverlayFragment = { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> }> };

export type PageSkeletonFragment = { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } }> };

export type PageIssuesBadgeFragment = { __typename?: 'Page', id: string, issues: Array<{ __typename?: 'Issue', id: string }> };

export type RegionIssueAlertFragment = { __typename?: 'Issue', id: string, type: IssueType };

export type RegionIssueAlertsFragment = { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string, type: IssueType }> };

export type RegionIssuesBadgeFragment = { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }> };

export type MetadataAuthorAccordionItemFragment = { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', document: { __typename?: 'Document', id: string }, authors: Array<{ __typename?: 'MetadataAuthor', id: string, name: string }> } };

export type AddAuthorMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type AddAuthorMutation = { __typename?: 'Mutation', addAuthor: { __typename?: 'AddAuthorPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, author?: { __typename?: 'MetadataAuthor', id: string, name: string } | null } };

export type RenameAuthorMutationVariables = Exact<{
  authorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameAuthorMutation = { __typename?: 'Mutation', renameAuthor: { __typename?: 'RenameAuthorPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, author?: { __typename?: 'MetadataAuthor', id: string, name: string } | null } };

export type RemoveAuthorMutationVariables = Exact<{
  authorId: Scalars['ID']['input'];
}>;


export type RemoveAuthorMutation = { __typename?: 'Mutation', removeAuthor: { __typename?: 'RemoveAuthorPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, author?: { __typename?: 'MetadataAuthor', id: string } | null } };

export type MetadataDateAccordionItemFragment = { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', date?: string | null, document: { __typename?: 'Document', id: string } } };

export type SetDocumentDateMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type SetDocumentDateMutation = { __typename?: 'Mutation', setDate: { __typename?: 'SetDatePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, metadata?: { __typename?: 'Metadata', date?: string | null, document: { __typename?: 'Document', id: string } } | null } };

export type MetadataKeywordAccordionItemFragment = { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', document: { __typename?: 'Document', id: string }, subject: Array<{ __typename?: 'MetadataSubject', id: string, subject: string }> } };

export type AddSubjectMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
}>;


export type AddSubjectMutation = { __typename?: 'Mutation', addSubject: { __typename?: 'AddSubjectPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, subject?: { __typename?: 'MetadataSubject', id: string, subject: string } | null } };

export type RemoveSubjectMutationVariables = Exact<{
  subjectId: Scalars['ID']['input'];
}>;


export type RemoveSubjectMutation = { __typename?: 'Mutation', removeSubject: { __typename?: 'RemoveSubjectPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, subject?: { __typename?: 'MetadataSubject', id: string } | null } };

export type MetadataLanguageAccordionItemFragment = { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', language: string, document: { __typename?: 'Document', id: string } } };

export type SetDocumentLanguageMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
}>;


export type SetDocumentLanguageMutation = { __typename?: 'Mutation', setLanguage: { __typename?: 'SetLanguagePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, metadata?: { __typename?: 'Metadata', language: string, document: { __typename?: 'Document', id: string } } | null } };

export type MetadataTitleAccordionItemFragment = { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', document: { __typename?: 'Document', id: string }, titles: Array<{ __typename?: 'MetadataTitle', id: string, title: string, language: string }> } };

export type AddTitleMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
  title: Scalars['String']['input'];
}>;


export type AddTitleMutation = { __typename?: 'Mutation', addTitle: { __typename?: 'AddTitlePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, title?: { __typename?: 'MetadataTitle', id: string, title: string, language: string } | null } };

export type RemoveTitleMutationVariables = Exact<{
  titleId: Scalars['ID']['input'];
}>;


export type RemoveTitleMutation = { __typename?: 'Mutation', removeTitle: { __typename?: 'RemoveTitlePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, title?: { __typename?: 'MetadataTitle', id: string } | null } };

export type UpdateTitleMutationVariables = Exact<{
  titleId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type UpdateTitleMutation = { __typename?: 'Mutation', renameTitle: { __typename?: 'RenameTitlePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, title?: { __typename?: 'MetadataTitle', id: string, title: string } | null }, changeTitleLanguage: { __typename?: 'ChangeTitleLanguagePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, title?: { __typename?: 'MetadataTitle', id: string, language: string } | null } };

export type PageNumberBadgeFragment = { __typename?: 'Page', id: string, index: number };

export type PagePaginationFragment = { __typename?: 'Page', id: string, index: number, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', total: number, pages: Array<{ __typename?: 'Page', id: string, index: number }> } } };

export type PageThumbnailFragment = { __typename?: 'Page', id: string, pngUrl?: string | null, width: number, height: number, index: number, document: { __typename?: 'Document', id: string } };

export type RegionCardFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> };

export type RegionContextMenuContentFragment = { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'TextAttribute' }>, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> } };

export type DeleteRegionFromContextMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type DeleteRegionFromContextMutation = { __typename?: 'Mutation', deleteRegion: { __typename?: 'DeleteRegionPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, region?: { __typename?: 'Region', id: string } | null } };

export type RegionImageFragment = { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } };

export type RegionLabelFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type RegionPolygonFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type RegionSelectContentFragment = { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } } };

export type RegionSelectionHandlerFragment = { __typename?: 'Region', id: string };

export type RegionShortcutsHandlerFragment = { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'TextAttribute' }>, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> } };

export type DeleteRegionViaShortcutMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type DeleteRegionViaShortcutMutation = { __typename?: 'Mutation', deleteRegion: { __typename?: 'DeleteRegionPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, region?: { __typename?: 'Region', id: string } | null } };

export type RegionThumbnailFragment = { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type RegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type RegionTileSwitchFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> } };

export type RegionsToolOverlayFragment = { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> }> };

export type CreateRegionMutationVariables = Exact<{
  pageId: Scalars['ID']['input'];
  vertices: Array<InputVertex> | InputVertex;
}>;


export type CreateRegionMutation = { __typename?: 'Mutation', createRegion: { __typename?: 'CreateRegionPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, region?: { __typename?: 'Region', id: string } | null } };

export type ReshapeableRegionFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type UpdateRegionVerticesMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  vertices: Array<InputVertex> | InputVertex;
}>;


export type UpdateRegionVerticesMutation = { __typename?: 'Mutation', updateRegionShape: { __typename?: 'UpdateRegionShapePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, region?: { __typename?: 'Region', id: string, readingOrderIndex: number, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> } | null } };

export type TransformableRegionFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type UpdateRegionShapeMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  vertices: Array<InputVertex> | InputVertex;
}>;


export type UpdateRegionShapeMutation = { __typename?: 'Mutation', updateRegionShape: { __typename?: 'UpdateRegionShapePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, region?: { __typename?: 'Region', id: string, readingOrderIndex: number, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> } | null } };

export type FootnoteRefPickerFragment = { __typename?: 'Page', id: string, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> };

export type FormulaRefPickerFragment = { __typename?: 'Page', id: string, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> };

export type RefNodeFragment = { __typename?: 'Page', id: string, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> };

export type RichTextToolbarFragment = { __typename?: 'Page', id: string, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> };

export type ExtensionFootnoteRefFragment = { __typename?: 'Page', id: string, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> };

export type ExtensionFormulaRefFragment = { __typename?: 'Page', id: string, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> };

export type DocumentScreenQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type DocumentScreenQuery = { __typename?: 'Query', node?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document', id: string, name: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, pngUrl?: string | null, width: number, height: number, index: number, issues: Array<{ __typename?: 'Issue', id: string }>, document: { __typename?: 'Document', id: string } }> }, metadata: { __typename?: 'Metadata', language: string, date?: string | null, document: { __typename?: 'Document', id: string }, titles: Array<{ __typename?: 'MetadataTitle', id: string, title: string, language: string }>, authors: Array<{ __typename?: 'MetadataAuthor', id: string, name: string }>, subject: Array<{ __typename?: 'MetadataSubject', id: string, subject: string }> } } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page', id: string, document: { __typename?: 'Document', id: string }, nextPage?: { __typename?: 'Page', id: string } | null, previousPage?: { __typename?: 'Page', id: string } | null } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type DocumentsScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentsScreenQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, memberships: { __typename?: 'MembershipConnection', memberships: Array<{ __typename?: 'Membership', document: { __typename?: 'Document', id: string, tags: Array<string>, extension: string, name: string, uploadedAt: string, lastModifiedAt: string, uploadedBy: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null }, members: { __typename?: 'MembershipConnection', total: number }, lastModifiedBy: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null } }, user: { __typename?: 'User', id: string } }> } } };

export type PageScreenQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
}>;


export type PageScreenQuery = { __typename?: 'Query', page?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page', id: string, available: boolean, index: number, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }>, issues: Array<{ __typename?: 'Issue', id: string, type: IssueType }>, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> } }>, document: { __typename?: 'Document', id: string, name: string, pages: { __typename?: 'PageConnection', total: number, pages: Array<{ __typename?: 'Page', id: string, index: number, pngUrl?: string | null, width: number, height: number, document: { __typename?: 'Document', id: string }, issues: Array<{ __typename?: 'Issue', id: string }> }> }, metadata: { __typename?: 'Metadata', language: string, date?: string | null, document: { __typename?: 'Document', id: string }, titles: Array<{ __typename?: 'MetadataTitle', id: string, title: string, language: string }>, authors: Array<{ __typename?: 'MetadataAuthor', id: string, name: string }>, subject: Array<{ __typename?: 'MetadataSubject', id: string, subject: string }> } }, nextPage?: { __typename?: 'Page', id: string } | null, previousPage?: { __typename?: 'Page', id: string } | null } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type SettingsScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsScreenQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, username: string, avatarUrl?: string | null }, deployment: { __typename?: 'Deployment', vcsRef?: string | null, vcsUrl?: string | null } };

export type TableCellPreviewFragment = { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null };

export type TableEditorFragment = { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, width: number, height: number, svgUrl?: string | null } };

export type TableEditorStep1Fragment = { __typename?: 'Page', id: string, pngUrl?: string | null };

export type TableEditorStep6Fragment = { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null };

export type RegionTableDataFragment = { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'TextAttribute' }>, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> } };

export type RegionUpdateTabFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string, type: IssueType }>, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type ArtifactRegionCreationTabFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> };

export type ArtifactRegionCreationTabQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
  paginationArtifactAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArtifactRegionCreationTabQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'Artifact', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'MetadataAuthor', id: string } | { __typename?: 'MetadataSubject', id: string } | { __typename?: 'MetadataTitle', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableGroup', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'Task', id: string } | { __typename?: 'TaskMessage', id: string } | { __typename?: 'TextAttribute', id: string } | { __typename?: 'User', id: string } | null, paginationArtifactAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute', id: string, type: PaginationArtifactType } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null> };

export type CreateArtifactRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  type: PaginationArtifactType;
  excessAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateArtifactRegionMutation = { __typename?: 'Mutation', createPaginationArtifactAttribute: { __typename?: 'CreatePaginationArtifactAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'PaginationArtifactAttribute', id: string, type: PaginationArtifactType, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> } } | null }, deleteAttributes: { __typename?: 'DeleteAttributesPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null } };

export type ArtifactRegionEditorQueryVariables = Exact<{
  paginationArtifactAttributeId: Scalars['ID']['input'];
}>;


export type ArtifactRegionEditorQuery = { __typename?: 'Query', paginationArtifactAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute', id: string, type: PaginationArtifactType } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type UpdateArtifactRegionMutationVariables = Exact<{
  paginationArtifactAttributeId: Scalars['ID']['input'];
  paginationArtifactType: PaginationArtifactType;
}>;


export type UpdateArtifactRegionMutation = { __typename?: 'Mutation', updatePaginationArtifactAttribute: { __typename?: 'UpdatePaginationArtifactAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'PaginationArtifactAttribute', id: string, type: PaginationArtifactType, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null } };

export type ArtifactRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', type: PaginationArtifactType, id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type ArtifactRegionTypeCardFragment = { __typename?: 'Region', id: string };

export type CaptionRegionCreationTabFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> };

export type CaptionRegionCreationTabQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
  captionAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  textAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CaptionRegionCreationTabQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null, captionAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null>, textAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute', id: string, text: string } | { __typename?: 'User' } | null> };

export type CreateCaptionRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  linkedRegionId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
  excessAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateCaptionRegionMutation = { __typename?: 'Mutation', createCaptionAttribute: { __typename?: 'CreateCaptionAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'CaptionAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null }, createTextAttribute: { __typename?: 'CreateTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null }, deleteAttributes: { __typename?: 'DeleteAttributesPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null } };

export type CaptionRegionEditorQueryVariables = Exact<{
  captionAttributeId: Scalars['ID']['input'];
  textAttributeId: Scalars['ID']['input'];
}>;


export type CaptionRegionEditorQuery = { __typename?: 'Query', captionAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } } } } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null, textAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } } | { __typename?: 'User' } | null };

export type UpdateCaptionRegionMutationVariables = Exact<{
  captionAttributeId: Scalars['ID']['input'];
  linkedRegionId?: InputMaybe<Scalars['ID']['input']>;
  textAttributeId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateCaptionRegionMutation = { __typename?: 'Mutation', updateCaptionAttribute: { __typename?: 'UpdateCaptionAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'CaptionAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null }, updateTextAttribute: { __typename?: 'UpdateTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null } };

export type CaptionRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> };

export type CaptionRegionTypeCardFragment = { __typename?: 'Region', id: string };

export type FigureRegionCreationTabFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> };

export type FigureRegionCreationTabQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
  figureAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FigureRegionCreationTabQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'Artifact', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'MetadataAuthor', id: string } | { __typename?: 'MetadataSubject', id: string } | { __typename?: 'MetadataTitle', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableGroup', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'Task', id: string } | { __typename?: 'TaskMessage', id: string } | { __typename?: 'TextAttribute', id: string } | { __typename?: 'User', id: string } | null, figureAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null> };

export type CreateFigureRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  excessAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateFigureRegionMutation = { __typename?: 'Mutation', createFigureAttribute: { __typename?: 'CreateFigureAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'FigureAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> } } | null }, deleteAttributes: { __typename?: 'DeleteAttributesPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null } };

export type FigureRegionEditorQueryVariables = Exact<{
  figureAttributeId: Scalars['ID']['input'];
}>;


export type FigureRegionEditorQuery = { __typename?: 'Query', figureAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type FigureRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type FigureRegionTypeCardFragment = { __typename?: 'Region', id: string };

export type FormulaRegionCreationTabFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> };

export type FormulaRegionCreationTabQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
  expressionAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FormulaRegionCreationTabQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'Artifact', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'MetadataAuthor', id: string } | { __typename?: 'MetadataSubject', id: string } | { __typename?: 'MetadataTitle', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, pngUrl?: string | null } } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableGroup', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'Task', id: string } | { __typename?: 'TaskMessage', id: string } | { __typename?: 'TextAttribute', id: string } | { __typename?: 'User', id: string } | null, expressionAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute', id: string, expressionLatex: string } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null> };

export type CreateFormulaRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  expressionLatex: Scalars['String']['input'];
  excessAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateFormulaRegionMutation = { __typename?: 'Mutation', createExpressionAttribute: { __typename?: 'CreateExpressionAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ExpressionAttribute', id: string, expressionLatex: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> } } | null }, deleteAttributes: { __typename?: 'DeleteAttributesPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null } };

export type FormulaRegionEditorQueryVariables = Exact<{
  expressionAttributeId: Scalars['ID']['input'];
}>;


export type FormulaRegionEditorQuery = { __typename?: 'Query', expressionAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute', id: string, expressionLatex: string, region: { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, pngUrl?: string | null } } } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type UpdateFormulaRegionMutationVariables = Exact<{
  expressionAttributeId: Scalars['ID']['input'];
  expressionLatex: Scalars['String']['input'];
}>;


export type UpdateFormulaRegionMutation = { __typename?: 'Mutation', updateExpressionAttribute: { __typename?: 'UpdateExpressionAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ExpressionAttribute', id: string, expressionLatex: string, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null } };

export type FormulaRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type FormulaRegionTypeCardFragment = { __typename?: 'Region', id: string };

export type HeadingRegionCreationTabFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> };

export type HeadingRegionCreationTabQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
  headerLevelAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  textAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type HeadingRegionCreationTabQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'Artifact', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'MetadataAuthor', id: string } | { __typename?: 'MetadataSubject', id: string } | { __typename?: 'MetadataTitle', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableGroup', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'Task', id: string } | { __typename?: 'TaskMessage', id: string } | { __typename?: 'TextAttribute', id: string } | { __typename?: 'User', id: string } | null, headerLevelAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute', id: string, level: number } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null>, textAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute', id: string, text: string } | { __typename?: 'User' } | null> };

export type CreateHeadingRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  level: Scalars['PositiveInt']['input'];
  text: Scalars['String']['input'];
  excessAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateHeadingRegionMutation = { __typename?: 'Mutation', createHeaderLevelAttribute: { __typename?: 'CreateHeaderLevelAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'HeaderLevelAttribute', id: string, level: number, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null }, createTextAttribute: { __typename?: 'CreateTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null }, deleteAttributes: { __typename?: 'DeleteAttributesPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null } };

export type HeadingRegionEditorQueryVariables = Exact<{
  headerLevelAttributeId: Scalars['ID']['input'];
  textAttributeId: Scalars['ID']['input'];
}>;


export type HeadingRegionEditorQuery = { __typename?: 'Query', headerLevelAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute', id: string, level: number } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null, textAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } } | { __typename?: 'User' } | null };

export type UpdateHeadingRegionMutationVariables = Exact<{
  headerLevelAttributeId: Scalars['ID']['input'];
  level: Scalars['PositiveInt']['input'];
  textAttributeId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateHeadingRegionMutation = { __typename?: 'Mutation', updateHeaderLevelAttribute: { __typename?: 'UpdateHeaderLevelAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'HeaderLevelAttribute', id: string, level: number, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null }, updateTextAttribute: { __typename?: 'UpdateTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null } };

export type HeadingRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', level: number, id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> };

export type HeadingRegionTypeCardFragment = { __typename?: 'Region', id: string };

export type AttributeCreationSectionFragment = { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, document: { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', language: string, document: { __typename?: 'Document', id: string } }, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> } };

export type AttributeUpdateSectionFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string, alternativeText: string, region: { __typename?: 'Region', id: string, document: { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', language: string, document: { __typename?: 'Document', id: string } } }, page: { __typename?: 'Page', id: string, pngUrl?: string | null }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } } | { __typename?: 'CaptionAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } } } } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string, expressionLatex: string, region: { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, pngUrl?: string | null } } } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string, level: number } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string, listType: ListType } | { __typename?: 'ListItemAttribute', id: string, ordinal: number } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string, type: PaginationArtifactType } | { __typename?: 'TableAttribute', id: string, parentRowOffset: number, parentColumnOffset: number, rows: Array<number>, columns: Array<number> } | { __typename?: 'TableCellAttribute', id: string, rowSpan: number, columnSpan: number } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } } } } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } }> };

export type HybridRegionCreationTabFragment = { __typename?: 'Region', id: string };

export type HybridRegionEditorQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type HybridRegionEditorQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string, alternativeText: string, region: { __typename?: 'Region', id: string, document: { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', language: string, document: { __typename?: 'Document', id: string } } }, page: { __typename?: 'Page', id: string, pngUrl?: string | null }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } } | { __typename?: 'CaptionAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } } } } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string, expressionLatex: string, region: { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null, pngUrl?: string | null } } } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string, level: number } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string, listType: ListType } | { __typename?: 'ListItemAttribute', id: string, ordinal: number } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string, type: PaginationArtifactType } | { __typename?: 'TableAttribute', id: string, parentRowOffset: number, parentColumnOffset: number, rows: Array<number>, columns: Array<number> } | { __typename?: 'TableCellAttribute', id: string, rowSpan: number, columnSpan: number } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string, linkedRegion?: { __typename?: 'Region', id: string } | null, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string }, document: { __typename?: 'Document', id: string, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } } } } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } }>, page: { __typename?: 'Page', id: string, pngUrl?: string | null, width: number, height: number, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, document: { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', language: string, document: { __typename?: 'Document', id: string } }, pages: { __typename?: 'PageConnection', pages: Array<{ __typename?: 'Page', id: string, index: number, regions: Array<{ __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }> } }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> } } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type HybridRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type HybridRegionTypeCardFragment = { __typename?: 'Region', id: string };

export type ImageRegionCreationTabFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> };

export type ImageRegionCreationTabQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
  imageAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  alternativeTextAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ImageRegionCreationTabQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'Artifact', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'MetadataAuthor', id: string } | { __typename?: 'MetadataSubject', id: string } | { __typename?: 'MetadataTitle', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'Region', id: string, document: { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', language: string, document: { __typename?: 'Document', id: string } } }, page: { __typename?: 'Page', id: string, pngUrl?: string | null }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableGroup', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'Task', id: string } | { __typename?: 'TaskMessage', id: string } | { __typename?: 'TextAttribute', id: string } | { __typename?: 'User', id: string } | null, imageAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null>, alternativeTextAttributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string, alternativeText: string } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null> };

export type CreateImageRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  alternativeText: Scalars['String']['input'];
  excessAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateImageRegionMutation = { __typename?: 'Mutation', createImageAttribute: { __typename?: 'CreateImageAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ImageAttribute', id: string, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null }, createAlternativeTextAttribute: { __typename?: 'CreateAlternativeTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string, alternativeText: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> } } | null }, deleteAttributes: { __typename?: 'DeleteAttributesPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null } };

export type ImageRegionEditorQueryVariables = Exact<{
  imageAttributeId: Scalars['ID']['input'];
  alternativeTextAttributeId: Scalars['ID']['input'];
}>;


export type ImageRegionEditorQuery = { __typename?: 'Query', imageAttr?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'Artifact', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'MetadataAuthor', id: string } | { __typename?: 'MetadataSubject', id: string } | { __typename?: 'MetadataTitle', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableGroup', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'Task', id: string } | { __typename?: 'TaskMessage', id: string } | { __typename?: 'TextAttribute', id: string } | { __typename?: 'User', id: string } | null, altTextAttr?: { __typename?: 'AlternativeTextAttribute', id: string, alternativeText: string, region: { __typename?: 'Region', id: string, document: { __typename?: 'Document', id: string, metadata: { __typename?: 'Metadata', language: string, document: { __typename?: 'Document', id: string } } }, page: { __typename?: 'Page', id: string, pngUrl?: string | null }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type UpdateImageRegionMutationVariables = Exact<{
  alternativeTextAttributeId: Scalars['ID']['input'];
  alternativeText: Scalars['String']['input'];
}>;


export type UpdateImageRegionMutation = { __typename?: 'Mutation', updateAlternativeTextAttribute: { __typename?: 'UpdateAlternativeTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'AlternativeTextAttribute', id: string, alternativeText: string, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null } };

export type ImageRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', alternativeText: string, id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type ImageRegionTypeCardFragment = { __typename?: 'Region', id: string };

export type ListItemRegionCreationTabFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> };

export type ListItemRegionCreationTabQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
  listItemAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  textAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ListItemRegionCreationTabQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'Artifact', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'MetadataAuthor', id: string } | { __typename?: 'MetadataSubject', id: string } | { __typename?: 'MetadataTitle', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableGroup', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'Task', id: string } | { __typename?: 'TaskMessage', id: string } | { __typename?: 'TextAttribute', id: string } | { __typename?: 'User', id: string } | null, listItemAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute', id: string, ordinal: number } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null>, textAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute', id: string, text: string } | { __typename?: 'User' } | null> };

export type CreateListItemRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  ordinal: Scalars['NonNegativeInt']['input'];
  text: Scalars['String']['input'];
  excessAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateListItemRegionMutation = { __typename?: 'Mutation', createListItemAttribute: { __typename?: 'CreateListItemAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListItemAttribute', id: string, ordinal: number, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null }, createTextAttribute: { __typename?: 'CreateTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null }, deleteAttributes: { __typename?: 'DeleteAttributesPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null } };

export type ListItemRegionEditorQueryVariables = Exact<{
  listItemAttributeId: Scalars['ID']['input'];
  textAttributeId: Scalars['ID']['input'];
}>;


export type ListItemRegionEditorQuery = { __typename?: 'Query', listItemAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute', id: string, ordinal: number } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null, textAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } } | { __typename?: 'User' } | null };

export type UpdateListItemRegionMutationVariables = Exact<{
  listItemAttributeId: Scalars['ID']['input'];
  textAttributeId: Scalars['ID']['input'];
  ordinal: Scalars['NonNegativeInt']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateListItemRegionMutation = { __typename?: 'Mutation', updateListItemAttribute: { __typename?: 'UpdateListItemAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListItemAttribute', id: string, ordinal: number, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null }, updateTextAttribute: { __typename?: 'UpdateTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null } };

export type ListItemRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> };

export type ListItemRegionTypeCardFragment = { __typename?: 'Region', id: string };

export type ListRegionCreationTabFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> };

export type ListRegionCreationTabQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
  listAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ListRegionCreationTabQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'Artifact', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'MetadataAuthor', id: string } | { __typename?: 'MetadataSubject', id: string } | { __typename?: 'MetadataTitle', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableGroup', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'Task', id: string } | { __typename?: 'TaskMessage', id: string } | { __typename?: 'TextAttribute', id: string } | { __typename?: 'User', id: string } | null, listAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute', id: string, listType: ListType } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null> };

export type CreateListRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  listType: ListType;
  excessAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateListRegionMutation = { __typename?: 'Mutation', createListAttribute: { __typename?: 'CreateListAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListAttribute', id: string, listType: ListType, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> } } | null }, deleteAttributes: { __typename?: 'DeleteAttributesPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null } };

export type ListRegionEditorQueryVariables = Exact<{
  listAttributeId: Scalars['ID']['input'];
}>;


export type ListRegionEditorQuery = { __typename?: 'Query', listAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute', id: string, listType: ListType } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type UpdateListRegionMutationVariables = Exact<{
  listAttributeId: Scalars['ID']['input'];
  listType: ListType;
}>;


export type UpdateListRegionMutation = { __typename?: 'Mutation', updateListAttribute: { __typename?: 'UpdateListAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListAttribute', id: string, listType: ListType, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null } };

export type ListRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type ListRegionTypeCardFragment = { __typename?: 'Region', id: string };

export type SublistRegionCreationTabFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> };

export type SublistRegionCreationTabQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
  listAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  listItemAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SublistRegionCreationTabQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'Artifact', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'MetadataAuthor', id: string } | { __typename?: 'MetadataSubject', id: string } | { __typename?: 'MetadataTitle', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableGroup', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'Task', id: string } | { __typename?: 'TaskMessage', id: string } | { __typename?: 'TextAttribute', id: string } | { __typename?: 'User', id: string } | null, listAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute', id: string, listType: ListType } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null>, listItemAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute', id: string, ordinal: number } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null> };

export type CreateSublistRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  listType: ListType;
  ordinal: Scalars['NonNegativeInt']['input'];
  excessAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateSublistRegionMutation = { __typename?: 'Mutation', createListAttribute: { __typename?: 'CreateListAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListAttribute', id: string, listType: ListType, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null }, createListItemAttribute: { __typename?: 'CreateListItemAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListItemAttribute', id: string, ordinal: number, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> } } | null }, deleteAttributes: { __typename?: 'DeleteAttributesPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null } };

export type SublistRegionEditorQueryVariables = Exact<{
  listAttributeId: Scalars['ID']['input'];
  listItemAttributeId: Scalars['ID']['input'];
}>;


export type SublistRegionEditorQuery = { __typename?: 'Query', listAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute', id: string, listType: ListType } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null, listItemAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute', id: string, ordinal: number } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type UpdateSublistRegionMutationVariables = Exact<{
  listAttributeId: Scalars['ID']['input'];
  listType: ListType;
  listItemAttributeId: Scalars['ID']['input'];
  ordinal: Scalars['NonNegativeInt']['input'];
}>;


export type UpdateSublistRegionMutation = { __typename?: 'Mutation', updateListAttribute: { __typename?: 'UpdateListAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListAttribute', id: string, listType: ListType, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null }, updateListItemAttribute: { __typename?: 'UpdateListItemAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'ListItemAttribute', id: string, ordinal: number, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null } };

export type SublistRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', listType: ListType, id: string } | { __typename: 'ListItemAttribute', ordinal: number, id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type SublistRegionTypeCardFragment = { __typename?: 'Region', id: string };

export type TableRegionCreationTabFragment = { __typename?: 'Region', id: string };

export type TableRegionCreationTabQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type TableRegionCreationTabQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'Artifact', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'MetadataAuthor', id: string } | { __typename?: 'MetadataSubject', id: string } | { __typename?: 'MetadataTitle', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, pngUrl?: string | null, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> } } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableGroup', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'Task', id: string } | { __typename?: 'TaskMessage', id: string } | { __typename?: 'TextAttribute', id: string } | { __typename?: 'User', id: string } | null };

export type TableRegionEditorQueryVariables = Exact<{
  tableAttributeId: Scalars['ID']['input'];
}>;


export type TableRegionEditorQuery = { __typename?: 'Query', tableAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute', id: string, region: { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, pngUrl?: string | null, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> } } } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type TableRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> } };

export type TableRegionTypeCardFragment = { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'TextAttribute' }>, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> } };

export type TableRegionUpsertFormFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, pngUrl?: string | null, svgUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> } };

export type DeleteTableCellRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type DeleteTableCellRegionMutation = { __typename?: 'Mutation', deleteRegion: { __typename?: 'DeleteRegionPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, region?: { __typename?: 'Region', id: string } | null } };

export type CreateTableRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  rows: Array<Scalars['NonNegativeFloat']['input']> | Scalars['NonNegativeFloat']['input'];
  cols: Array<Scalars['NonNegativeFloat']['input']> | Scalars['NonNegativeFloat']['input'];
  excessAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateTableRegionMutation = { __typename?: 'Mutation', deleteAttributes: { __typename?: 'DeleteAttributesPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null }, createTableAttribute: { __typename?: 'CreateTableAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> } } | null } };

export type CreateTableCellRegionMutationVariables = Exact<{
  pageId: Scalars['ID']['input'];
  vertices: Array<InputVertex> | InputVertex;
}>;


export type CreateTableCellRegionMutation = { __typename?: 'Mutation', createRegion: { __typename?: 'CreateRegionPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, region?: { __typename?: 'Region', id: string } | null } };

export type CreateTableDataRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  colSpan: Scalars['PositiveInt']['input'];
  rowSpan: Scalars['PositiveInt']['input'];
}>;


export type CreateTableDataRegionMutation = { __typename?: 'Mutation', createTableCellAttribute: { __typename?: 'CreateTableCellAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableCellAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> } } | null } };

export type CreateTableHeaderRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  colSpan: Scalars['PositiveInt']['input'];
  rowSpan: Scalars['PositiveInt']['input'];
  scopes: Array<TableHeaderCellScopeInput> | TableHeaderCellScopeInput;
}>;


export type CreateTableHeaderRegionMutation = { __typename?: 'Mutation', createTableCellAttribute: { __typename?: 'CreateTableCellAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null }, createTableHeaderCellAttribute: { __typename?: 'CreateTableHeaderCellAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableHeaderCellAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> } } | null } };

export type TextRegionCreationTabFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> };

export type TextRegionCreationTabQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
  textAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type TextRegionCreationTabQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'Artifact', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'MetadataAuthor', id: string } | { __typename?: 'MetadataSubject', id: string } | { __typename?: 'MetadataTitle', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'Region', id: string, page: { __typename?: 'Page', id: string, pngUrl?: string | null, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableGroup', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'Task', id: string } | { __typename?: 'TaskMessage', id: string } | { __typename?: 'TextAttribute', id: string } | { __typename?: 'User', id: string } | null, textAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute', id: string, text: string } | { __typename?: 'User' } | null> };

export type CreateTextRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  excessAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateTextRegionMutation = { __typename?: 'Mutation', createTextAttribute: { __typename?: 'CreateTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> } } | null }, deleteAttributes: { __typename?: 'DeleteAttributesPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null } };

export type TextRegionEditorQueryVariables = Exact<{
  textAttributeId: Scalars['ID']['input'];
}>;


export type TextRegionEditorQuery = { __typename?: 'Query', textAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, pngUrl?: string | null, issues: Array<{ __typename?: 'Issue', id: string }>, regions: Array<{ __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', expressionLatex: string, id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', ordinal: number, id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }>, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', width: number, height: number, top: number, left: number }, vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, page: { __typename?: 'Page', id: string, width: number, height: number, svgUrl?: string | null } }> }, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } } } } | { __typename?: 'User' } | null };

export type UpdateTextRegionMutationVariables = Exact<{
  textAttributeId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateTextRegionMutation = { __typename?: 'Mutation', updateTextAttribute: { __typename?: 'UpdateTextAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TextAttribute', id: string, text: string, region: { __typename?: 'Region', id: string, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', issues: Array<{ __typename?: 'Issue', id: string }> } } } | null } };

export type TextRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', text: string, id: string }> };

export type TextRegionTypeCardFragment = { __typename?: 'Region', id: string };

export type TocRegionCreationTabFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> };

export type TocRegionCreationTabQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
  tableOfContentsAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type TocRegionCreationTabQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'Artifact', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'Document', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'Issue', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'MetadataAuthor', id: string } | { __typename?: 'MetadataSubject', id: string } | { __typename?: 'MetadataTitle', id: string } | { __typename?: 'Page', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', id: string } | { __typename?: 'TableGroup', id: string } | { __typename?: 'TableHeaderCellAttribute', id: string } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'Task', id: string } | { __typename?: 'TaskMessage', id: string } | { __typename?: 'TextAttribute', id: string } | { __typename?: 'User', id: string } | null, tableOfContentsAttributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null> };

export type CreateTocRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  excessAttributeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateTocRegionMutation = { __typename?: 'Mutation', createTableOfContentsAttribute: { __typename?: 'CreateTableOfContentsAttributePayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null, attribute?: { __typename?: 'TableOfContentsAttribute', id: string, region: { __typename?: 'Region', id: string, readingOrderIndex: number, issues: Array<{ __typename?: 'Issue', id: string }>, page: { __typename?: 'Page', id: string, width: number, height: number, issues: Array<{ __typename?: 'Issue', id: string }> }, shape: { __typename?: 'Polygon', vertices: Array<{ __typename?: 'Vertex', top: number, left: number }> }, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> } } | null }, deleteAttributes: { __typename?: 'DeleteAttributesPayload', userErrors?: Array<{ __typename?: 'NoFixError', code: UserErrorCode, path: string }> | null } };

export type TocRegionEditorQueryVariables = Exact<{
  tocAttributeId: Scalars['ID']['input'];
}>;


export type TocRegionEditorQuery = { __typename?: 'Query', tocAttr?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region' } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type TocRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type TocRegionTypeCardFragment = { __typename?: 'Region', id: string };

export type UntypedRegionEditorQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type UntypedRegionEditorQuery = { __typename?: 'Query', region?: { __typename?: 'AlternativeTextAttribute' } | { __typename?: 'Artifact' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'Document' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'Issue' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'MetadataAuthor' } | { __typename?: 'MetadataSubject' } | { __typename?: 'MetadataTitle' } | { __typename?: 'Page' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute' } | { __typename?: 'CaptionAttribute' } | { __typename?: 'ExcludeReadingOrderAttribute' } | { __typename?: 'ExpressionAttribute' } | { __typename?: 'FigureAttribute' } | { __typename?: 'FootnoteAttribute' } | { __typename?: 'HeaderLevelAttribute' } | { __typename?: 'ImageAttribute' } | { __typename?: 'ListAttribute' } | { __typename?: 'ListItemAttribute' } | { __typename?: 'ListItemLabelAttribute' } | { __typename?: 'PaginationArtifactAttribute' } | { __typename?: 'TableAttribute', id: string, rows: Array<number>, columns: Array<number> } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'TextAttribute' }>, page: { __typename?: 'Page', id: string, width: number, height: number, regions: Array<{ __typename?: 'Region', id: string, shape: { __typename?: 'Polygon', aabb: { __typename?: 'AABB', top: number, left: number, width: number, height: number } }, attributes: Array<{ __typename?: 'AlternativeTextAttribute', id: string } | { __typename?: 'CaptionAttribute', id: string } | { __typename?: 'ExcludeReadingOrderAttribute', id: string } | { __typename?: 'ExpressionAttribute', id: string } | { __typename?: 'FigureAttribute', id: string } | { __typename?: 'FootnoteAttribute', id: string } | { __typename?: 'HeaderLevelAttribute', id: string } | { __typename?: 'ImageAttribute', id: string } | { __typename?: 'ListAttribute', id: string } | { __typename?: 'ListItemAttribute', id: string } | { __typename?: 'ListItemLabelAttribute', id: string } | { __typename?: 'PaginationArtifactAttribute', id: string } | { __typename?: 'TableAttribute', id: string } | { __typename?: 'TableCellAttribute', rowSpan: number, columnSpan: number, id: string } | { __typename?: 'TableHeaderCellAttribute', id: string, scopes: Array<{ __typename?: 'TableHeaderCellScope', type: TableHeaderCellScopeType, link?: string | null }> } | { __typename?: 'TableOfContentsAttribute', id: string } | { __typename?: 'TableOfContentsHeadingAttribute', id: string } | { __typename?: 'TableOfContentsItemAttribute', id: string } | { __typename?: 'TableOfContentsPageNumberAttribute', id: string } | { __typename?: 'TextAttribute', id: string }> }> } } | { __typename?: 'TableAttribute' } | { __typename?: 'TableCellAttribute' } | { __typename?: 'TableGroup' } | { __typename?: 'TableHeaderCellAttribute' } | { __typename?: 'TableOfContentsAttribute' } | { __typename?: 'TableOfContentsHeadingAttribute' } | { __typename?: 'TableOfContentsItemAttribute' } | { __typename?: 'TableOfContentsPageNumberAttribute' } | { __typename?: 'Task' } | { __typename?: 'TaskMessage' } | { __typename?: 'TextAttribute' } | { __typename?: 'User' } | null };

export type UntypedRegionTileFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type RegionTypeFragment = { __typename?: 'Region', id: string, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type RegionNameFragment = { __typename?: 'Region', id: string, readingOrderIndex: number, attributes: Array<{ __typename: 'AlternativeTextAttribute', id: string } | { __typename: 'CaptionAttribute', id: string } | { __typename: 'ExcludeReadingOrderAttribute', id: string } | { __typename: 'ExpressionAttribute', id: string } | { __typename: 'FigureAttribute', id: string } | { __typename: 'FootnoteAttribute', id: string } | { __typename: 'HeaderLevelAttribute', id: string } | { __typename: 'ImageAttribute', id: string } | { __typename: 'ListAttribute', id: string } | { __typename: 'ListItemAttribute', id: string } | { __typename: 'ListItemLabelAttribute', id: string } | { __typename: 'PaginationArtifactAttribute', id: string } | { __typename: 'TableAttribute', id: string } | { __typename: 'TableCellAttribute', id: string } | { __typename: 'TableHeaderCellAttribute', id: string } | { __typename: 'TableOfContentsAttribute', id: string } | { __typename: 'TableOfContentsHeadingAttribute', id: string } | { __typename: 'TableOfContentsItemAttribute', id: string } | { __typename: 'TableOfContentsPageNumberAttribute', id: string } | { __typename: 'TextAttribute', id: string }> };

export type UserAvatarFragment = { __typename?: 'User', id: string, username: string, avatarUrl?: string | null };

export const AttributeDeleteButtonFragmentDoc = gql`
    fragment AttributeDeleteButton on Attribute {
  id
}
    `;
export const UserAvatarFragmentDoc = gql`
    fragment UserAvatar on User {
  id
  username
  avatarUrl
}
    `;
export const DocumentExportArtifactOptionsFragmentDoc = gql`
    fragment DocumentExportArtifactOptions on Artifact {
  id
  downloadUrl
  exporter
  source {
    id
    name
  }
}
    `;
export const DocumentExportArtifactFragmentDoc = gql`
    fragment DocumentExportArtifact on Artifact {
  id
  progress
  createdAt
  createdBy {
    id
    username
    ...UserAvatar
  }
  ...DocumentExportArtifactOptions
}
    ${UserAvatarFragmentDoc}
${DocumentExportArtifactOptionsFragmentDoc}`;
export const DocumentShareCollaboratorFragmentDoc = gql`
    fragment DocumentShareCollaborator on User {
  id
  username
  ...UserAvatar
}
    ${UserAvatarFragmentDoc}`;
export const DocumentShareComboxboxFragmentDoc = gql`
    fragment DocumentShareComboxbox on UserConnection {
  users {
    id
    username
    ...DocumentShareCollaborator
  }
}
    ${DocumentShareCollaboratorFragmentDoc}`;
export const DocumentSharePermissionFragmentDoc = gql`
    fragment DocumentSharePermission on Membership {
  document {
    id
  }
  user {
    id
  }
  permission
}
    `;
export const DocumentTagsFragmentDoc = gql`
    fragment DocumentTags on Document {
  id
  tags
}
    `;
export const DocumentNameTableCellFragmentDoc = gql`
    fragment DocumentNameTableCell on Document {
  id
  name
  members {
    total
  }
  ...DocumentTags
}
    ${DocumentTagsFragmentDoc}`;
export const DocumentTagsTableCellFragmentDoc = gql`
    fragment DocumentTagsTableCell on Document {
  id
  ...DocumentTags
}
    ${DocumentTagsFragmentDoc}`;
export const DocumentUploadedByTableCellFragmentDoc = gql`
    fragment DocumentUploadedByTableCell on Document {
  id
  uploadedBy {
    id
    username
    ...UserAvatar
  }
}
    ${UserAvatarFragmentDoc}`;
export const DocumentUploadedAtTableCellFragmentDoc = gql`
    fragment DocumentUploadedAtTableCell on Document {
  id
  uploadedAt
}
    `;
export const DocumentModifiedByTableCellFragmentDoc = gql`
    fragment DocumentModifiedByTableCell on Document {
  id
  lastModifiedBy {
    id
    username
    ...UserAvatar
  }
}
    ${UserAvatarFragmentDoc}`;
export const DocumentModifiedAtTableCellFragmentDoc = gql`
    fragment DocumentModifiedAtTableCell on Document {
  id
  lastModifiedAt
}
    `;
export const DocumentExtensionTableCellFragmentDoc = gql`
    fragment DocumentExtensionTableCell on Document {
  id
  extension
}
    `;
export const DocumentTagsDialogContentFragmentDoc = gql`
    fragment DocumentTagsDialogContent on Document {
  id
}
    `;
export const DocumentTagsDropdownMenuItemFragmentDoc = gql`
    fragment DocumentTagsDropdownMenuItem on Document {
  id
  ...DocumentTagsDialogContent
}
    ${DocumentTagsDialogContentFragmentDoc}`;
export const DocumentShareDialogContentFragmentDoc = gql`
    fragment DocumentShareDialogContent on Document {
  id
}
    `;
export const DocumentShareDrowdownMenuItemFragmentDoc = gql`
    fragment DocumentShareDrowdownMenuItem on Document {
  id
  ...DocumentShareDialogContent
}
    ${DocumentShareDialogContentFragmentDoc}`;
export const DocumentRenameDialogContentFragmentDoc = gql`
    fragment DocumentRenameDialogContent on Document {
  id
  name
}
    `;
export const DocumentRenameDropdownMenuItemFragmentDoc = gql`
    fragment DocumentRenameDropdownMenuItem on Document {
  id
  ...DocumentRenameDialogContent
}
    ${DocumentRenameDialogContentFragmentDoc}`;
export const DocumentExportDialogContentFragmentDoc = gql`
    fragment DocumentExportDialogContent on Document {
  id
}
    `;
export const DocumentExportDropdownMenuItemFragmentDoc = gql`
    fragment DocumentExportDropdownMenuItem on Document {
  id
  ...DocumentExportDialogContent
}
    ${DocumentExportDialogContentFragmentDoc}`;
export const DocumentDeleteDialogContentFragmentDoc = gql`
    fragment DocumentDeleteDialogContent on Document {
  id
  name
}
    `;
export const DocumentDeleteDropdownMenuItemFragmentDoc = gql`
    fragment DocumentDeleteDropdownMenuItem on Document {
  id
  ...DocumentDeleteDialogContent
}
    ${DocumentDeleteDialogContentFragmentDoc}`;
export const DocumentTableActionsDropdownMenuFragmentDoc = gql`
    fragment DocumentTableActionsDropdownMenu on Document {
  id
  ...DocumentTagsDropdownMenuItem
  ...DocumentShareDrowdownMenuItem
  ...DocumentRenameDropdownMenuItem
  ...DocumentExportDropdownMenuItem
  ...DocumentDeleteDropdownMenuItem
}
    ${DocumentTagsDropdownMenuItemFragmentDoc}
${DocumentShareDrowdownMenuItemFragmentDoc}
${DocumentRenameDropdownMenuItemFragmentDoc}
${DocumentExportDropdownMenuItemFragmentDoc}
${DocumentDeleteDropdownMenuItemFragmentDoc}`;
export const DocumentRowFragmentDoc = gql`
    fragment DocumentRow on Membership {
  document {
    id
    ...DocumentNameTableCell
    ...DocumentTagsTableCell
    ...DocumentUploadedByTableCell
    ...DocumentUploadedAtTableCell
    ...DocumentModifiedByTableCell
    ...DocumentModifiedAtTableCell
    ...DocumentExtensionTableCell
    ...DocumentTableActionsDropdownMenu
  }
}
    ${DocumentNameTableCellFragmentDoc}
${DocumentTagsTableCellFragmentDoc}
${DocumentUploadedByTableCellFragmentDoc}
${DocumentUploadedAtTableCellFragmentDoc}
${DocumentModifiedByTableCellFragmentDoc}
${DocumentModifiedAtTableCellFragmentDoc}
${DocumentExtensionTableCellFragmentDoc}
${DocumentTableActionsDropdownMenuFragmentDoc}`;
export const DocumentTableToolbarFragmentDoc = gql`
    fragment DocumentTableToolbar on MembershipConnection {
  memberships {
    document {
      id
      tags
      extension
      uploadedBy {
        id
        username
      }
    }
    user {
      id
    }
  }
}
    `;
export const DocumentTableFragmentDoc = gql`
    fragment DocumentTable on MembershipConnection {
  memberships {
    document {
      id
    }
    user {
      id
    }
    ...DocumentRow
  }
  ...DocumentTableToolbar
}
    ${DocumentRowFragmentDoc}
${DocumentTableToolbarFragmentDoc}`;
export const DocumentTagsInputFragmentDoc = gql`
    fragment DocumentTagsInput on Document {
  id
  tags
}
    `;
export const DocumentTagsSuggestionsFragmentDoc = gql`
    fragment DocumentTagsSuggestions on Document {
  id
  possibleTags
}
    `;
export const NavbarExportTabContentFragmentDoc = gql`
    fragment NavbarExportTabContent on Document {
  id
}
    `;
export const MetadataLanguageAccordionItemFragmentDoc = gql`
    fragment MetadataLanguageAccordionItem on Document {
  id
  metadata {
    document {
      id
    }
    language
  }
}
    `;
export const MetadataTitleAccordionItemFragmentDoc = gql`
    fragment MetadataTitleAccordionItem on Document {
  id
  metadata {
    document {
      id
    }
    titles {
      id
      title
      language
    }
  }
}
    `;
export const MetadataAuthorAccordionItemFragmentDoc = gql`
    fragment MetadataAuthorAccordionItem on Document {
  id
  metadata {
    document {
      id
    }
    authors {
      id
      name
    }
  }
}
    `;
export const MetadataKeywordAccordionItemFragmentDoc = gql`
    fragment MetadataKeywordAccordionItem on Document {
  id
  metadata {
    document {
      id
    }
    subject {
      id
      subject
    }
  }
}
    `;
export const MetadataDateAccordionItemFragmentDoc = gql`
    fragment MetadataDateAccordionItem on Document {
  id
  metadata {
    document {
      id
    }
    date
  }
}
    `;
export const NavbarMetadataTabContentFragmentDoc = gql`
    fragment NavbarMetadataTabContent on Document {
  id
  ...MetadataLanguageAccordionItem
  ...MetadataTitleAccordionItem
  ...MetadataAuthorAccordionItem
  ...MetadataKeywordAccordionItem
  ...MetadataDateAccordionItem
}
    ${MetadataLanguageAccordionItemFragmentDoc}
${MetadataTitleAccordionItemFragmentDoc}
${MetadataAuthorAccordionItemFragmentDoc}
${MetadataKeywordAccordionItemFragmentDoc}
${MetadataDateAccordionItemFragmentDoc}`;
export const NavbarNextPageButtonFragmentDoc = gql`
    fragment NavbarNextPageButton on Page {
  id
  document {
    id
  }
  nextPage {
    id
  }
}
    `;
export const NavbarOverviewButtonFragmentDoc = gql`
    fragment NavbarOverviewButton on Document {
  id
}
    `;
export const PageNumberBadgeFragmentDoc = gql`
    fragment PageNumberBadge on Page {
  id
  index
}
    `;
export const PageThumbnailFragmentDoc = gql`
    fragment PageThumbnail on Page {
  id
  pngUrl
  width
  height
  document {
    id
  }
  ...PageNumberBadge
}
    ${PageNumberBadgeFragmentDoc}`;
export const PageIssuesBadgeFragmentDoc = gql`
    fragment PageIssuesBadge on Page {
  id
  issues {
    id
  }
}
    `;
export const PagePaginationFragmentDoc = gql`
    fragment PagePagination on Page {
  id
  index
  document {
    id
    pages {
      total
      pages {
        id
        index
      }
    }
  }
}
    `;
export const NavbarPagesTabContentFragmentDoc = gql`
    fragment NavbarPagesTabContent on Page {
  id
  document {
    id
    pages {
      total
      pages {
        id
        ...PageThumbnail
        ...PageIssuesBadge
      }
    }
  }
  ...PagePagination
}
    ${PageThumbnailFragmentDoc}
${PageIssuesBadgeFragmentDoc}
${PagePaginationFragmentDoc}`;
export const NavbarPreviousPageButtonFragmentDoc = gql`
    fragment NavbarPreviousPageButton on Page {
  id
  document {
    id
  }
  previousPage {
    id
  }
}
    `;
export const RegionTableDataFragmentDoc = gql`
    fragment RegionTableData on Region {
  id
  shape {
    aabb {
      top
      left
      width
      height
    }
  }
  attributes {
    ... on TableAttribute {
      id
      rows
      columns
    }
  }
  page {
    id
    width
    height
    regions {
      id
      shape {
        aabb {
          top
          left
          width
          height
        }
      }
      attributes {
        id
        ... on TableHeaderCellAttribute {
          scopes {
            type
            link
          }
        }
        ... on TableCellAttribute {
          rowSpan
          columnSpan
        }
      }
    }
  }
}
    `;
export const RegionContextMenuContentFragmentDoc = gql`
    fragment RegionContextMenuContent on Region {
  id
  ...RegionTableData
}
    ${RegionTableDataFragmentDoc}`;
export const RegionShortcutsHandlerFragmentDoc = gql`
    fragment RegionShortcutsHandler on Region {
  id
  ...RegionTableData
}
    ${RegionTableDataFragmentDoc}`;
export const RegionIssuesBadgeFragmentDoc = gql`
    fragment RegionIssuesBadge on Region {
  id
  issues {
    id
  }
}
    `;
export const RegionImageFragmentDoc = gql`
    fragment RegionImage on Region {
  id
  shape {
    aabb {
      top
      left
      width
      height
    }
    vertices {
      top
      left
    }
  }
  page {
    id
    width
    height
    svgUrl
  }
}
    `;
export const RegionTypeFragmentDoc = gql`
    fragment RegionType on Region {
  id
  attributes {
    __typename
    id
  }
}
    `;
export const RegionThumbnailFragmentDoc = gql`
    fragment RegionThumbnail on Region {
  id
  shape {
    aabb {
      width
      height
    }
  }
  page {
    id
    width
    height
  }
  ...RegionImage
  ...RegionType
}
    ${RegionImageFragmentDoc}
${RegionTypeFragmentDoc}`;
export const RegionNameFragmentDoc = gql`
    fragment RegionName on Region {
  id
  readingOrderIndex
  ...RegionType
}
    ${RegionTypeFragmentDoc}`;
export const RegionTileFragmentDoc = gql`
    fragment RegionTile on Region {
  id
  ...RegionName
}
    ${RegionNameFragmentDoc}`;
export const ArtifactRegionTileFragmentDoc = gql`
    fragment ArtifactRegionTile on Region {
  id
  attributes {
    id
    ... on PaginationArtifactAttribute {
      type
    }
  }
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const CaptionRegionTileFragmentDoc = gql`
    fragment CaptionRegionTile on Region {
  id
  attributes {
    id
    ... on TextAttribute {
      text
    }
  }
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const FigureRegionTileFragmentDoc = gql`
    fragment FigureRegionTile on Region {
  id
  attributes {
    id
  }
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const FormulaRegionTileFragmentDoc = gql`
    fragment FormulaRegionTile on Region {
  id
  attributes {
    id
    ... on ExpressionAttribute {
      expressionLatex
    }
  }
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const HeadingRegionTileFragmentDoc = gql`
    fragment HeadingRegionTile on Region {
  id
  attributes {
    id
    ... on HeaderLevelAttribute {
      level
    }
    ... on TextAttribute {
      text
    }
  }
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const HybridRegionTileFragmentDoc = gql`
    fragment HybridRegionTile on Region {
  id
  attributes {
    __typename
    id
  }
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const ImageRegionTileFragmentDoc = gql`
    fragment ImageRegionTile on Region {
  id
  attributes {
    id
    ... on AlternativeTextAttribute {
      alternativeText
    }
  }
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const ListRegionTileFragmentDoc = gql`
    fragment ListRegionTile on Region {
  id
  attributes {
    id
    ... on ListAttribute {
      listType
    }
  }
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const ListItemRegionTileFragmentDoc = gql`
    fragment ListItemRegionTile on Region {
  id
  attributes {
    id
    ... on ListItemAttribute {
      ordinal
    }
    ... on TextAttribute {
      text
    }
  }
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const SublistRegionTileFragmentDoc = gql`
    fragment SublistRegionTile on Region {
  id
  attributes {
    id
    ... on ListItemAttribute {
      ordinal
    }
    ... on ListAttribute {
      listType
    }
  }
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const TableRegionTileFragmentDoc = gql`
    fragment TableRegionTile on Region {
  id
  attributes {
    id
    ... on TableAttribute {
      rows
      columns
    }
  }
  ...RegionTile
  ...RegionTableData
}
    ${RegionTileFragmentDoc}
${RegionTableDataFragmentDoc}`;
export const TextRegionTileFragmentDoc = gql`
    fragment TextRegionTile on Region {
  id
  attributes {
    id
    ... on TextAttribute {
      text
    }
  }
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const TocRegionTileFragmentDoc = gql`
    fragment TOCRegionTile on Region {
  id
  attributes {
    id
  }
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const UntypedRegionTileFragmentDoc = gql`
    fragment UntypedRegionTile on Region {
  id
  ...RegionTile
}
    ${RegionTileFragmentDoc}`;
export const RegionTileSwitchFragmentDoc = gql`
    fragment RegionTileSwitch on Region {
  id
  ...RegionType
  ...ArtifactRegionTile
  ...CaptionRegionTile
  ...FigureRegionTile
  ...FormulaRegionTile
  ...HeadingRegionTile
  ...HybridRegionTile
  ...ImageRegionTile
  ...ListRegionTile
  ...ListItemRegionTile
  ...SublistRegionTile
  ...TableRegionTile
  ...TextRegionTile
  ...TOCRegionTile
  ...UntypedRegionTile
}
    ${RegionTypeFragmentDoc}
${ArtifactRegionTileFragmentDoc}
${CaptionRegionTileFragmentDoc}
${FigureRegionTileFragmentDoc}
${FormulaRegionTileFragmentDoc}
${HeadingRegionTileFragmentDoc}
${HybridRegionTileFragmentDoc}
${ImageRegionTileFragmentDoc}
${ListRegionTileFragmentDoc}
${ListItemRegionTileFragmentDoc}
${SublistRegionTileFragmentDoc}
${TableRegionTileFragmentDoc}
${TextRegionTileFragmentDoc}
${TocRegionTileFragmentDoc}
${UntypedRegionTileFragmentDoc}`;
export const RegionCardFragmentDoc = gql`
    fragment RegionCard on Region {
  id
  ...RegionContextMenuContent
  ...RegionShortcutsHandler
  ...RegionIssuesBadge
  ...RegionThumbnail
  ...RegionTileSwitch
}
    ${RegionContextMenuContentFragmentDoc}
${RegionShortcutsHandlerFragmentDoc}
${RegionIssuesBadgeFragmentDoc}
${RegionThumbnailFragmentDoc}
${RegionTileSwitchFragmentDoc}`;
export const NavbarRegionsTabContentFragmentDoc = gql`
    fragment NavbarRegionsTabContent on Page {
  id
  available
  regions {
    id
    readingOrderIndex
    ...RegionCard
  }
}
    ${RegionCardFragmentDoc}`;
export const PageSkeletonFragmentDoc = gql`
    fragment PageSkeleton on Page {
  id
  width
  height
  regions {
    id
    shape {
      aabb {
        top
        left
        width
        height
      }
    }
  }
}
    `;
export const PageFragmentDoc = gql`
    fragment Page on Page {
  id
  width
  height
  svgUrl
  ...PageSkeleton
}
    ${PageSkeletonFragmentDoc}`;
export const PageMinimapFragmentDoc = gql`
    fragment PageMinimap on Page {
  id
  index
  ...Page
}
    ${PageFragmentDoc}`;
export const RegionSelectionHandlerFragmentDoc = gql`
    fragment RegionSelectionHandler on Region {
  id
}
    `;
export const RegionLabelFragmentDoc = gql`
    fragment RegionLabel on Region {
  id
  shape {
    vertices {
      top
      left
    }
  }
  page {
    id
    width
    height
  }
  ...RegionType
  ...RegionName
}
    ${RegionTypeFragmentDoc}
${RegionNameFragmentDoc}`;
export const RegionPolygonFragmentDoc = gql`
    fragment RegionPolygon on Region {
  id
  shape {
    vertices {
      top
      left
    }
  }
  readingOrderIndex
  ...RegionType
}
    ${RegionTypeFragmentDoc}`;
export const TransformableRegionFragmentDoc = gql`
    fragment TransformableRegion on Region {
  id
  page {
    id
    width
    height
  }
  shape {
    aabb {
      top
      left
      width
      height
    }
    vertices {
      left
      top
    }
  }
  ...RegionContextMenuContent
  ...RegionShortcutsHandler
  ...RegionSelectionHandler
  ...RegionLabel
  ...RegionPolygon
}
    ${RegionContextMenuContentFragmentDoc}
${RegionShortcutsHandlerFragmentDoc}
${RegionSelectionHandlerFragmentDoc}
${RegionLabelFragmentDoc}
${RegionPolygonFragmentDoc}`;
export const ReshapeableRegionFragmentDoc = gql`
    fragment ReshapeableRegion on Region {
  id
  page {
    id
    width
    height
  }
  shape {
    vertices {
      left
      top
    }
  }
  ...RegionContextMenuContent
  ...RegionShortcutsHandler
  ...RegionSelectionHandler
  ...RegionLabel
  ...RegionPolygon
}
    ${RegionContextMenuContentFragmentDoc}
${RegionShortcutsHandlerFragmentDoc}
${RegionSelectionHandlerFragmentDoc}
${RegionLabelFragmentDoc}
${RegionPolygonFragmentDoc}`;
export const RegionsToolOverlayFragmentDoc = gql`
    fragment RegionsToolOverlay on Page {
  id
  width
  height
  regions {
    id
    shape {
      aabb {
        width
        height
      }
    }
    ...TransformableRegion
    ...ReshapeableRegion
  }
}
    ${TransformableRegionFragmentDoc}
${ReshapeableRegionFragmentDoc}`;
export const PageOverlayFragmentDoc = gql`
    fragment PageOverlay on Page {
  id
  ...RegionsToolOverlay
}
    ${RegionsToolOverlayFragmentDoc}`;
export const PageEditorFragmentDoc = gql`
    fragment PageEditor on Page {
  id
  document {
    id
  }
  nextPage {
    id
  }
  previousPage {
    id
  }
  ...PageMinimap
  ...PageOverlay
  ...Page
}
    ${PageMinimapFragmentDoc}
${PageOverlayFragmentDoc}
${PageFragmentDoc}`;
export const RefNodeFragmentDoc = gql`
    fragment RefNode on Page {
  id
  regions {
    id
    ...RegionType
    ...RegionName
    ...RegionThumbnail
  }
}
    ${RegionTypeFragmentDoc}
${RegionNameFragmentDoc}
${RegionThumbnailFragmentDoc}`;
export const ExtensionFootnoteRefFragmentDoc = gql`
    fragment ExtensionFootnoteRef on Page {
  id
  ...RefNode
}
    ${RefNodeFragmentDoc}`;
export const ExtensionFormulaRefFragmentDoc = gql`
    fragment ExtensionFormulaRef on Page {
  id
  ...RefNode
}
    ${RefNodeFragmentDoc}`;
export const RegionIssueAlertFragmentDoc = gql`
    fragment RegionIssueAlert on Issue {
  id
  type
}
    `;
export const RegionIssueAlertsFragmentDoc = gql`
    fragment RegionIssueAlerts on Region {
  id
  issues {
    id
    ...RegionIssueAlert
  }
}
    ${RegionIssueAlertFragmentDoc}`;
export const RegionUpdateTabFragmentDoc = gql`
    fragment RegionUpdateTab on Region {
  id
  issues {
    id
  }
  ...RegionName
  ...RegionIssueAlerts
}
    ${RegionNameFragmentDoc}
${RegionIssueAlertsFragmentDoc}`;
export const ArtifactRegionCreationTabFragmentDoc = gql`
    fragment ArtifactRegionCreationTab on Region {
  id
  attributes {
    id
  }
}
    `;
export const ArtifactRegionTypeCardFragmentDoc = gql`
    fragment ArtifactRegionTypeCard on Region {
  id
}
    `;
export const CaptionRegionCreationTabFragmentDoc = gql`
    fragment CaptionRegionCreationTab on Region {
  id
  attributes {
    id
  }
}
    `;
export const CaptionRegionTypeCardFragmentDoc = gql`
    fragment CaptionRegionTypeCard on Region {
  id
}
    `;
export const FigureRegionCreationTabFragmentDoc = gql`
    fragment FigureRegionCreationTab on Region {
  id
  attributes {
    id
  }
}
    `;
export const FigureRegionTypeCardFragmentDoc = gql`
    fragment FigureRegionTypeCard on Region {
  id
}
    `;
export const FormulaRegionCreationTabFragmentDoc = gql`
    fragment FormulaRegionCreationTab on Region {
  id
  attributes {
    id
  }
}
    `;
export const FormulaRegionTypeCardFragmentDoc = gql`
    fragment FormulaRegionTypeCard on Region {
  id
}
    `;
export const HeadingRegionCreationTabFragmentDoc = gql`
    fragment HeadingRegionCreationTab on Region {
  id
  attributes {
    id
  }
}
    `;
export const HeadingRegionTypeCardFragmentDoc = gql`
    fragment HeadingRegionTypeCard on Region {
  id
}
    `;
export const AlternativeTextPredictionButtonFragmentDoc = gql`
    fragment AlternativeTextPredictionButton on Region {
  id
  document {
    id
    metadata {
      document {
        id
      }
      language
    }
  }
  page {
    id
    pngUrl
  }
  shape {
    aabb {
      top
      left
      width
      height
    }
  }
}
    `;
export const AlternativeTextFormFieldFragmentDoc = gql`
    fragment AlternativeTextFormField on Region {
  id
  ...AlternativeTextPredictionButton
}
    ${AlternativeTextPredictionButtonFragmentDoc}`;
export const AlternativeTextCreationPanelFragmentDoc = gql`
    fragment AlternativeTextCreationPanel on Region {
  id
  ...AlternativeTextFormField
}
    ${AlternativeTextFormFieldFragmentDoc}`;
export const RegionSelectContentFragmentDoc = gql`
    fragment RegionSelectContent on Region {
  id
  page {
    id
  }
  document {
    id
    pages {
      pages {
        id
        index
        regions {
          id
          attributes {
            id
          }
          ...RegionThumbnail
        }
      }
    }
  }
}
    ${RegionThumbnailFragmentDoc}`;
export const CaptionFormFieldFragmentDoc = gql`
    fragment CaptionFormField on Region {
  id
  ...RegionSelectContent
}
    ${RegionSelectContentFragmentDoc}`;
export const CaptionCreationPanelFragmentDoc = gql`
    fragment CaptionCreationPanel on Region {
  id
  ...CaptionFormField
}
    ${CaptionFormFieldFragmentDoc}`;
export const ExcludeReadingOrderCreationPanelFragmentDoc = gql`
    fragment ExcludeReadingOrderCreationPanel on Region {
  id
}
    `;
export const ExpressionReferenceFormFieldFragmentDoc = gql`
    fragment ExpressionReferenceFormField on Region {
  id
  ...RegionImage
}
    ${RegionImageFragmentDoc}`;
export const ExpressionPredictionButtonFragmentDoc = gql`
    fragment ExpressionPredictionButton on Region {
  id
  page {
    id
    pngUrl
  }
  shape {
    aabb {
      top
      left
      width
      height
    }
  }
}
    `;
export const ExpressionFormFieldFragmentDoc = gql`
    fragment ExpressionFormField on Region {
  id
  ...ExpressionPredictionButton
}
    ${ExpressionPredictionButtonFragmentDoc}`;
export const ExpressionCreationPanelFragmentDoc = gql`
    fragment ExpressionCreationPanel on Region {
  id
  ...ExpressionReferenceFormField
  ...ExpressionFormField
}
    ${ExpressionReferenceFormFieldFragmentDoc}
${ExpressionFormFieldFragmentDoc}`;
export const FigureCreationPanelFragmentDoc = gql`
    fragment FigureCreationPanel on Region {
  id
}
    `;
export const HeadingLevelCreationPanelFragmentDoc = gql`
    fragment HeadingLevelCreationPanel on Region {
  id
}
    `;
export const ImageCreationPanelFragmentDoc = gql`
    fragment ImageCreationPanel on Region {
  id
}
    `;
export const ListCreationPanelFragmentDoc = gql`
    fragment ListCreationPanel on Region {
  id
}
    `;
export const ListItemCreationPanelFragmentDoc = gql`
    fragment ListItemCreationPanel on Region {
  id
}
    `;
export const ListItemLabelCreationPanelFragmentDoc = gql`
    fragment ListItemLabelCreationPanel on Region {
  id
}
    `;
export const PaginationArtifactCreationPanelFragmentDoc = gql`
    fragment PaginationArtifactCreationPanel on Region {
  id
}
    `;
export const TableCreationPanelFragmentDoc = gql`
    fragment TableCreationPanel on Region {
  id
}
    `;
export const TableCellCreationPanelFragmentDoc = gql`
    fragment TableCellCreationPanel on Region {
  id
}
    `;
export const TableHeaderCellCreationPanelFragmentDoc = gql`
    fragment TableHeaderCellCreationPanel on Region {
  id
}
    `;
export const TableOfContentsCreationPanelFragmentDoc = gql`
    fragment TableOfContentsCreationPanel on Region {
  id
}
    `;
export const TableOfContentsHeadingCreationPanelFragmentDoc = gql`
    fragment TableOfContentsHeadingCreationPanel on Region {
  id
}
    `;
export const TableOfContentsItemFormFieldFragmentDoc = gql`
    fragment TableOfContentsItemFormField on Region {
  id
  ...RegionSelectContent
}
    ${RegionSelectContentFragmentDoc}`;
export const TableOfContentsItemCreationPanelFragmentDoc = gql`
    fragment TableOfContentsItemCreationPanel on Region {
  id
  ...TableOfContentsItemFormField
}
    ${TableOfContentsItemFormFieldFragmentDoc}`;
export const TableOfContentsPageNumberCreationPanelFragmentDoc = gql`
    fragment TableOfContentsPageNumberCreationPanel on Region {
  id
}
    `;
export const FormulaRefPickerFragmentDoc = gql`
    fragment FormulaRefPicker on Page {
  id
  regions {
    id
    attributes {
      id
      ... on ExpressionAttribute {
        expressionLatex
      }
    }
    ...RegionName
    ...RegionThumbnail
  }
}
    ${RegionNameFragmentDoc}
${RegionThumbnailFragmentDoc}`;
export const FootnoteRefPickerFragmentDoc = gql`
    fragment FootnoteRefPicker on Page {
  id
  regions {
    id
    attributes {
      id
      ... on FootnoteAttribute {
        ordinal
      }
    }
    ...RegionName
    ...RegionThumbnail
  }
}
    ${RegionNameFragmentDoc}
${RegionThumbnailFragmentDoc}`;
export const RichTextToolbarFragmentDoc = gql`
    fragment RichTextToolbar on Page {
  id
  ...FormulaRefPicker
  ...FootnoteRefPicker
}
    ${FormulaRefPickerFragmentDoc}
${FootnoteRefPickerFragmentDoc}`;
export const TextPredictionButtonFragmentDoc = gql`
    fragment TextPredictionButton on Region {
  id
  page {
    id
    pngUrl
  }
  shape {
    aabb {
      top
      left
      width
      height
    }
  }
}
    `;
export const TextFormFieldFragmentDoc = gql`
    fragment TextFormField on Region {
  id
  page {
    id
    ...RichTextToolbar
  }
  ...TextPredictionButton
}
    ${RichTextToolbarFragmentDoc}
${TextPredictionButtonFragmentDoc}`;
export const TextCreationPanelFragmentDoc = gql`
    fragment TextCreationPanel on Region {
  id
  ...TextFormField
}
    ${TextFormFieldFragmentDoc}`;
export const AttributeCreationSectionFragmentDoc = gql`
    fragment AttributeCreationSection on Region {
  id
  ...AlternativeTextCreationPanel
  ...CaptionCreationPanel
  ...ExcludeReadingOrderCreationPanel
  ...ExpressionCreationPanel
  ...FigureCreationPanel
  ...HeadingLevelCreationPanel
  ...ImageCreationPanel
  ...ListCreationPanel
  ...ListItemCreationPanel
  ...ListItemLabelCreationPanel
  ...PaginationArtifactCreationPanel
  ...TableCreationPanel
  ...TableCellCreationPanel
  ...TableHeaderCellCreationPanel
  ...TableOfContentsCreationPanel
  ...TableOfContentsHeadingCreationPanel
  ...TableOfContentsItemCreationPanel
  ...TableOfContentsPageNumberCreationPanel
  ...TextCreationPanel
}
    ${AlternativeTextCreationPanelFragmentDoc}
${CaptionCreationPanelFragmentDoc}
${ExcludeReadingOrderCreationPanelFragmentDoc}
${ExpressionCreationPanelFragmentDoc}
${FigureCreationPanelFragmentDoc}
${HeadingLevelCreationPanelFragmentDoc}
${ImageCreationPanelFragmentDoc}
${ListCreationPanelFragmentDoc}
${ListItemCreationPanelFragmentDoc}
${ListItemLabelCreationPanelFragmentDoc}
${PaginationArtifactCreationPanelFragmentDoc}
${TableCreationPanelFragmentDoc}
${TableCellCreationPanelFragmentDoc}
${TableHeaderCellCreationPanelFragmentDoc}
${TableOfContentsCreationPanelFragmentDoc}
${TableOfContentsHeadingCreationPanelFragmentDoc}
${TableOfContentsItemCreationPanelFragmentDoc}
${TableOfContentsPageNumberCreationPanelFragmentDoc}
${TextCreationPanelFragmentDoc}`;
export const AlternativeTextUpdatePanelFragmentDoc = gql`
    fragment AlternativeTextUpdatePanel on AlternativeTextAttribute {
  id
  alternativeText
  region {
    id
    ...AlternativeTextFormField
  }
}
    ${AlternativeTextFormFieldFragmentDoc}`;
export const CaptionUpdatePanelFragmentDoc = gql`
    fragment CaptionUpdatePanel on CaptionAttribute {
  id
  linkedRegion {
    id
  }
  region {
    id
    ...CaptionFormField
  }
}
    ${CaptionFormFieldFragmentDoc}`;
export const ExcludeReadingOrderUpdatePanelFragmentDoc = gql`
    fragment ExcludeReadingOrderUpdatePanel on ExcludeReadingOrderAttribute {
  id
}
    `;
export const ExpressionUpdatePanelFragmentDoc = gql`
    fragment ExpressionUpdatePanel on ExpressionAttribute {
  id
  expressionLatex
  region {
    id
    ...ExpressionReferenceFormField
    ...ExpressionFormField
  }
}
    ${ExpressionReferenceFormFieldFragmentDoc}
${ExpressionFormFieldFragmentDoc}`;
export const FigureUpdatePanelFragmentDoc = gql`
    fragment FigureUpdatePanel on FigureAttribute {
  id
}
    `;
export const HeadingLevelUpdatePanelFragmentDoc = gql`
    fragment HeadingLevelUpdatePanel on HeaderLevelAttribute {
  id
  level
}
    `;
export const ImageUpdatePanelFragmentDoc = gql`
    fragment ImageUpdatePanel on ImageAttribute {
  id
}
    `;
export const ListUpdatePanelFragmentDoc = gql`
    fragment ListUpdatePanel on ListAttribute {
  id
  listType
}
    `;
export const ListItemUpdatePanelFragmentDoc = gql`
    fragment ListItemUpdatePanel on ListItemAttribute {
  id
  ordinal
}
    `;
export const ListItemLabelUpdatePanelFragmentDoc = gql`
    fragment ListItemLabelUpdatePanel on ListItemLabelAttribute {
  id
}
    `;
export const PaginationArtifactUpdatePanelFragmentDoc = gql`
    fragment PaginationArtifactUpdatePanel on PaginationArtifactAttribute {
  id
  type
}
    `;
export const TableUpdatePanelFragmentDoc = gql`
    fragment TableUpdatePanel on TableAttribute {
  id
  parentRowOffset
  parentColumnOffset
  rows
  columns
}
    `;
export const TableCellUpdatePanelFragmentDoc = gql`
    fragment TableCellUpdatePanel on TableCellAttribute {
  id
  rowSpan
  columnSpan
}
    `;
export const TableHeaderCellUpdatePanelFragmentDoc = gql`
    fragment TableHeaderCellUpdatePanel on TableHeaderCellAttribute {
  id
}
    `;
export const TableOfContentsUpdatePanelFragmentDoc = gql`
    fragment TableOfContentsUpdatePanel on TableOfContentsAttribute {
  id
}
    `;
export const TableOfContentsHeadingUpdatePanelFragmentDoc = gql`
    fragment TableOfContentsHeadingUpdatePanel on TableOfContentsHeadingAttribute {
  id
}
    `;
export const TableOfContentsItemUpdatePanelFragmentDoc = gql`
    fragment TableOfContentsItemUpdatePanel on TableOfContentsItemAttribute {
  id
  linkedRegion {
    id
  }
  region {
    id
    ...TableOfContentsItemFormField
  }
}
    ${TableOfContentsItemFormFieldFragmentDoc}`;
export const TableOfContentsPageNumberUpdatePanelFragmentDoc = gql`
    fragment TableOfContentsPageNumberUpdatePanel on TableOfContentsPageNumberAttribute {
  id
}
    `;
export const TextUpdatePanelFragmentDoc = gql`
    fragment TextUpdatePanel on TextAttribute {
  id
  text
  region {
    id
    ...TextFormField
  }
}
    ${TextFormFieldFragmentDoc}`;
export const AttributeUpdateSectionFragmentDoc = gql`
    fragment AttributeUpdateSection on Region {
  id
  attributes {
    id
    ...AlternativeTextUpdatePanel
    ...CaptionUpdatePanel
    ...ExcludeReadingOrderUpdatePanel
    ...ExpressionUpdatePanel
    ...FigureUpdatePanel
    ...HeadingLevelUpdatePanel
    ...ImageUpdatePanel
    ...ListUpdatePanel
    ...ListItemUpdatePanel
    ...ListItemLabelUpdatePanel
    ...PaginationArtifactUpdatePanel
    ...TableUpdatePanel
    ...TableCellUpdatePanel
    ...TableHeaderCellUpdatePanel
    ...TableOfContentsUpdatePanel
    ...TableOfContentsHeadingUpdatePanel
    ...TableOfContentsItemUpdatePanel
    ...TableOfContentsPageNumberUpdatePanel
    ...TextUpdatePanel
  }
}
    ${AlternativeTextUpdatePanelFragmentDoc}
${CaptionUpdatePanelFragmentDoc}
${ExcludeReadingOrderUpdatePanelFragmentDoc}
${ExpressionUpdatePanelFragmentDoc}
${FigureUpdatePanelFragmentDoc}
${HeadingLevelUpdatePanelFragmentDoc}
${ImageUpdatePanelFragmentDoc}
${ListUpdatePanelFragmentDoc}
${ListItemUpdatePanelFragmentDoc}
${ListItemLabelUpdatePanelFragmentDoc}
${PaginationArtifactUpdatePanelFragmentDoc}
${TableUpdatePanelFragmentDoc}
${TableCellUpdatePanelFragmentDoc}
${TableHeaderCellUpdatePanelFragmentDoc}
${TableOfContentsUpdatePanelFragmentDoc}
${TableOfContentsHeadingUpdatePanelFragmentDoc}
${TableOfContentsItemUpdatePanelFragmentDoc}
${TableOfContentsPageNumberUpdatePanelFragmentDoc}
${TextUpdatePanelFragmentDoc}`;
export const HybridRegionCreationTabFragmentDoc = gql`
    fragment HybridRegionCreationTab on Region {
  id
}
    `;
export const HybridRegionTypeCardFragmentDoc = gql`
    fragment HybridRegionTypeCard on Region {
  id
}
    `;
export const ImageRegionCreationTabFragmentDoc = gql`
    fragment ImageRegionCreationTab on Region {
  id
  attributes {
    id
  }
}
    `;
export const ImageRegionTypeCardFragmentDoc = gql`
    fragment ImageRegionTypeCard on Region {
  id
}
    `;
export const ListItemRegionCreationTabFragmentDoc = gql`
    fragment ListItemRegionCreationTab on Region {
  id
  attributes {
    id
  }
}
    `;
export const ListItemRegionTypeCardFragmentDoc = gql`
    fragment ListItemRegionTypeCard on Region {
  id
}
    `;
export const ListRegionCreationTabFragmentDoc = gql`
    fragment ListRegionCreationTab on Region {
  id
  attributes {
    id
  }
}
    `;
export const ListRegionTypeCardFragmentDoc = gql`
    fragment ListRegionTypeCard on Region {
  id
}
    `;
export const SublistRegionCreationTabFragmentDoc = gql`
    fragment SublistRegionCreationTab on Region {
  id
  attributes {
    id
  }
}
    `;
export const SublistRegionTypeCardFragmentDoc = gql`
    fragment SublistRegionTypeCard on Region {
  id
}
    `;
export const TableRegionCreationTabFragmentDoc = gql`
    fragment TableRegionCreationTab on Region {
  id
}
    `;
export const TableRegionTypeCardFragmentDoc = gql`
    fragment TableRegionTypeCard on Region {
  id
  ...RegionTableData
}
    ${RegionTableDataFragmentDoc}`;
export const TableEditorStep1FragmentDoc = gql`
    fragment TableEditorStep1 on Page {
  id
  pngUrl
}
    `;
export const TableCellPreviewFragmentDoc = gql`
    fragment TableCellPreview on Page {
  id
  width
  height
  svgUrl
}
    `;
export const TableEditorStep6FragmentDoc = gql`
    fragment TableEditorStep6 on Page {
  id
  ...TableCellPreview
}
    ${TableCellPreviewFragmentDoc}`;
export const TableEditorFragmentDoc = gql`
    fragment TableEditor on Region {
  id
  page {
    ...TableEditorStep1
    ...TableEditorStep6
  }
}
    ${TableEditorStep1FragmentDoc}
${TableEditorStep6FragmentDoc}`;
export const TableRegionUpsertFormFragmentDoc = gql`
    fragment TableRegionUpsertForm on Region {
  id
  attributes {
    id
  }
  page {
    id
    width
    height
    regions {
      id
      shape {
        aabb {
          top
          left
          width
          height
        }
      }
      attributes {
        id
      }
    }
  }
  ...TableEditor
}
    ${TableEditorFragmentDoc}`;
export const TextRegionCreationTabFragmentDoc = gql`
    fragment TextRegionCreationTab on Region {
  id
  attributes {
    id
  }
}
    `;
export const TextRegionTypeCardFragmentDoc = gql`
    fragment TextRegionTypeCard on Region {
  id
}
    `;
export const TocRegionCreationTabFragmentDoc = gql`
    fragment TOCRegionCreationTab on Region {
  id
  attributes {
    id
  }
}
    `;
export const TocRegionTypeCardFragmentDoc = gql`
    fragment TOCRegionTypeCard on Region {
  id
}
    `;
export const DeleteAttributeDocument = gql`
    mutation DeleteAttribute($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteAttributeMutationFn = Apollo.MutationFunction<DeleteAttributeMutation, DeleteAttributeMutationVariables>;

/**
 * __useDeleteAttributeMutation__
 *
 * To run a mutation, you first call `useDeleteAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributeMutation, { data, loading, error }] = useDeleteAttributeMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteAttributeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributeMutation, DeleteAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributeMutation, DeleteAttributeMutationVariables>(DeleteAttributeDocument, options);
      }
export type DeleteAttributeMutationHookResult = ReturnType<typeof useDeleteAttributeMutation>;
export type DeleteAttributeMutationResult = Apollo.MutationResult<DeleteAttributeMutation>;
export type DeleteAttributeMutationOptions = Apollo.BaseMutationOptions<DeleteAttributeMutation, DeleteAttributeMutationVariables>;
export const CreateAlternativeTextFromPanelDocument = gql`
    mutation CreateAlternativeTextFromPanel($regionId: ID!, $alternativeText: String!) {
  createAlternativeTextAttribute(
    input: {regionId: $regionId, alternativeText: $alternativeText}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateAlternativeTextFromPanelMutationFn = Apollo.MutationFunction<CreateAlternativeTextFromPanelMutation, CreateAlternativeTextFromPanelMutationVariables>;

/**
 * __useCreateAlternativeTextFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateAlternativeTextFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlternativeTextFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlternativeTextFromPanelMutation, { data, loading, error }] = useCreateAlternativeTextFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      alternativeText: // value for 'alternativeText'
 *   },
 * });
 */
export function useCreateAlternativeTextFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlternativeTextFromPanelMutation, CreateAlternativeTextFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlternativeTextFromPanelMutation, CreateAlternativeTextFromPanelMutationVariables>(CreateAlternativeTextFromPanelDocument, options);
      }
export type CreateAlternativeTextFromPanelMutationHookResult = ReturnType<typeof useCreateAlternativeTextFromPanelMutation>;
export type CreateAlternativeTextFromPanelMutationResult = Apollo.MutationResult<CreateAlternativeTextFromPanelMutation>;
export type CreateAlternativeTextFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateAlternativeTextFromPanelMutation, CreateAlternativeTextFromPanelMutationVariables>;
export const DeleteAlternativeTextFromPanelDocument = gql`
    mutation DeleteAlternativeTextFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteAlternativeTextFromPanelMutationFn = Apollo.MutationFunction<DeleteAlternativeTextFromPanelMutation, DeleteAlternativeTextFromPanelMutationVariables>;

/**
 * __useDeleteAlternativeTextFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteAlternativeTextFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlternativeTextFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlternativeTextFromPanelMutation, { data, loading, error }] = useDeleteAlternativeTextFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteAlternativeTextFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlternativeTextFromPanelMutation, DeleteAlternativeTextFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlternativeTextFromPanelMutation, DeleteAlternativeTextFromPanelMutationVariables>(DeleteAlternativeTextFromPanelDocument, options);
      }
export type DeleteAlternativeTextFromPanelMutationHookResult = ReturnType<typeof useDeleteAlternativeTextFromPanelMutation>;
export type DeleteAlternativeTextFromPanelMutationResult = Apollo.MutationResult<DeleteAlternativeTextFromPanelMutation>;
export type DeleteAlternativeTextFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteAlternativeTextFromPanelMutation, DeleteAlternativeTextFromPanelMutationVariables>;
export const UpdateAlternativeTextFromPanelDocument = gql`
    mutation UpdateAlternativeTextFromPanel($attributeId: ID!, $alternativeText: String!) {
  updateAlternativeTextAttribute(
    input: {attributeId: $attributeId, alternativeText: $alternativeText}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      alternativeText
    }
  }
}
    `;
export type UpdateAlternativeTextFromPanelMutationFn = Apollo.MutationFunction<UpdateAlternativeTextFromPanelMutation, UpdateAlternativeTextFromPanelMutationVariables>;

/**
 * __useUpdateAlternativeTextFromPanelMutation__
 *
 * To run a mutation, you first call `useUpdateAlternativeTextFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlternativeTextFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlternativeTextFromPanelMutation, { data, loading, error }] = useUpdateAlternativeTextFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      alternativeText: // value for 'alternativeText'
 *   },
 * });
 */
export function useUpdateAlternativeTextFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlternativeTextFromPanelMutation, UpdateAlternativeTextFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlternativeTextFromPanelMutation, UpdateAlternativeTextFromPanelMutationVariables>(UpdateAlternativeTextFromPanelDocument, options);
      }
export type UpdateAlternativeTextFromPanelMutationHookResult = ReturnType<typeof useUpdateAlternativeTextFromPanelMutation>;
export type UpdateAlternativeTextFromPanelMutationResult = Apollo.MutationResult<UpdateAlternativeTextFromPanelMutation>;
export type UpdateAlternativeTextFromPanelMutationOptions = Apollo.BaseMutationOptions<UpdateAlternativeTextFromPanelMutation, UpdateAlternativeTextFromPanelMutationVariables>;
export const CreateCaptionFromPanelDocument = gql`
    mutation CreateCaptionFromPanel($regionId: ID!, $linkedRegionId: ID) {
  createCaptionAttribute(
    input: {regionId: $regionId, linkedRegionId: $linkedRegionId}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      linkedRegion {
        id
      }
    }
  }
}
    `;
export type CreateCaptionFromPanelMutationFn = Apollo.MutationFunction<CreateCaptionFromPanelMutation, CreateCaptionFromPanelMutationVariables>;

/**
 * __useCreateCaptionFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateCaptionFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaptionFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaptionFromPanelMutation, { data, loading, error }] = useCreateCaptionFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      linkedRegionId: // value for 'linkedRegionId'
 *   },
 * });
 */
export function useCreateCaptionFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaptionFromPanelMutation, CreateCaptionFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaptionFromPanelMutation, CreateCaptionFromPanelMutationVariables>(CreateCaptionFromPanelDocument, options);
      }
export type CreateCaptionFromPanelMutationHookResult = ReturnType<typeof useCreateCaptionFromPanelMutation>;
export type CreateCaptionFromPanelMutationResult = Apollo.MutationResult<CreateCaptionFromPanelMutation>;
export type CreateCaptionFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateCaptionFromPanelMutation, CreateCaptionFromPanelMutationVariables>;
export const DeleteCaptionFromPanelDocument = gql`
    mutation DeleteCaptionFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteCaptionFromPanelMutationFn = Apollo.MutationFunction<DeleteCaptionFromPanelMutation, DeleteCaptionFromPanelMutationVariables>;

/**
 * __useDeleteCaptionFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteCaptionFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaptionFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaptionFromPanelMutation, { data, loading, error }] = useDeleteCaptionFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteCaptionFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaptionFromPanelMutation, DeleteCaptionFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaptionFromPanelMutation, DeleteCaptionFromPanelMutationVariables>(DeleteCaptionFromPanelDocument, options);
      }
export type DeleteCaptionFromPanelMutationHookResult = ReturnType<typeof useDeleteCaptionFromPanelMutation>;
export type DeleteCaptionFromPanelMutationResult = Apollo.MutationResult<DeleteCaptionFromPanelMutation>;
export type DeleteCaptionFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteCaptionFromPanelMutation, DeleteCaptionFromPanelMutationVariables>;
export const UpdateCaptionFromPanelDocument = gql`
    mutation UpdateCaptionFromPanel($attributeId: ID!, $linkedRegionId: ID) {
  updateCaptionAttribute(
    input: {attributeId: $attributeId, linkedRegionId: $linkedRegionId}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      linkedRegion {
        id
      }
    }
  }
}
    `;
export type UpdateCaptionFromPanelMutationFn = Apollo.MutationFunction<UpdateCaptionFromPanelMutation, UpdateCaptionFromPanelMutationVariables>;

/**
 * __useUpdateCaptionFromPanelMutation__
 *
 * To run a mutation, you first call `useUpdateCaptionFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaptionFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaptionFromPanelMutation, { data, loading, error }] = useUpdateCaptionFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      linkedRegionId: // value for 'linkedRegionId'
 *   },
 * });
 */
export function useUpdateCaptionFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaptionFromPanelMutation, UpdateCaptionFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaptionFromPanelMutation, UpdateCaptionFromPanelMutationVariables>(UpdateCaptionFromPanelDocument, options);
      }
export type UpdateCaptionFromPanelMutationHookResult = ReturnType<typeof useUpdateCaptionFromPanelMutation>;
export type UpdateCaptionFromPanelMutationResult = Apollo.MutationResult<UpdateCaptionFromPanelMutation>;
export type UpdateCaptionFromPanelMutationOptions = Apollo.BaseMutationOptions<UpdateCaptionFromPanelMutation, UpdateCaptionFromPanelMutationVariables>;
export const CreateExcludeReadingOrderFromPanelDocument = gql`
    mutation CreateExcludeReadingOrderFromPanel($regionId: ID!) {
  createExcludeReadingOrderAttribute(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateExcludeReadingOrderFromPanelMutationFn = Apollo.MutationFunction<CreateExcludeReadingOrderFromPanelMutation, CreateExcludeReadingOrderFromPanelMutationVariables>;

/**
 * __useCreateExcludeReadingOrderFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateExcludeReadingOrderFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExcludeReadingOrderFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExcludeReadingOrderFromPanelMutation, { data, loading, error }] = useCreateExcludeReadingOrderFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useCreateExcludeReadingOrderFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateExcludeReadingOrderFromPanelMutation, CreateExcludeReadingOrderFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExcludeReadingOrderFromPanelMutation, CreateExcludeReadingOrderFromPanelMutationVariables>(CreateExcludeReadingOrderFromPanelDocument, options);
      }
export type CreateExcludeReadingOrderFromPanelMutationHookResult = ReturnType<typeof useCreateExcludeReadingOrderFromPanelMutation>;
export type CreateExcludeReadingOrderFromPanelMutationResult = Apollo.MutationResult<CreateExcludeReadingOrderFromPanelMutation>;
export type CreateExcludeReadingOrderFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateExcludeReadingOrderFromPanelMutation, CreateExcludeReadingOrderFromPanelMutationVariables>;
export const DeleteExcludeReadingOrderFromPanelDocument = gql`
    mutation DeleteExcludeReadingOrderFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteExcludeReadingOrderFromPanelMutationFn = Apollo.MutationFunction<DeleteExcludeReadingOrderFromPanelMutation, DeleteExcludeReadingOrderFromPanelMutationVariables>;

/**
 * __useDeleteExcludeReadingOrderFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteExcludeReadingOrderFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExcludeReadingOrderFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExcludeReadingOrderFromPanelMutation, { data, loading, error }] = useDeleteExcludeReadingOrderFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteExcludeReadingOrderFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExcludeReadingOrderFromPanelMutation, DeleteExcludeReadingOrderFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExcludeReadingOrderFromPanelMutation, DeleteExcludeReadingOrderFromPanelMutationVariables>(DeleteExcludeReadingOrderFromPanelDocument, options);
      }
export type DeleteExcludeReadingOrderFromPanelMutationHookResult = ReturnType<typeof useDeleteExcludeReadingOrderFromPanelMutation>;
export type DeleteExcludeReadingOrderFromPanelMutationResult = Apollo.MutationResult<DeleteExcludeReadingOrderFromPanelMutation>;
export type DeleteExcludeReadingOrderFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteExcludeReadingOrderFromPanelMutation, DeleteExcludeReadingOrderFromPanelMutationVariables>;
export const CreateExpressionFromPanelDocument = gql`
    mutation CreateExpressionFromPanel($regionId: ID!, $expressionLatex: String!) {
  createExpressionAttribute(
    input: {regionId: $regionId, expressionLatex: $expressionLatex}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateExpressionFromPanelMutationFn = Apollo.MutationFunction<CreateExpressionFromPanelMutation, CreateExpressionFromPanelMutationVariables>;

/**
 * __useCreateExpressionFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateExpressionFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpressionFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpressionFromPanelMutation, { data, loading, error }] = useCreateExpressionFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      expressionLatex: // value for 'expressionLatex'
 *   },
 * });
 */
export function useCreateExpressionFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateExpressionFromPanelMutation, CreateExpressionFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExpressionFromPanelMutation, CreateExpressionFromPanelMutationVariables>(CreateExpressionFromPanelDocument, options);
      }
export type CreateExpressionFromPanelMutationHookResult = ReturnType<typeof useCreateExpressionFromPanelMutation>;
export type CreateExpressionFromPanelMutationResult = Apollo.MutationResult<CreateExpressionFromPanelMutation>;
export type CreateExpressionFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateExpressionFromPanelMutation, CreateExpressionFromPanelMutationVariables>;
export const DeleteExpressionFromPanelDocument = gql`
    mutation DeleteExpressionFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteExpressionFromPanelMutationFn = Apollo.MutationFunction<DeleteExpressionFromPanelMutation, DeleteExpressionFromPanelMutationVariables>;

/**
 * __useDeleteExpressionFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteExpressionFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpressionFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpressionFromPanelMutation, { data, loading, error }] = useDeleteExpressionFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteExpressionFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExpressionFromPanelMutation, DeleteExpressionFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExpressionFromPanelMutation, DeleteExpressionFromPanelMutationVariables>(DeleteExpressionFromPanelDocument, options);
      }
export type DeleteExpressionFromPanelMutationHookResult = ReturnType<typeof useDeleteExpressionFromPanelMutation>;
export type DeleteExpressionFromPanelMutationResult = Apollo.MutationResult<DeleteExpressionFromPanelMutation>;
export type DeleteExpressionFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteExpressionFromPanelMutation, DeleteExpressionFromPanelMutationVariables>;
export const UpdateExpressionFromPanelDocument = gql`
    mutation UpdateExpressionFromPanel($attributeId: ID!, $expressionLatex: String!) {
  updateExpressionAttribute(
    input: {attributeId: $attributeId, expressionLatex: $expressionLatex}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      expressionLatex
    }
  }
}
    `;
export type UpdateExpressionFromPanelMutationFn = Apollo.MutationFunction<UpdateExpressionFromPanelMutation, UpdateExpressionFromPanelMutationVariables>;

/**
 * __useUpdateExpressionFromPanelMutation__
 *
 * To run a mutation, you first call `useUpdateExpressionFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpressionFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpressionFromPanelMutation, { data, loading, error }] = useUpdateExpressionFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      expressionLatex: // value for 'expressionLatex'
 *   },
 * });
 */
export function useUpdateExpressionFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpressionFromPanelMutation, UpdateExpressionFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpressionFromPanelMutation, UpdateExpressionFromPanelMutationVariables>(UpdateExpressionFromPanelDocument, options);
      }
export type UpdateExpressionFromPanelMutationHookResult = ReturnType<typeof useUpdateExpressionFromPanelMutation>;
export type UpdateExpressionFromPanelMutationResult = Apollo.MutationResult<UpdateExpressionFromPanelMutation>;
export type UpdateExpressionFromPanelMutationOptions = Apollo.BaseMutationOptions<UpdateExpressionFromPanelMutation, UpdateExpressionFromPanelMutationVariables>;
export const CreateFigureFromPanelDocument = gql`
    mutation CreateFigureFromPanel($regionId: ID!) {
  createFigureAttribute(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateFigureFromPanelMutationFn = Apollo.MutationFunction<CreateFigureFromPanelMutation, CreateFigureFromPanelMutationVariables>;

/**
 * __useCreateFigureFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateFigureFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFigureFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFigureFromPanelMutation, { data, loading, error }] = useCreateFigureFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useCreateFigureFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateFigureFromPanelMutation, CreateFigureFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFigureFromPanelMutation, CreateFigureFromPanelMutationVariables>(CreateFigureFromPanelDocument, options);
      }
export type CreateFigureFromPanelMutationHookResult = ReturnType<typeof useCreateFigureFromPanelMutation>;
export type CreateFigureFromPanelMutationResult = Apollo.MutationResult<CreateFigureFromPanelMutation>;
export type CreateFigureFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateFigureFromPanelMutation, CreateFigureFromPanelMutationVariables>;
export const DeleteFigureFromPanelDocument = gql`
    mutation DeleteFigureFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteFigureFromPanelMutationFn = Apollo.MutationFunction<DeleteFigureFromPanelMutation, DeleteFigureFromPanelMutationVariables>;

/**
 * __useDeleteFigureFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteFigureFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFigureFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFigureFromPanelMutation, { data, loading, error }] = useDeleteFigureFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteFigureFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFigureFromPanelMutation, DeleteFigureFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFigureFromPanelMutation, DeleteFigureFromPanelMutationVariables>(DeleteFigureFromPanelDocument, options);
      }
export type DeleteFigureFromPanelMutationHookResult = ReturnType<typeof useDeleteFigureFromPanelMutation>;
export type DeleteFigureFromPanelMutationResult = Apollo.MutationResult<DeleteFigureFromPanelMutation>;
export type DeleteFigureFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteFigureFromPanelMutation, DeleteFigureFromPanelMutationVariables>;
export const CreateHeadingLevelFromPanelDocument = gql`
    mutation CreateHeadingLevelFromPanel($regionId: ID!, $level: PositiveInt!) {
  createHeaderLevelAttribute(input: {regionId: $regionId, level: $level}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateHeadingLevelFromPanelMutationFn = Apollo.MutationFunction<CreateHeadingLevelFromPanelMutation, CreateHeadingLevelFromPanelMutationVariables>;

/**
 * __useCreateHeadingLevelFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateHeadingLevelFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHeadingLevelFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHeadingLevelFromPanelMutation, { data, loading, error }] = useCreateHeadingLevelFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useCreateHeadingLevelFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateHeadingLevelFromPanelMutation, CreateHeadingLevelFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHeadingLevelFromPanelMutation, CreateHeadingLevelFromPanelMutationVariables>(CreateHeadingLevelFromPanelDocument, options);
      }
export type CreateHeadingLevelFromPanelMutationHookResult = ReturnType<typeof useCreateHeadingLevelFromPanelMutation>;
export type CreateHeadingLevelFromPanelMutationResult = Apollo.MutationResult<CreateHeadingLevelFromPanelMutation>;
export type CreateHeadingLevelFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateHeadingLevelFromPanelMutation, CreateHeadingLevelFromPanelMutationVariables>;
export const DeleteHeadingLevelFromPanelDocument = gql`
    mutation DeleteHeadingLevelFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteHeadingLevelFromPanelMutationFn = Apollo.MutationFunction<DeleteHeadingLevelFromPanelMutation, DeleteHeadingLevelFromPanelMutationVariables>;

/**
 * __useDeleteHeadingLevelFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteHeadingLevelFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHeadingLevelFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHeadingLevelFromPanelMutation, { data, loading, error }] = useDeleteHeadingLevelFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteHeadingLevelFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHeadingLevelFromPanelMutation, DeleteHeadingLevelFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHeadingLevelFromPanelMutation, DeleteHeadingLevelFromPanelMutationVariables>(DeleteHeadingLevelFromPanelDocument, options);
      }
export type DeleteHeadingLevelFromPanelMutationHookResult = ReturnType<typeof useDeleteHeadingLevelFromPanelMutation>;
export type DeleteHeadingLevelFromPanelMutationResult = Apollo.MutationResult<DeleteHeadingLevelFromPanelMutation>;
export type DeleteHeadingLevelFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteHeadingLevelFromPanelMutation, DeleteHeadingLevelFromPanelMutationVariables>;
export const UpdateHeadingLevelFromPanelDocument = gql`
    mutation UpdateHeadingLevelFromPanel($attributeId: ID!, $level: PositiveInt!) {
  updateHeaderLevelAttribute(input: {attributeId: $attributeId, level: $level}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      level
    }
  }
}
    `;
export type UpdateHeadingLevelFromPanelMutationFn = Apollo.MutationFunction<UpdateHeadingLevelFromPanelMutation, UpdateHeadingLevelFromPanelMutationVariables>;

/**
 * __useUpdateHeadingLevelFromPanelMutation__
 *
 * To run a mutation, you first call `useUpdateHeadingLevelFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHeadingLevelFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHeadingLevelFromPanelMutation, { data, loading, error }] = useUpdateHeadingLevelFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useUpdateHeadingLevelFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHeadingLevelFromPanelMutation, UpdateHeadingLevelFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHeadingLevelFromPanelMutation, UpdateHeadingLevelFromPanelMutationVariables>(UpdateHeadingLevelFromPanelDocument, options);
      }
export type UpdateHeadingLevelFromPanelMutationHookResult = ReturnType<typeof useUpdateHeadingLevelFromPanelMutation>;
export type UpdateHeadingLevelFromPanelMutationResult = Apollo.MutationResult<UpdateHeadingLevelFromPanelMutation>;
export type UpdateHeadingLevelFromPanelMutationOptions = Apollo.BaseMutationOptions<UpdateHeadingLevelFromPanelMutation, UpdateHeadingLevelFromPanelMutationVariables>;
export const CreateImageFromPanelDocument = gql`
    mutation CreateImageFromPanel($regionId: ID!) {
  createImageAttribute(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateImageFromPanelMutationFn = Apollo.MutationFunction<CreateImageFromPanelMutation, CreateImageFromPanelMutationVariables>;

/**
 * __useCreateImageFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateImageFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImageFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImageFromPanelMutation, { data, loading, error }] = useCreateImageFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useCreateImageFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateImageFromPanelMutation, CreateImageFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImageFromPanelMutation, CreateImageFromPanelMutationVariables>(CreateImageFromPanelDocument, options);
      }
export type CreateImageFromPanelMutationHookResult = ReturnType<typeof useCreateImageFromPanelMutation>;
export type CreateImageFromPanelMutationResult = Apollo.MutationResult<CreateImageFromPanelMutation>;
export type CreateImageFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateImageFromPanelMutation, CreateImageFromPanelMutationVariables>;
export const DeleteImageFromPanelDocument = gql`
    mutation DeleteImageFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteImageFromPanelMutationFn = Apollo.MutationFunction<DeleteImageFromPanelMutation, DeleteImageFromPanelMutationVariables>;

/**
 * __useDeleteImageFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteImageFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImageFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImageFromPanelMutation, { data, loading, error }] = useDeleteImageFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteImageFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteImageFromPanelMutation, DeleteImageFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteImageFromPanelMutation, DeleteImageFromPanelMutationVariables>(DeleteImageFromPanelDocument, options);
      }
export type DeleteImageFromPanelMutationHookResult = ReturnType<typeof useDeleteImageFromPanelMutation>;
export type DeleteImageFromPanelMutationResult = Apollo.MutationResult<DeleteImageFromPanelMutation>;
export type DeleteImageFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteImageFromPanelMutation, DeleteImageFromPanelMutationVariables>;
export const CreateListItemLabelFromPanelDocument = gql`
    mutation CreateListItemLabelFromPanel($regionId: ID!) {
  createListItemLabelAttribute(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateListItemLabelFromPanelMutationFn = Apollo.MutationFunction<CreateListItemLabelFromPanelMutation, CreateListItemLabelFromPanelMutationVariables>;

/**
 * __useCreateListItemLabelFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateListItemLabelFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListItemLabelFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListItemLabelFromPanelMutation, { data, loading, error }] = useCreateListItemLabelFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useCreateListItemLabelFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateListItemLabelFromPanelMutation, CreateListItemLabelFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListItemLabelFromPanelMutation, CreateListItemLabelFromPanelMutationVariables>(CreateListItemLabelFromPanelDocument, options);
      }
export type CreateListItemLabelFromPanelMutationHookResult = ReturnType<typeof useCreateListItemLabelFromPanelMutation>;
export type CreateListItemLabelFromPanelMutationResult = Apollo.MutationResult<CreateListItemLabelFromPanelMutation>;
export type CreateListItemLabelFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateListItemLabelFromPanelMutation, CreateListItemLabelFromPanelMutationVariables>;
export const DeleteListItemLabelFromPanelDocument = gql`
    mutation DeleteListItemLabelFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteListItemLabelFromPanelMutationFn = Apollo.MutationFunction<DeleteListItemLabelFromPanelMutation, DeleteListItemLabelFromPanelMutationVariables>;

/**
 * __useDeleteListItemLabelFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteListItemLabelFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListItemLabelFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListItemLabelFromPanelMutation, { data, loading, error }] = useDeleteListItemLabelFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteListItemLabelFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListItemLabelFromPanelMutation, DeleteListItemLabelFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListItemLabelFromPanelMutation, DeleteListItemLabelFromPanelMutationVariables>(DeleteListItemLabelFromPanelDocument, options);
      }
export type DeleteListItemLabelFromPanelMutationHookResult = ReturnType<typeof useDeleteListItemLabelFromPanelMutation>;
export type DeleteListItemLabelFromPanelMutationResult = Apollo.MutationResult<DeleteListItemLabelFromPanelMutation>;
export type DeleteListItemLabelFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteListItemLabelFromPanelMutation, DeleteListItemLabelFromPanelMutationVariables>;
export const CreateListItemFromPanelDocument = gql`
    mutation CreateListItemFromPanel($regionId: ID!, $ordinal: NonNegativeInt!) {
  createListItemAttribute(input: {regionId: $regionId, ordinal: $ordinal}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateListItemFromPanelMutationFn = Apollo.MutationFunction<CreateListItemFromPanelMutation, CreateListItemFromPanelMutationVariables>;

/**
 * __useCreateListItemFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateListItemFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListItemFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListItemFromPanelMutation, { data, loading, error }] = useCreateListItemFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      ordinal: // value for 'ordinal'
 *   },
 * });
 */
export function useCreateListItemFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateListItemFromPanelMutation, CreateListItemFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListItemFromPanelMutation, CreateListItemFromPanelMutationVariables>(CreateListItemFromPanelDocument, options);
      }
export type CreateListItemFromPanelMutationHookResult = ReturnType<typeof useCreateListItemFromPanelMutation>;
export type CreateListItemFromPanelMutationResult = Apollo.MutationResult<CreateListItemFromPanelMutation>;
export type CreateListItemFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateListItemFromPanelMutation, CreateListItemFromPanelMutationVariables>;
export const DeleteListItemFromPanelDocument = gql`
    mutation DeleteListItemFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteListItemFromPanelMutationFn = Apollo.MutationFunction<DeleteListItemFromPanelMutation, DeleteListItemFromPanelMutationVariables>;

/**
 * __useDeleteListItemFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteListItemFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListItemFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListItemFromPanelMutation, { data, loading, error }] = useDeleteListItemFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteListItemFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListItemFromPanelMutation, DeleteListItemFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListItemFromPanelMutation, DeleteListItemFromPanelMutationVariables>(DeleteListItemFromPanelDocument, options);
      }
export type DeleteListItemFromPanelMutationHookResult = ReturnType<typeof useDeleteListItemFromPanelMutation>;
export type DeleteListItemFromPanelMutationResult = Apollo.MutationResult<DeleteListItemFromPanelMutation>;
export type DeleteListItemFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteListItemFromPanelMutation, DeleteListItemFromPanelMutationVariables>;
export const UpdateListItemFromPanelDocument = gql`
    mutation UpdateListItemFromPanel($attributeId: ID!, $ordinal: NonNegativeInt!) {
  updateListItemAttribute(input: {attributeId: $attributeId, ordinal: $ordinal}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      ordinal
    }
  }
}
    `;
export type UpdateListItemFromPanelMutationFn = Apollo.MutationFunction<UpdateListItemFromPanelMutation, UpdateListItemFromPanelMutationVariables>;

/**
 * __useUpdateListItemFromPanelMutation__
 *
 * To run a mutation, you first call `useUpdateListItemFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListItemFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListItemFromPanelMutation, { data, loading, error }] = useUpdateListItemFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      ordinal: // value for 'ordinal'
 *   },
 * });
 */
export function useUpdateListItemFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListItemFromPanelMutation, UpdateListItemFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListItemFromPanelMutation, UpdateListItemFromPanelMutationVariables>(UpdateListItemFromPanelDocument, options);
      }
export type UpdateListItemFromPanelMutationHookResult = ReturnType<typeof useUpdateListItemFromPanelMutation>;
export type UpdateListItemFromPanelMutationResult = Apollo.MutationResult<UpdateListItemFromPanelMutation>;
export type UpdateListItemFromPanelMutationOptions = Apollo.BaseMutationOptions<UpdateListItemFromPanelMutation, UpdateListItemFromPanelMutationVariables>;
export const CreateListFromPanelDocument = gql`
    mutation CreateListFromPanel($regionId: ID!, $listType: ListType!) {
  createListAttribute(input: {listType: $listType, regionId: $regionId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateListFromPanelMutationFn = Apollo.MutationFunction<CreateListFromPanelMutation, CreateListFromPanelMutationVariables>;

/**
 * __useCreateListFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateListFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListFromPanelMutation, { data, loading, error }] = useCreateListFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      listType: // value for 'listType'
 *   },
 * });
 */
export function useCreateListFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateListFromPanelMutation, CreateListFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListFromPanelMutation, CreateListFromPanelMutationVariables>(CreateListFromPanelDocument, options);
      }
export type CreateListFromPanelMutationHookResult = ReturnType<typeof useCreateListFromPanelMutation>;
export type CreateListFromPanelMutationResult = Apollo.MutationResult<CreateListFromPanelMutation>;
export type CreateListFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateListFromPanelMutation, CreateListFromPanelMutationVariables>;
export const DeleteListFromPanelDocument = gql`
    mutation DeleteListFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteListFromPanelMutationFn = Apollo.MutationFunction<DeleteListFromPanelMutation, DeleteListFromPanelMutationVariables>;

/**
 * __useDeleteListFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteListFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListFromPanelMutation, { data, loading, error }] = useDeleteListFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteListFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteListFromPanelMutation, DeleteListFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteListFromPanelMutation, DeleteListFromPanelMutationVariables>(DeleteListFromPanelDocument, options);
      }
export type DeleteListFromPanelMutationHookResult = ReturnType<typeof useDeleteListFromPanelMutation>;
export type DeleteListFromPanelMutationResult = Apollo.MutationResult<DeleteListFromPanelMutation>;
export type DeleteListFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteListFromPanelMutation, DeleteListFromPanelMutationVariables>;
export const UpdateListFromPanelDocument = gql`
    mutation UpdateListFromPanel($attributeId: ID!, $listType: ListType!) {
  updateListAttribute(input: {attributeId: $attributeId, listType: $listType}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      listType
    }
  }
}
    `;
export type UpdateListFromPanelMutationFn = Apollo.MutationFunction<UpdateListFromPanelMutation, UpdateListFromPanelMutationVariables>;

/**
 * __useUpdateListFromPanelMutation__
 *
 * To run a mutation, you first call `useUpdateListFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListFromPanelMutation, { data, loading, error }] = useUpdateListFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      listType: // value for 'listType'
 *   },
 * });
 */
export function useUpdateListFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListFromPanelMutation, UpdateListFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListFromPanelMutation, UpdateListFromPanelMutationVariables>(UpdateListFromPanelDocument, options);
      }
export type UpdateListFromPanelMutationHookResult = ReturnType<typeof useUpdateListFromPanelMutation>;
export type UpdateListFromPanelMutationResult = Apollo.MutationResult<UpdateListFromPanelMutation>;
export type UpdateListFromPanelMutationOptions = Apollo.BaseMutationOptions<UpdateListFromPanelMutation, UpdateListFromPanelMutationVariables>;
export const CreatePaginationArtifactFromPanelDocument = gql`
    mutation CreatePaginationArtifactFromPanel($regionId: ID!, $type: PaginationArtifactType!) {
  createPaginationArtifactAttribute(input: {regionId: $regionId, type: $type}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreatePaginationArtifactFromPanelMutationFn = Apollo.MutationFunction<CreatePaginationArtifactFromPanelMutation, CreatePaginationArtifactFromPanelMutationVariables>;

/**
 * __useCreatePaginationArtifactFromPanelMutation__
 *
 * To run a mutation, you first call `useCreatePaginationArtifactFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaginationArtifactFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaginationArtifactFromPanelMutation, { data, loading, error }] = useCreatePaginationArtifactFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreatePaginationArtifactFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaginationArtifactFromPanelMutation, CreatePaginationArtifactFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaginationArtifactFromPanelMutation, CreatePaginationArtifactFromPanelMutationVariables>(CreatePaginationArtifactFromPanelDocument, options);
      }
export type CreatePaginationArtifactFromPanelMutationHookResult = ReturnType<typeof useCreatePaginationArtifactFromPanelMutation>;
export type CreatePaginationArtifactFromPanelMutationResult = Apollo.MutationResult<CreatePaginationArtifactFromPanelMutation>;
export type CreatePaginationArtifactFromPanelMutationOptions = Apollo.BaseMutationOptions<CreatePaginationArtifactFromPanelMutation, CreatePaginationArtifactFromPanelMutationVariables>;
export const DeletePaginationArtifactFromPanelDocument = gql`
    mutation DeletePaginationArtifactFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeletePaginationArtifactFromPanelMutationFn = Apollo.MutationFunction<DeletePaginationArtifactFromPanelMutation, DeletePaginationArtifactFromPanelMutationVariables>;

/**
 * __useDeletePaginationArtifactFromPanelMutation__
 *
 * To run a mutation, you first call `useDeletePaginationArtifactFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaginationArtifactFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaginationArtifactFromPanelMutation, { data, loading, error }] = useDeletePaginationArtifactFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeletePaginationArtifactFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaginationArtifactFromPanelMutation, DeletePaginationArtifactFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaginationArtifactFromPanelMutation, DeletePaginationArtifactFromPanelMutationVariables>(DeletePaginationArtifactFromPanelDocument, options);
      }
export type DeletePaginationArtifactFromPanelMutationHookResult = ReturnType<typeof useDeletePaginationArtifactFromPanelMutation>;
export type DeletePaginationArtifactFromPanelMutationResult = Apollo.MutationResult<DeletePaginationArtifactFromPanelMutation>;
export type DeletePaginationArtifactFromPanelMutationOptions = Apollo.BaseMutationOptions<DeletePaginationArtifactFromPanelMutation, DeletePaginationArtifactFromPanelMutationVariables>;
export const UpdatePaginationArtifactFromPanelDocument = gql`
    mutation UpdatePaginationArtifactFromPanel($attributeId: ID!, $type: PaginationArtifactType!) {
  updatePaginationArtifactAttribute(
    input: {attributeId: $attributeId, type: $type}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      type
    }
  }
}
    `;
export type UpdatePaginationArtifactFromPanelMutationFn = Apollo.MutationFunction<UpdatePaginationArtifactFromPanelMutation, UpdatePaginationArtifactFromPanelMutationVariables>;

/**
 * __useUpdatePaginationArtifactFromPanelMutation__
 *
 * To run a mutation, you first call `useUpdatePaginationArtifactFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaginationArtifactFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaginationArtifactFromPanelMutation, { data, loading, error }] = useUpdatePaginationArtifactFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdatePaginationArtifactFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaginationArtifactFromPanelMutation, UpdatePaginationArtifactFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaginationArtifactFromPanelMutation, UpdatePaginationArtifactFromPanelMutationVariables>(UpdatePaginationArtifactFromPanelDocument, options);
      }
export type UpdatePaginationArtifactFromPanelMutationHookResult = ReturnType<typeof useUpdatePaginationArtifactFromPanelMutation>;
export type UpdatePaginationArtifactFromPanelMutationResult = Apollo.MutationResult<UpdatePaginationArtifactFromPanelMutation>;
export type UpdatePaginationArtifactFromPanelMutationOptions = Apollo.BaseMutationOptions<UpdatePaginationArtifactFromPanelMutation, UpdatePaginationArtifactFromPanelMutationVariables>;
export const CreateTableCellFromPanelDocument = gql`
    mutation CreateTableCellFromPanel($regionId: ID!, $columnSpan: PositiveInt!, $rowSpan: PositiveInt!) {
  createTableCellAttribute(
    input: {regionId: $regionId, columnSpan: $columnSpan, rowSpan: $rowSpan}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateTableCellFromPanelMutationFn = Apollo.MutationFunction<CreateTableCellFromPanelMutation, CreateTableCellFromPanelMutationVariables>;

/**
 * __useCreateTableCellFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateTableCellFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableCellFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableCellFromPanelMutation, { data, loading, error }] = useCreateTableCellFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      columnSpan: // value for 'columnSpan'
 *      rowSpan: // value for 'rowSpan'
 *   },
 * });
 */
export function useCreateTableCellFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateTableCellFromPanelMutation, CreateTableCellFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTableCellFromPanelMutation, CreateTableCellFromPanelMutationVariables>(CreateTableCellFromPanelDocument, options);
      }
export type CreateTableCellFromPanelMutationHookResult = ReturnType<typeof useCreateTableCellFromPanelMutation>;
export type CreateTableCellFromPanelMutationResult = Apollo.MutationResult<CreateTableCellFromPanelMutation>;
export type CreateTableCellFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateTableCellFromPanelMutation, CreateTableCellFromPanelMutationVariables>;
export const DeleteTableCellFromPanelDocument = gql`
    mutation DeleteTableCellFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteTableCellFromPanelMutationFn = Apollo.MutationFunction<DeleteTableCellFromPanelMutation, DeleteTableCellFromPanelMutationVariables>;

/**
 * __useDeleteTableCellFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteTableCellFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableCellFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableCellFromPanelMutation, { data, loading, error }] = useDeleteTableCellFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteTableCellFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTableCellFromPanelMutation, DeleteTableCellFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTableCellFromPanelMutation, DeleteTableCellFromPanelMutationVariables>(DeleteTableCellFromPanelDocument, options);
      }
export type DeleteTableCellFromPanelMutationHookResult = ReturnType<typeof useDeleteTableCellFromPanelMutation>;
export type DeleteTableCellFromPanelMutationResult = Apollo.MutationResult<DeleteTableCellFromPanelMutation>;
export type DeleteTableCellFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteTableCellFromPanelMutation, DeleteTableCellFromPanelMutationVariables>;
export const UpdateTableCellFromPanelDocument = gql`
    mutation UpdateTableCellFromPanel($attributeId: ID!, $rowSpan: PositiveInt!, $columnSpan: PositiveInt!) {
  updateTableCellAttribute(
    input: {attributeId: $attributeId, rowSpan: $rowSpan, columnSpan: $columnSpan}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      rowSpan
      columnSpan
    }
  }
}
    `;
export type UpdateTableCellFromPanelMutationFn = Apollo.MutationFunction<UpdateTableCellFromPanelMutation, UpdateTableCellFromPanelMutationVariables>;

/**
 * __useUpdateTableCellFromPanelMutation__
 *
 * To run a mutation, you first call `useUpdateTableCellFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableCellFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableCellFromPanelMutation, { data, loading, error }] = useUpdateTableCellFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      rowSpan: // value for 'rowSpan'
 *      columnSpan: // value for 'columnSpan'
 *   },
 * });
 */
export function useUpdateTableCellFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTableCellFromPanelMutation, UpdateTableCellFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTableCellFromPanelMutation, UpdateTableCellFromPanelMutationVariables>(UpdateTableCellFromPanelDocument, options);
      }
export type UpdateTableCellFromPanelMutationHookResult = ReturnType<typeof useUpdateTableCellFromPanelMutation>;
export type UpdateTableCellFromPanelMutationResult = Apollo.MutationResult<UpdateTableCellFromPanelMutation>;
export type UpdateTableCellFromPanelMutationOptions = Apollo.BaseMutationOptions<UpdateTableCellFromPanelMutation, UpdateTableCellFromPanelMutationVariables>;
export const CreateTableHeaderCellFromPanelDocument = gql`
    mutation CreateTableHeaderCellFromPanel($regionId: ID!) {
  createTableHeaderCellAttribute(input: {regionId: $regionId, scopes: []}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateTableHeaderCellFromPanelMutationFn = Apollo.MutationFunction<CreateTableHeaderCellFromPanelMutation, CreateTableHeaderCellFromPanelMutationVariables>;

/**
 * __useCreateTableHeaderCellFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateTableHeaderCellFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableHeaderCellFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableHeaderCellFromPanelMutation, { data, loading, error }] = useCreateTableHeaderCellFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useCreateTableHeaderCellFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateTableHeaderCellFromPanelMutation, CreateTableHeaderCellFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTableHeaderCellFromPanelMutation, CreateTableHeaderCellFromPanelMutationVariables>(CreateTableHeaderCellFromPanelDocument, options);
      }
export type CreateTableHeaderCellFromPanelMutationHookResult = ReturnType<typeof useCreateTableHeaderCellFromPanelMutation>;
export type CreateTableHeaderCellFromPanelMutationResult = Apollo.MutationResult<CreateTableHeaderCellFromPanelMutation>;
export type CreateTableHeaderCellFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateTableHeaderCellFromPanelMutation, CreateTableHeaderCellFromPanelMutationVariables>;
export const DeleteTableHeaderCellFromPanelDocument = gql`
    mutation DeleteTableHeaderCellFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteTableHeaderCellFromPanelMutationFn = Apollo.MutationFunction<DeleteTableHeaderCellFromPanelMutation, DeleteTableHeaderCellFromPanelMutationVariables>;

/**
 * __useDeleteTableHeaderCellFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteTableHeaderCellFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableHeaderCellFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableHeaderCellFromPanelMutation, { data, loading, error }] = useDeleteTableHeaderCellFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteTableHeaderCellFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTableHeaderCellFromPanelMutation, DeleteTableHeaderCellFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTableHeaderCellFromPanelMutation, DeleteTableHeaderCellFromPanelMutationVariables>(DeleteTableHeaderCellFromPanelDocument, options);
      }
export type DeleteTableHeaderCellFromPanelMutationHookResult = ReturnType<typeof useDeleteTableHeaderCellFromPanelMutation>;
export type DeleteTableHeaderCellFromPanelMutationResult = Apollo.MutationResult<DeleteTableHeaderCellFromPanelMutation>;
export type DeleteTableHeaderCellFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteTableHeaderCellFromPanelMutation, DeleteTableHeaderCellFromPanelMutationVariables>;
export const CreateTableOfContentsHeadingFromPanelDocument = gql`
    mutation CreateTableOfContentsHeadingFromPanel($regionId: ID!) {
  createTableOfContentsHeadingAttribute(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateTableOfContentsHeadingFromPanelMutationFn = Apollo.MutationFunction<CreateTableOfContentsHeadingFromPanelMutation, CreateTableOfContentsHeadingFromPanelMutationVariables>;

/**
 * __useCreateTableOfContentsHeadingFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateTableOfContentsHeadingFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableOfContentsHeadingFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableOfContentsHeadingFromPanelMutation, { data, loading, error }] = useCreateTableOfContentsHeadingFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useCreateTableOfContentsHeadingFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateTableOfContentsHeadingFromPanelMutation, CreateTableOfContentsHeadingFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTableOfContentsHeadingFromPanelMutation, CreateTableOfContentsHeadingFromPanelMutationVariables>(CreateTableOfContentsHeadingFromPanelDocument, options);
      }
export type CreateTableOfContentsHeadingFromPanelMutationHookResult = ReturnType<typeof useCreateTableOfContentsHeadingFromPanelMutation>;
export type CreateTableOfContentsHeadingFromPanelMutationResult = Apollo.MutationResult<CreateTableOfContentsHeadingFromPanelMutation>;
export type CreateTableOfContentsHeadingFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateTableOfContentsHeadingFromPanelMutation, CreateTableOfContentsHeadingFromPanelMutationVariables>;
export const DeleteTableOfContentsHeadingFromPanelDocument = gql`
    mutation DeleteTableOfContentsHeadingFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteTableOfContentsHeadingFromPanelMutationFn = Apollo.MutationFunction<DeleteTableOfContentsHeadingFromPanelMutation, DeleteTableOfContentsHeadingFromPanelMutationVariables>;

/**
 * __useDeleteTableOfContentsHeadingFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteTableOfContentsHeadingFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableOfContentsHeadingFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableOfContentsHeadingFromPanelMutation, { data, loading, error }] = useDeleteTableOfContentsHeadingFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteTableOfContentsHeadingFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTableOfContentsHeadingFromPanelMutation, DeleteTableOfContentsHeadingFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTableOfContentsHeadingFromPanelMutation, DeleteTableOfContentsHeadingFromPanelMutationVariables>(DeleteTableOfContentsHeadingFromPanelDocument, options);
      }
export type DeleteTableOfContentsHeadingFromPanelMutationHookResult = ReturnType<typeof useDeleteTableOfContentsHeadingFromPanelMutation>;
export type DeleteTableOfContentsHeadingFromPanelMutationResult = Apollo.MutationResult<DeleteTableOfContentsHeadingFromPanelMutation>;
export type DeleteTableOfContentsHeadingFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteTableOfContentsHeadingFromPanelMutation, DeleteTableOfContentsHeadingFromPanelMutationVariables>;
export const CreateTableOfContentsItemFromPanelDocument = gql`
    mutation CreateTableOfContentsItemFromPanel($regionId: ID!, $linkedRegionId: ID) {
  createTableOfContentsItemAttribute(
    input: {regionId: $regionId, linkedRegionId: $linkedRegionId}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      linkedRegion {
        id
      }
    }
  }
}
    `;
export type CreateTableOfContentsItemFromPanelMutationFn = Apollo.MutationFunction<CreateTableOfContentsItemFromPanelMutation, CreateTableOfContentsItemFromPanelMutationVariables>;

/**
 * __useCreateTableOfContentsItemFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateTableOfContentsItemFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableOfContentsItemFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableOfContentsItemFromPanelMutation, { data, loading, error }] = useCreateTableOfContentsItemFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      linkedRegionId: // value for 'linkedRegionId'
 *   },
 * });
 */
export function useCreateTableOfContentsItemFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateTableOfContentsItemFromPanelMutation, CreateTableOfContentsItemFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTableOfContentsItemFromPanelMutation, CreateTableOfContentsItemFromPanelMutationVariables>(CreateTableOfContentsItemFromPanelDocument, options);
      }
export type CreateTableOfContentsItemFromPanelMutationHookResult = ReturnType<typeof useCreateTableOfContentsItemFromPanelMutation>;
export type CreateTableOfContentsItemFromPanelMutationResult = Apollo.MutationResult<CreateTableOfContentsItemFromPanelMutation>;
export type CreateTableOfContentsItemFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateTableOfContentsItemFromPanelMutation, CreateTableOfContentsItemFromPanelMutationVariables>;
export const DeleteTableOfContentsItemFromPanelDocument = gql`
    mutation DeleteTableOfContentsItemFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteTableOfContentsItemFromPanelMutationFn = Apollo.MutationFunction<DeleteTableOfContentsItemFromPanelMutation, DeleteTableOfContentsItemFromPanelMutationVariables>;

/**
 * __useDeleteTableOfContentsItemFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteTableOfContentsItemFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableOfContentsItemFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableOfContentsItemFromPanelMutation, { data, loading, error }] = useDeleteTableOfContentsItemFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteTableOfContentsItemFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTableOfContentsItemFromPanelMutation, DeleteTableOfContentsItemFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTableOfContentsItemFromPanelMutation, DeleteTableOfContentsItemFromPanelMutationVariables>(DeleteTableOfContentsItemFromPanelDocument, options);
      }
export type DeleteTableOfContentsItemFromPanelMutationHookResult = ReturnType<typeof useDeleteTableOfContentsItemFromPanelMutation>;
export type DeleteTableOfContentsItemFromPanelMutationResult = Apollo.MutationResult<DeleteTableOfContentsItemFromPanelMutation>;
export type DeleteTableOfContentsItemFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteTableOfContentsItemFromPanelMutation, DeleteTableOfContentsItemFromPanelMutationVariables>;
export const UpdateTableOfContentsItemFromPanelDocument = gql`
    mutation UpdateTableOfContentsItemFromPanel($attributeId: ID!, $linkedRegionId: ID!) {
  updateTableOfContentsItemAttribute(
    input: {attributeId: $attributeId, linkedRegionId: $linkedRegionId}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      linkedRegion {
        id
      }
    }
  }
}
    `;
export type UpdateTableOfContentsItemFromPanelMutationFn = Apollo.MutationFunction<UpdateTableOfContentsItemFromPanelMutation, UpdateTableOfContentsItemFromPanelMutationVariables>;

/**
 * __useUpdateTableOfContentsItemFromPanelMutation__
 *
 * To run a mutation, you first call `useUpdateTableOfContentsItemFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableOfContentsItemFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableOfContentsItemFromPanelMutation, { data, loading, error }] = useUpdateTableOfContentsItemFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      linkedRegionId: // value for 'linkedRegionId'
 *   },
 * });
 */
export function useUpdateTableOfContentsItemFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTableOfContentsItemFromPanelMutation, UpdateTableOfContentsItemFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTableOfContentsItemFromPanelMutation, UpdateTableOfContentsItemFromPanelMutationVariables>(UpdateTableOfContentsItemFromPanelDocument, options);
      }
export type UpdateTableOfContentsItemFromPanelMutationHookResult = ReturnType<typeof useUpdateTableOfContentsItemFromPanelMutation>;
export type UpdateTableOfContentsItemFromPanelMutationResult = Apollo.MutationResult<UpdateTableOfContentsItemFromPanelMutation>;
export type UpdateTableOfContentsItemFromPanelMutationOptions = Apollo.BaseMutationOptions<UpdateTableOfContentsItemFromPanelMutation, UpdateTableOfContentsItemFromPanelMutationVariables>;
export const CreateTableOfContentsPageNumberFromPanelDocument = gql`
    mutation CreateTableOfContentsPageNumberFromPanel($regionId: ID!) {
  createTableOfContentsPageNumberAttribute(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateTableOfContentsPageNumberFromPanelMutationFn = Apollo.MutationFunction<CreateTableOfContentsPageNumberFromPanelMutation, CreateTableOfContentsPageNumberFromPanelMutationVariables>;

/**
 * __useCreateTableOfContentsPageNumberFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateTableOfContentsPageNumberFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableOfContentsPageNumberFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableOfContentsPageNumberFromPanelMutation, { data, loading, error }] = useCreateTableOfContentsPageNumberFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useCreateTableOfContentsPageNumberFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateTableOfContentsPageNumberFromPanelMutation, CreateTableOfContentsPageNumberFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTableOfContentsPageNumberFromPanelMutation, CreateTableOfContentsPageNumberFromPanelMutationVariables>(CreateTableOfContentsPageNumberFromPanelDocument, options);
      }
export type CreateTableOfContentsPageNumberFromPanelMutationHookResult = ReturnType<typeof useCreateTableOfContentsPageNumberFromPanelMutation>;
export type CreateTableOfContentsPageNumberFromPanelMutationResult = Apollo.MutationResult<CreateTableOfContentsPageNumberFromPanelMutation>;
export type CreateTableOfContentsPageNumberFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateTableOfContentsPageNumberFromPanelMutation, CreateTableOfContentsPageNumberFromPanelMutationVariables>;
export const DeleteTableOfContentsPageNumberFromPanelDocument = gql`
    mutation DeleteTableOfContentsPageNumberFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteTableOfContentsPageNumberFromPanelMutationFn = Apollo.MutationFunction<DeleteTableOfContentsPageNumberFromPanelMutation, DeleteTableOfContentsPageNumberFromPanelMutationVariables>;

/**
 * __useDeleteTableOfContentsPageNumberFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteTableOfContentsPageNumberFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableOfContentsPageNumberFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableOfContentsPageNumberFromPanelMutation, { data, loading, error }] = useDeleteTableOfContentsPageNumberFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteTableOfContentsPageNumberFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTableOfContentsPageNumberFromPanelMutation, DeleteTableOfContentsPageNumberFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTableOfContentsPageNumberFromPanelMutation, DeleteTableOfContentsPageNumberFromPanelMutationVariables>(DeleteTableOfContentsPageNumberFromPanelDocument, options);
      }
export type DeleteTableOfContentsPageNumberFromPanelMutationHookResult = ReturnType<typeof useDeleteTableOfContentsPageNumberFromPanelMutation>;
export type DeleteTableOfContentsPageNumberFromPanelMutationResult = Apollo.MutationResult<DeleteTableOfContentsPageNumberFromPanelMutation>;
export type DeleteTableOfContentsPageNumberFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteTableOfContentsPageNumberFromPanelMutation, DeleteTableOfContentsPageNumberFromPanelMutationVariables>;
export const CreateTableOfContentsFromPanelDocument = gql`
    mutation CreateTableOfContentsFromPanel($regionId: ID!) {
  createTableOfContentsAttribute(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateTableOfContentsFromPanelMutationFn = Apollo.MutationFunction<CreateTableOfContentsFromPanelMutation, CreateTableOfContentsFromPanelMutationVariables>;

/**
 * __useCreateTableOfContentsFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateTableOfContentsFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableOfContentsFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableOfContentsFromPanelMutation, { data, loading, error }] = useCreateTableOfContentsFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useCreateTableOfContentsFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateTableOfContentsFromPanelMutation, CreateTableOfContentsFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTableOfContentsFromPanelMutation, CreateTableOfContentsFromPanelMutationVariables>(CreateTableOfContentsFromPanelDocument, options);
      }
export type CreateTableOfContentsFromPanelMutationHookResult = ReturnType<typeof useCreateTableOfContentsFromPanelMutation>;
export type CreateTableOfContentsFromPanelMutationResult = Apollo.MutationResult<CreateTableOfContentsFromPanelMutation>;
export type CreateTableOfContentsFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateTableOfContentsFromPanelMutation, CreateTableOfContentsFromPanelMutationVariables>;
export const DeleteTableOfContentsFromPanelDocument = gql`
    mutation DeleteTableOfContentsFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteTableOfContentsFromPanelMutationFn = Apollo.MutationFunction<DeleteTableOfContentsFromPanelMutation, DeleteTableOfContentsFromPanelMutationVariables>;

/**
 * __useDeleteTableOfContentsFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteTableOfContentsFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableOfContentsFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableOfContentsFromPanelMutation, { data, loading, error }] = useDeleteTableOfContentsFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteTableOfContentsFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTableOfContentsFromPanelMutation, DeleteTableOfContentsFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTableOfContentsFromPanelMutation, DeleteTableOfContentsFromPanelMutationVariables>(DeleteTableOfContentsFromPanelDocument, options);
      }
export type DeleteTableOfContentsFromPanelMutationHookResult = ReturnType<typeof useDeleteTableOfContentsFromPanelMutation>;
export type DeleteTableOfContentsFromPanelMutationResult = Apollo.MutationResult<DeleteTableOfContentsFromPanelMutation>;
export type DeleteTableOfContentsFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteTableOfContentsFromPanelMutation, DeleteTableOfContentsFromPanelMutationVariables>;
export const CreateTableFromPanelDocument = gql`
    mutation CreateTableFromPanel($regionId: ID!, $rows: [NonNegativeFloat!]!, $columns: [NonNegativeFloat!]!, $parentRowOffset: NonNegativeInt!, $parentColumnOffset: NonNegativeInt!) {
  createTableAttribute(
    input: {regionId: $regionId, rows: $rows, columns: $columns, parentRowOffset: $parentRowOffset, parentColumnOffset: $parentColumnOffset}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateTableFromPanelMutationFn = Apollo.MutationFunction<CreateTableFromPanelMutation, CreateTableFromPanelMutationVariables>;

/**
 * __useCreateTableFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateTableFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableFromPanelMutation, { data, loading, error }] = useCreateTableFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      rows: // value for 'rows'
 *      columns: // value for 'columns'
 *      parentRowOffset: // value for 'parentRowOffset'
 *      parentColumnOffset: // value for 'parentColumnOffset'
 *   },
 * });
 */
export function useCreateTableFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateTableFromPanelMutation, CreateTableFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTableFromPanelMutation, CreateTableFromPanelMutationVariables>(CreateTableFromPanelDocument, options);
      }
export type CreateTableFromPanelMutationHookResult = ReturnType<typeof useCreateTableFromPanelMutation>;
export type CreateTableFromPanelMutationResult = Apollo.MutationResult<CreateTableFromPanelMutation>;
export type CreateTableFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateTableFromPanelMutation, CreateTableFromPanelMutationVariables>;
export const DeleteTableFromPanelDocument = gql`
    mutation DeleteTableFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteTableFromPanelMutationFn = Apollo.MutationFunction<DeleteTableFromPanelMutation, DeleteTableFromPanelMutationVariables>;

/**
 * __useDeleteTableFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteTableFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableFromPanelMutation, { data, loading, error }] = useDeleteTableFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteTableFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTableFromPanelMutation, DeleteTableFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTableFromPanelMutation, DeleteTableFromPanelMutationVariables>(DeleteTableFromPanelDocument, options);
      }
export type DeleteTableFromPanelMutationHookResult = ReturnType<typeof useDeleteTableFromPanelMutation>;
export type DeleteTableFromPanelMutationResult = Apollo.MutationResult<DeleteTableFromPanelMutation>;
export type DeleteTableFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteTableFromPanelMutation, DeleteTableFromPanelMutationVariables>;
export const UpdateTableFromPanelDocument = gql`
    mutation UpdateTableFromPanel($attributeId: ID!, $rowOffset: NonNegativeInt, $columnOffset: NonNegativeInt, $rows: [NonNegativeFloat!]!, $columns: [NonNegativeFloat!]!) {
  updateTableAttribute(
    input: {attributeId: $attributeId, parentRowOffset: $rowOffset, parentColumnOffset: $columnOffset, rows: $rows, columns: $columns}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      parentRowOffset
      parentColumnOffset
      rows
      columns
    }
  }
}
    `;
export type UpdateTableFromPanelMutationFn = Apollo.MutationFunction<UpdateTableFromPanelMutation, UpdateTableFromPanelMutationVariables>;

/**
 * __useUpdateTableFromPanelMutation__
 *
 * To run a mutation, you first call `useUpdateTableFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableFromPanelMutation, { data, loading, error }] = useUpdateTableFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      rowOffset: // value for 'rowOffset'
 *      columnOffset: // value for 'columnOffset'
 *      rows: // value for 'rows'
 *      columns: // value for 'columns'
 *   },
 * });
 */
export function useUpdateTableFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTableFromPanelMutation, UpdateTableFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTableFromPanelMutation, UpdateTableFromPanelMutationVariables>(UpdateTableFromPanelDocument, options);
      }
export type UpdateTableFromPanelMutationHookResult = ReturnType<typeof useUpdateTableFromPanelMutation>;
export type UpdateTableFromPanelMutationResult = Apollo.MutationResult<UpdateTableFromPanelMutation>;
export type UpdateTableFromPanelMutationOptions = Apollo.BaseMutationOptions<UpdateTableFromPanelMutation, UpdateTableFromPanelMutationVariables>;
export const CreateTextFromPanelDocument = gql`
    mutation CreateTextFromPanel($regionId: ID!, $text: String!) {
  createTextAttribute(input: {regionId: $regionId, text: $text}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionCard
      }
    }
  }
}
    ${RegionCardFragmentDoc}`;
export type CreateTextFromPanelMutationFn = Apollo.MutationFunction<CreateTextFromPanelMutation, CreateTextFromPanelMutationVariables>;

/**
 * __useCreateTextFromPanelMutation__
 *
 * To run a mutation, you first call `useCreateTextFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTextFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTextFromPanelMutation, { data, loading, error }] = useCreateTextFromPanelMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCreateTextFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<CreateTextFromPanelMutation, CreateTextFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTextFromPanelMutation, CreateTextFromPanelMutationVariables>(CreateTextFromPanelDocument, options);
      }
export type CreateTextFromPanelMutationHookResult = ReturnType<typeof useCreateTextFromPanelMutation>;
export type CreateTextFromPanelMutationResult = Apollo.MutationResult<CreateTextFromPanelMutation>;
export type CreateTextFromPanelMutationOptions = Apollo.BaseMutationOptions<CreateTextFromPanelMutation, CreateTextFromPanelMutationVariables>;
export const DeleteTextFromPanelDocument = gql`
    mutation DeleteTextFromPanel($attributeId: ID!) {
  deleteAttribute(input: {attributeId: $attributeId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
    }
  }
}
    `;
export type DeleteTextFromPanelMutationFn = Apollo.MutationFunction<DeleteTextFromPanelMutation, DeleteTextFromPanelMutationVariables>;

/**
 * __useDeleteTextFromPanelMutation__
 *
 * To run a mutation, you first call `useDeleteTextFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTextFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTextFromPanelMutation, { data, loading, error }] = useDeleteTextFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteTextFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTextFromPanelMutation, DeleteTextFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTextFromPanelMutation, DeleteTextFromPanelMutationVariables>(DeleteTextFromPanelDocument, options);
      }
export type DeleteTextFromPanelMutationHookResult = ReturnType<typeof useDeleteTextFromPanelMutation>;
export type DeleteTextFromPanelMutationResult = Apollo.MutationResult<DeleteTextFromPanelMutation>;
export type DeleteTextFromPanelMutationOptions = Apollo.BaseMutationOptions<DeleteTextFromPanelMutation, DeleteTextFromPanelMutationVariables>;
export const UpdateTextFromPanelDocument = gql`
    mutation UpdateTextFromPanel($attributeId: ID!, $text: String!) {
  updateTextAttribute(input: {attributeId: $attributeId, text: $text}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      text
    }
  }
}
    `;
export type UpdateTextFromPanelMutationFn = Apollo.MutationFunction<UpdateTextFromPanelMutation, UpdateTextFromPanelMutationVariables>;

/**
 * __useUpdateTextFromPanelMutation__
 *
 * To run a mutation, you first call `useUpdateTextFromPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTextFromPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTextFromPanelMutation, { data, loading, error }] = useUpdateTextFromPanelMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateTextFromPanelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTextFromPanelMutation, UpdateTextFromPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTextFromPanelMutation, UpdateTextFromPanelMutationVariables>(UpdateTextFromPanelDocument, options);
      }
export type UpdateTextFromPanelMutationHookResult = ReturnType<typeof useUpdateTextFromPanelMutation>;
export type UpdateTextFromPanelMutationResult = Apollo.MutationResult<UpdateTextFromPanelMutation>;
export type UpdateTextFromPanelMutationOptions = Apollo.BaseMutationOptions<UpdateTextFromPanelMutation, UpdateTextFromPanelMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($id: ID!) {
  deleteDocument(input: {documentId: $id}) {
    userErrors {
      code
      path
    }
    document {
      id
    }
  }
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const DeleteArtifactDocument = gql`
    mutation DeleteArtifact($artifactId: ID!) {
  deleteArtifact(input: {artifactId: $artifactId}) {
    userErrors {
      code
      path
    }
    artifact {
      id
    }
  }
}
    `;
export type DeleteArtifactMutationFn = Apollo.MutationFunction<DeleteArtifactMutation, DeleteArtifactMutationVariables>;

/**
 * __useDeleteArtifactMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactMutation, { data, loading, error }] = useDeleteArtifactMutation({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useDeleteArtifactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArtifactMutation, DeleteArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArtifactMutation, DeleteArtifactMutationVariables>(DeleteArtifactDocument, options);
      }
export type DeleteArtifactMutationHookResult = ReturnType<typeof useDeleteArtifactMutation>;
export type DeleteArtifactMutationResult = Apollo.MutationResult<DeleteArtifactMutation>;
export type DeleteArtifactMutationOptions = Apollo.BaseMutationOptions<DeleteArtifactMutation, DeleteArtifactMutationVariables>;
export const DocumentExportDialogContentDocument = gql`
    query DocumentExportDialogContent($documentId: ID!) {
  document: node(id: $documentId) {
    ... on Document {
      id
      name
      artifacts {
        artifacts {
          id
          ...DocumentExportArtifact
        }
      }
    }
  }
}
    ${DocumentExportArtifactFragmentDoc}`;

/**
 * __useDocumentExportDialogContentQuery__
 *
 * To run a query within a React component, call `useDocumentExportDialogContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentExportDialogContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentExportDialogContentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentExportDialogContentQuery(baseOptions: Apollo.QueryHookOptions<DocumentExportDialogContentQuery, DocumentExportDialogContentQueryVariables> & ({ variables: DocumentExportDialogContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentExportDialogContentQuery, DocumentExportDialogContentQueryVariables>(DocumentExportDialogContentDocument, options);
      }
export function useDocumentExportDialogContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentExportDialogContentQuery, DocumentExportDialogContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentExportDialogContentQuery, DocumentExportDialogContentQueryVariables>(DocumentExportDialogContentDocument, options);
        }
export function useDocumentExportDialogContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentExportDialogContentQuery, DocumentExportDialogContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentExportDialogContentQuery, DocumentExportDialogContentQueryVariables>(DocumentExportDialogContentDocument, options);
        }
export type DocumentExportDialogContentQueryHookResult = ReturnType<typeof useDocumentExportDialogContentQuery>;
export type DocumentExportDialogContentLazyQueryHookResult = ReturnType<typeof useDocumentExportDialogContentLazyQuery>;
export type DocumentExportDialogContentSuspenseQueryHookResult = ReturnType<typeof useDocumentExportDialogContentSuspenseQuery>;
export type DocumentExportDialogContentQueryResult = Apollo.QueryResult<DocumentExportDialogContentQuery, DocumentExportDialogContentQueryVariables>;
export const CreateArtifactDocument = gql`
    mutation CreateArtifact($documentId: ID!, $exportType: ExporterType!) {
  createArtifact(input: {documentId: $documentId, type: $exportType}) {
    userErrors {
      code
      path
    }
    artifact {
      id
      source {
        id
        artifacts {
          artifacts {
            id
            ...DocumentExportArtifact
          }
        }
      }
    }
  }
}
    ${DocumentExportArtifactFragmentDoc}`;
export type CreateArtifactMutationFn = Apollo.MutationFunction<CreateArtifactMutation, CreateArtifactMutationVariables>;

/**
 * __useCreateArtifactMutation__
 *
 * To run a mutation, you first call `useCreateArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactMutation, { data, loading, error }] = useCreateArtifactMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      exportType: // value for 'exportType'
 *   },
 * });
 */
export function useCreateArtifactMutation(baseOptions?: Apollo.MutationHookOptions<CreateArtifactMutation, CreateArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArtifactMutation, CreateArtifactMutationVariables>(CreateArtifactDocument, options);
      }
export type CreateArtifactMutationHookResult = ReturnType<typeof useCreateArtifactMutation>;
export type CreateArtifactMutationResult = Apollo.MutationResult<CreateArtifactMutation>;
export type CreateArtifactMutationOptions = Apollo.BaseMutationOptions<CreateArtifactMutation, CreateArtifactMutationVariables>;
export const RenameDocumentDocument = gql`
    mutation RenameDocument($documentId: ID!, $newName: String!) {
  renameDocument(input: {documentId: $documentId, name: $newName}) {
    userErrors {
      code
      path
    }
    document {
      id
      name
      ...DocumentRenameDialogContent
    }
  }
}
    ${DocumentRenameDialogContentFragmentDoc}`;
export type RenameDocumentMutationFn = Apollo.MutationFunction<RenameDocumentMutation, RenameDocumentMutationVariables>;

/**
 * __useRenameDocumentMutation__
 *
 * To run a mutation, you first call `useRenameDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameDocumentMutation, { data, loading, error }] = useRenameDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useRenameDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RenameDocumentMutation, RenameDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameDocumentMutation, RenameDocumentMutationVariables>(RenameDocumentDocument, options);
      }
export type RenameDocumentMutationHookResult = ReturnType<typeof useRenameDocumentMutation>;
export type RenameDocumentMutationResult = Apollo.MutationResult<RenameDocumentMutation>;
export type RenameDocumentMutationOptions = Apollo.BaseMutationOptions<RenameDocumentMutation, RenameDocumentMutationVariables>;
export const DocumentShareDialogContentDocument = gql`
    query DocumentShareDialogContent($documentId: ID!) {
  document: node(id: $documentId) {
    ... on Document {
      id
      name
      members {
        memberships {
          document {
            id
          }
          user {
            id
            ...DocumentShareCollaborator
          }
          ...DocumentSharePermission
        }
      }
      viewerMembership {
        user {
          id
          colleagues {
            ...DocumentShareComboxbox
          }
        }
        document {
          id
        }
      }
    }
  }
}
    ${DocumentShareCollaboratorFragmentDoc}
${DocumentSharePermissionFragmentDoc}
${DocumentShareComboxboxFragmentDoc}`;

/**
 * __useDocumentShareDialogContentQuery__
 *
 * To run a query within a React component, call `useDocumentShareDialogContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentShareDialogContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentShareDialogContentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentShareDialogContentQuery(baseOptions: Apollo.QueryHookOptions<DocumentShareDialogContentQuery, DocumentShareDialogContentQueryVariables> & ({ variables: DocumentShareDialogContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentShareDialogContentQuery, DocumentShareDialogContentQueryVariables>(DocumentShareDialogContentDocument, options);
      }
export function useDocumentShareDialogContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentShareDialogContentQuery, DocumentShareDialogContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentShareDialogContentQuery, DocumentShareDialogContentQueryVariables>(DocumentShareDialogContentDocument, options);
        }
export function useDocumentShareDialogContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentShareDialogContentQuery, DocumentShareDialogContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentShareDialogContentQuery, DocumentShareDialogContentQueryVariables>(DocumentShareDialogContentDocument, options);
        }
export type DocumentShareDialogContentQueryHookResult = ReturnType<typeof useDocumentShareDialogContentQuery>;
export type DocumentShareDialogContentLazyQueryHookResult = ReturnType<typeof useDocumentShareDialogContentLazyQuery>;
export type DocumentShareDialogContentSuspenseQueryHookResult = ReturnType<typeof useDocumentShareDialogContentSuspenseQuery>;
export type DocumentShareDialogContentQueryResult = Apollo.QueryResult<DocumentShareDialogContentQuery, DocumentShareDialogContentQueryVariables>;
export const ShareDocumentDocument = gql`
    mutation ShareDocument($documentId: ID!, $userId: ID!) {
  updateDocumentPermission(
    input: {documentId: $documentId, userId: $userId, permission: READ}
  ) {
    userErrors {
      code
      path
    }
    membership {
      document {
        id
        members {
          memberships {
            document {
              id
            }
            user {
              id
              ...DocumentShareCollaborator
            }
            ...DocumentSharePermission
          }
        }
      }
      user {
        id
      }
      permission
    }
  }
}
    ${DocumentShareCollaboratorFragmentDoc}
${DocumentSharePermissionFragmentDoc}`;
export type ShareDocumentMutationFn = Apollo.MutationFunction<ShareDocumentMutation, ShareDocumentMutationVariables>;

/**
 * __useShareDocumentMutation__
 *
 * To run a mutation, you first call `useShareDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareDocumentMutation, { data, loading, error }] = useShareDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useShareDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ShareDocumentMutation, ShareDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareDocumentMutation, ShareDocumentMutationVariables>(ShareDocumentDocument, options);
      }
export type ShareDocumentMutationHookResult = ReturnType<typeof useShareDocumentMutation>;
export type ShareDocumentMutationResult = Apollo.MutationResult<ShareDocumentMutation>;
export type ShareDocumentMutationOptions = Apollo.BaseMutationOptions<ShareDocumentMutation, ShareDocumentMutationVariables>;
export const UpdateDocumentPermissionDocument = gql`
    mutation UpdateDocumentPermission($documentId: ID!, $userId: ID!, $permission: Permission!) {
  updateDocumentPermission(
    input: {documentId: $documentId, userId: $userId, permission: $permission}
  ) {
    userErrors {
      code
      path
    }
    membership {
      document {
        id
      }
      user {
        id
      }
      permission
    }
  }
}
    `;
export type UpdateDocumentPermissionMutationFn = Apollo.MutationFunction<UpdateDocumentPermissionMutation, UpdateDocumentPermissionMutationVariables>;

/**
 * __useUpdateDocumentPermissionMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentPermissionMutation, { data, loading, error }] = useUpdateDocumentPermissionMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      userId: // value for 'userId'
 *      permission: // value for 'permission'
 *   },
 * });
 */
export function useUpdateDocumentPermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentPermissionMutation, UpdateDocumentPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentPermissionMutation, UpdateDocumentPermissionMutationVariables>(UpdateDocumentPermissionDocument, options);
      }
export type UpdateDocumentPermissionMutationHookResult = ReturnType<typeof useUpdateDocumentPermissionMutation>;
export type UpdateDocumentPermissionMutationResult = Apollo.MutationResult<UpdateDocumentPermissionMutation>;
export type UpdateDocumentPermissionMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentPermissionMutation, UpdateDocumentPermissionMutationVariables>;
export const DocumentTagsDialogContentDocument = gql`
    query DocumentTagsDialogContent($documentId: ID!) {
  document: node(id: $documentId) {
    ... on Document {
      id
      name
      ...DocumentTagsInput
      ...DocumentTagsSuggestions
    }
  }
}
    ${DocumentTagsInputFragmentDoc}
${DocumentTagsSuggestionsFragmentDoc}`;

/**
 * __useDocumentTagsDialogContentQuery__
 *
 * To run a query within a React component, call `useDocumentTagsDialogContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentTagsDialogContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentTagsDialogContentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentTagsDialogContentQuery(baseOptions: Apollo.QueryHookOptions<DocumentTagsDialogContentQuery, DocumentTagsDialogContentQueryVariables> & ({ variables: DocumentTagsDialogContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentTagsDialogContentQuery, DocumentTagsDialogContentQueryVariables>(DocumentTagsDialogContentDocument, options);
      }
export function useDocumentTagsDialogContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentTagsDialogContentQuery, DocumentTagsDialogContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentTagsDialogContentQuery, DocumentTagsDialogContentQueryVariables>(DocumentTagsDialogContentDocument, options);
        }
export function useDocumentTagsDialogContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentTagsDialogContentQuery, DocumentTagsDialogContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentTagsDialogContentQuery, DocumentTagsDialogContentQueryVariables>(DocumentTagsDialogContentDocument, options);
        }
export type DocumentTagsDialogContentQueryHookResult = ReturnType<typeof useDocumentTagsDialogContentQuery>;
export type DocumentTagsDialogContentLazyQueryHookResult = ReturnType<typeof useDocumentTagsDialogContentLazyQuery>;
export type DocumentTagsDialogContentSuspenseQueryHookResult = ReturnType<typeof useDocumentTagsDialogContentSuspenseQuery>;
export type DocumentTagsDialogContentQueryResult = Apollo.QueryResult<DocumentTagsDialogContentQuery, DocumentTagsDialogContentQueryVariables>;
export const TagDocumentDocument = gql`
    mutation TagDocument($documentId: ID!, $tag: String!) {
  addDocumentTag(input: {documentId: $documentId, tag: $tag}) {
    userErrors {
      code
      path
    }
    document {
      id
      ...DocumentTagsInput
      ...DocumentTagsSuggestions
    }
  }
}
    ${DocumentTagsInputFragmentDoc}
${DocumentTagsSuggestionsFragmentDoc}`;
export type TagDocumentMutationFn = Apollo.MutationFunction<TagDocumentMutation, TagDocumentMutationVariables>;

/**
 * __useTagDocumentMutation__
 *
 * To run a mutation, you first call `useTagDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagDocumentMutation, { data, loading, error }] = useTagDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useTagDocumentMutation(baseOptions?: Apollo.MutationHookOptions<TagDocumentMutation, TagDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagDocumentMutation, TagDocumentMutationVariables>(TagDocumentDocument, options);
      }
export type TagDocumentMutationHookResult = ReturnType<typeof useTagDocumentMutation>;
export type TagDocumentMutationResult = Apollo.MutationResult<TagDocumentMutation>;
export type TagDocumentMutationOptions = Apollo.BaseMutationOptions<TagDocumentMutation, TagDocumentMutationVariables>;
export const UntagDocumentDocument = gql`
    mutation UntagDocument($documentId: ID!, $tag: String!) {
  removeDocumentTag(input: {documentId: $documentId, tag: $tag}) {
    userErrors {
      code
      path
    }
    document {
      id
      ...DocumentTagsInput
      ...DocumentTagsSuggestions
    }
  }
}
    ${DocumentTagsInputFragmentDoc}
${DocumentTagsSuggestionsFragmentDoc}`;
export type UntagDocumentMutationFn = Apollo.MutationFunction<UntagDocumentMutation, UntagDocumentMutationVariables>;

/**
 * __useUntagDocumentMutation__
 *
 * To run a mutation, you first call `useUntagDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUntagDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [untagDocumentMutation, { data, loading, error }] = useUntagDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useUntagDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UntagDocumentMutation, UntagDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UntagDocumentMutation, UntagDocumentMutationVariables>(UntagDocumentDocument, options);
      }
export type UntagDocumentMutationHookResult = ReturnType<typeof useUntagDocumentMutation>;
export type UntagDocumentMutationResult = Apollo.MutationResult<UntagDocumentMutation>;
export type UntagDocumentMutationOptions = Apollo.BaseMutationOptions<UntagDocumentMutation, UntagDocumentMutationVariables>;
export const NavbarExportTabContentDocument = gql`
    query NavbarExportTabContent($documentId: ID!) {
  document: node(id: $documentId) {
    ... on Document {
      id
      name
      artifacts {
        artifacts {
          id
          ...DocumentExportArtifact
        }
      }
    }
  }
}
    ${DocumentExportArtifactFragmentDoc}`;

/**
 * __useNavbarExportTabContentQuery__
 *
 * To run a query within a React component, call `useNavbarExportTabContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavbarExportTabContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavbarExportTabContentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useNavbarExportTabContentQuery(baseOptions: Apollo.QueryHookOptions<NavbarExportTabContentQuery, NavbarExportTabContentQueryVariables> & ({ variables: NavbarExportTabContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavbarExportTabContentQuery, NavbarExportTabContentQueryVariables>(NavbarExportTabContentDocument, options);
      }
export function useNavbarExportTabContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavbarExportTabContentQuery, NavbarExportTabContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavbarExportTabContentQuery, NavbarExportTabContentQueryVariables>(NavbarExportTabContentDocument, options);
        }
export function useNavbarExportTabContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NavbarExportTabContentQuery, NavbarExportTabContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavbarExportTabContentQuery, NavbarExportTabContentQueryVariables>(NavbarExportTabContentDocument, options);
        }
export type NavbarExportTabContentQueryHookResult = ReturnType<typeof useNavbarExportTabContentQuery>;
export type NavbarExportTabContentLazyQueryHookResult = ReturnType<typeof useNavbarExportTabContentLazyQuery>;
export type NavbarExportTabContentSuspenseQueryHookResult = ReturnType<typeof useNavbarExportTabContentSuspenseQuery>;
export type NavbarExportTabContentQueryResult = Apollo.QueryResult<NavbarExportTabContentQuery, NavbarExportTabContentQueryVariables>;
export const UpdateReadingOrderDocument = gql`
    mutation UpdateReadingOrder($regionId: ID!, $readingOrderIndex: NonNegativeInt!) {
  updateRegionReadingOrderIndex(
    input: {regionId: $regionId, readingOrderIndex: $readingOrderIndex}
  ) {
    userErrors {
      code
      path
    }
    region {
      id
      readingOrderIndex
    }
  }
}
    `;
export type UpdateReadingOrderMutationFn = Apollo.MutationFunction<UpdateReadingOrderMutation, UpdateReadingOrderMutationVariables>;

/**
 * __useUpdateReadingOrderMutation__
 *
 * To run a mutation, you first call `useUpdateReadingOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReadingOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReadingOrderMutation, { data, loading, error }] = useUpdateReadingOrderMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      readingOrderIndex: // value for 'readingOrderIndex'
 *   },
 * });
 */
export function useUpdateReadingOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReadingOrderMutation, UpdateReadingOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReadingOrderMutation, UpdateReadingOrderMutationVariables>(UpdateReadingOrderDocument, options);
      }
export type UpdateReadingOrderMutationHookResult = ReturnType<typeof useUpdateReadingOrderMutation>;
export type UpdateReadingOrderMutationResult = Apollo.MutationResult<UpdateReadingOrderMutation>;
export type UpdateReadingOrderMutationOptions = Apollo.BaseMutationOptions<UpdateReadingOrderMutation, UpdateReadingOrderMutationVariables>;
export const AddAuthorDocument = gql`
    mutation AddAuthor($documentId: ID!, $name: String!) {
  addAuthor(input: {documentId: $documentId, name: $name}) {
    userErrors {
      code
      path
    }
    author {
      id
      name
    }
  }
}
    `;
export type AddAuthorMutationFn = Apollo.MutationFunction<AddAuthorMutation, AddAuthorMutationVariables>;

/**
 * __useAddAuthorMutation__
 *
 * To run a mutation, you first call `useAddAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAuthorMutation, { data, loading, error }] = useAddAuthorMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddAuthorMutation(baseOptions?: Apollo.MutationHookOptions<AddAuthorMutation, AddAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAuthorMutation, AddAuthorMutationVariables>(AddAuthorDocument, options);
      }
export type AddAuthorMutationHookResult = ReturnType<typeof useAddAuthorMutation>;
export type AddAuthorMutationResult = Apollo.MutationResult<AddAuthorMutation>;
export type AddAuthorMutationOptions = Apollo.BaseMutationOptions<AddAuthorMutation, AddAuthorMutationVariables>;
export const RenameAuthorDocument = gql`
    mutation RenameAuthor($authorId: ID!, $name: String!) {
  renameAuthor(input: {authorId: $authorId, name: $name}) {
    userErrors {
      code
      path
    }
    author {
      id
      name
    }
  }
}
    `;
export type RenameAuthorMutationFn = Apollo.MutationFunction<RenameAuthorMutation, RenameAuthorMutationVariables>;

/**
 * __useRenameAuthorMutation__
 *
 * To run a mutation, you first call `useRenameAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameAuthorMutation, { data, loading, error }] = useRenameAuthorMutation({
 *   variables: {
 *      authorId: // value for 'authorId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameAuthorMutation(baseOptions?: Apollo.MutationHookOptions<RenameAuthorMutation, RenameAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameAuthorMutation, RenameAuthorMutationVariables>(RenameAuthorDocument, options);
      }
export type RenameAuthorMutationHookResult = ReturnType<typeof useRenameAuthorMutation>;
export type RenameAuthorMutationResult = Apollo.MutationResult<RenameAuthorMutation>;
export type RenameAuthorMutationOptions = Apollo.BaseMutationOptions<RenameAuthorMutation, RenameAuthorMutationVariables>;
export const RemoveAuthorDocument = gql`
    mutation RemoveAuthor($authorId: ID!) {
  removeAuthor(input: {authorId: $authorId}) {
    userErrors {
      code
      path
    }
    author {
      id
    }
  }
}
    `;
export type RemoveAuthorMutationFn = Apollo.MutationFunction<RemoveAuthorMutation, RemoveAuthorMutationVariables>;

/**
 * __useRemoveAuthorMutation__
 *
 * To run a mutation, you first call `useRemoveAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAuthorMutation, { data, loading, error }] = useRemoveAuthorMutation({
 *   variables: {
 *      authorId: // value for 'authorId'
 *   },
 * });
 */
export function useRemoveAuthorMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAuthorMutation, RemoveAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAuthorMutation, RemoveAuthorMutationVariables>(RemoveAuthorDocument, options);
      }
export type RemoveAuthorMutationHookResult = ReturnType<typeof useRemoveAuthorMutation>;
export type RemoveAuthorMutationResult = Apollo.MutationResult<RemoveAuthorMutation>;
export type RemoveAuthorMutationOptions = Apollo.BaseMutationOptions<RemoveAuthorMutation, RemoveAuthorMutationVariables>;
export const SetDocumentDateDocument = gql`
    mutation SetDocumentDate($documentId: ID!, $date: DateTime) {
  setDate(input: {documentId: $documentId, date: $date}) {
    userErrors {
      code
      path
    }
    metadata {
      document {
        id
      }
      date
    }
  }
}
    `;
export type SetDocumentDateMutationFn = Apollo.MutationFunction<SetDocumentDateMutation, SetDocumentDateMutationVariables>;

/**
 * __useSetDocumentDateMutation__
 *
 * To run a mutation, you first call `useSetDocumentDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentDateMutation, { data, loading, error }] = useSetDocumentDateMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useSetDocumentDateMutation(baseOptions?: Apollo.MutationHookOptions<SetDocumentDateMutation, SetDocumentDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDocumentDateMutation, SetDocumentDateMutationVariables>(SetDocumentDateDocument, options);
      }
export type SetDocumentDateMutationHookResult = ReturnType<typeof useSetDocumentDateMutation>;
export type SetDocumentDateMutationResult = Apollo.MutationResult<SetDocumentDateMutation>;
export type SetDocumentDateMutationOptions = Apollo.BaseMutationOptions<SetDocumentDateMutation, SetDocumentDateMutationVariables>;
export const AddSubjectDocument = gql`
    mutation AddSubject($documentId: ID!, $subject: String!) {
  addSubject(input: {documentId: $documentId, subject: $subject}) {
    userErrors {
      code
      path
    }
    subject {
      id
      subject
    }
  }
}
    `;
export type AddSubjectMutationFn = Apollo.MutationFunction<AddSubjectMutation, AddSubjectMutationVariables>;

/**
 * __useAddSubjectMutation__
 *
 * To run a mutation, you first call `useAddSubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubjectMutation, { data, loading, error }] = useAddSubjectMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useAddSubjectMutation(baseOptions?: Apollo.MutationHookOptions<AddSubjectMutation, AddSubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSubjectMutation, AddSubjectMutationVariables>(AddSubjectDocument, options);
      }
export type AddSubjectMutationHookResult = ReturnType<typeof useAddSubjectMutation>;
export type AddSubjectMutationResult = Apollo.MutationResult<AddSubjectMutation>;
export type AddSubjectMutationOptions = Apollo.BaseMutationOptions<AddSubjectMutation, AddSubjectMutationVariables>;
export const RemoveSubjectDocument = gql`
    mutation RemoveSubject($subjectId: ID!) {
  removeSubject(input: {subjectId: $subjectId}) {
    userErrors {
      code
      path
    }
    subject {
      id
    }
  }
}
    `;
export type RemoveSubjectMutationFn = Apollo.MutationFunction<RemoveSubjectMutation, RemoveSubjectMutationVariables>;

/**
 * __useRemoveSubjectMutation__
 *
 * To run a mutation, you first call `useRemoveSubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSubjectMutation, { data, loading, error }] = useRemoveSubjectMutation({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *   },
 * });
 */
export function useRemoveSubjectMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSubjectMutation, RemoveSubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSubjectMutation, RemoveSubjectMutationVariables>(RemoveSubjectDocument, options);
      }
export type RemoveSubjectMutationHookResult = ReturnType<typeof useRemoveSubjectMutation>;
export type RemoveSubjectMutationResult = Apollo.MutationResult<RemoveSubjectMutation>;
export type RemoveSubjectMutationOptions = Apollo.BaseMutationOptions<RemoveSubjectMutation, RemoveSubjectMutationVariables>;
export const SetDocumentLanguageDocument = gql`
    mutation SetDocumentLanguage($documentId: ID!, $language: String!) {
  setLanguage(input: {documentId: $documentId, language: $language}) {
    userErrors {
      code
      path
    }
    metadata {
      document {
        id
      }
      language
    }
  }
}
    `;
export type SetDocumentLanguageMutationFn = Apollo.MutationFunction<SetDocumentLanguageMutation, SetDocumentLanguageMutationVariables>;

/**
 * __useSetDocumentLanguageMutation__
 *
 * To run a mutation, you first call `useSetDocumentLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentLanguageMutation, { data, loading, error }] = useSetDocumentLanguageMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSetDocumentLanguageMutation(baseOptions?: Apollo.MutationHookOptions<SetDocumentLanguageMutation, SetDocumentLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDocumentLanguageMutation, SetDocumentLanguageMutationVariables>(SetDocumentLanguageDocument, options);
      }
export type SetDocumentLanguageMutationHookResult = ReturnType<typeof useSetDocumentLanguageMutation>;
export type SetDocumentLanguageMutationResult = Apollo.MutationResult<SetDocumentLanguageMutation>;
export type SetDocumentLanguageMutationOptions = Apollo.BaseMutationOptions<SetDocumentLanguageMutation, SetDocumentLanguageMutationVariables>;
export const AddTitleDocument = gql`
    mutation AddTitle($documentId: ID!, $language: String!, $title: String!) {
  addTitle(input: {documentId: $documentId, language: $language, title: $title}) {
    userErrors {
      code
      path
    }
    title {
      id
      title
      language
    }
  }
}
    `;
export type AddTitleMutationFn = Apollo.MutationFunction<AddTitleMutation, AddTitleMutationVariables>;

/**
 * __useAddTitleMutation__
 *
 * To run a mutation, you first call `useAddTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTitleMutation, { data, loading, error }] = useAddTitleMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      language: // value for 'language'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useAddTitleMutation(baseOptions?: Apollo.MutationHookOptions<AddTitleMutation, AddTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTitleMutation, AddTitleMutationVariables>(AddTitleDocument, options);
      }
export type AddTitleMutationHookResult = ReturnType<typeof useAddTitleMutation>;
export type AddTitleMutationResult = Apollo.MutationResult<AddTitleMutation>;
export type AddTitleMutationOptions = Apollo.BaseMutationOptions<AddTitleMutation, AddTitleMutationVariables>;
export const RemoveTitleDocument = gql`
    mutation RemoveTitle($titleId: ID!) {
  removeTitle(input: {titleId: $titleId}) {
    userErrors {
      code
      path
    }
    title {
      id
    }
  }
}
    `;
export type RemoveTitleMutationFn = Apollo.MutationFunction<RemoveTitleMutation, RemoveTitleMutationVariables>;

/**
 * __useRemoveTitleMutation__
 *
 * To run a mutation, you first call `useRemoveTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTitleMutation, { data, loading, error }] = useRemoveTitleMutation({
 *   variables: {
 *      titleId: // value for 'titleId'
 *   },
 * });
 */
export function useRemoveTitleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTitleMutation, RemoveTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTitleMutation, RemoveTitleMutationVariables>(RemoveTitleDocument, options);
      }
export type RemoveTitleMutationHookResult = ReturnType<typeof useRemoveTitleMutation>;
export type RemoveTitleMutationResult = Apollo.MutationResult<RemoveTitleMutation>;
export type RemoveTitleMutationOptions = Apollo.BaseMutationOptions<RemoveTitleMutation, RemoveTitleMutationVariables>;
export const UpdateTitleDocument = gql`
    mutation UpdateTitle($titleId: ID!, $title: String!, $language: String!) {
  renameTitle(input: {titleId: $titleId, title: $title}) {
    userErrors {
      code
      path
    }
    title {
      id
      title
    }
  }
  changeTitleLanguage(input: {titleId: $titleId, language: $language}) {
    userErrors {
      code
      path
    }
    title {
      id
      language
    }
  }
}
    `;
export type UpdateTitleMutationFn = Apollo.MutationFunction<UpdateTitleMutation, UpdateTitleMutationVariables>;

/**
 * __useUpdateTitleMutation__
 *
 * To run a mutation, you first call `useUpdateTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTitleMutation, { data, loading, error }] = useUpdateTitleMutation({
 *   variables: {
 *      titleId: // value for 'titleId'
 *      title: // value for 'title'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTitleMutation, UpdateTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTitleMutation, UpdateTitleMutationVariables>(UpdateTitleDocument, options);
      }
export type UpdateTitleMutationHookResult = ReturnType<typeof useUpdateTitleMutation>;
export type UpdateTitleMutationResult = Apollo.MutationResult<UpdateTitleMutation>;
export type UpdateTitleMutationOptions = Apollo.BaseMutationOptions<UpdateTitleMutation, UpdateTitleMutationVariables>;
export const DeleteRegionFromContextDocument = gql`
    mutation DeleteRegionFromContext($regionId: ID!) {
  deleteRegion(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    region {
      id
    }
  }
}
    `;
export type DeleteRegionFromContextMutationFn = Apollo.MutationFunction<DeleteRegionFromContextMutation, DeleteRegionFromContextMutationVariables>;

/**
 * __useDeleteRegionFromContextMutation__
 *
 * To run a mutation, you first call `useDeleteRegionFromContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegionFromContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegionFromContextMutation, { data, loading, error }] = useDeleteRegionFromContextMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useDeleteRegionFromContextMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegionFromContextMutation, DeleteRegionFromContextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegionFromContextMutation, DeleteRegionFromContextMutationVariables>(DeleteRegionFromContextDocument, options);
      }
export type DeleteRegionFromContextMutationHookResult = ReturnType<typeof useDeleteRegionFromContextMutation>;
export type DeleteRegionFromContextMutationResult = Apollo.MutationResult<DeleteRegionFromContextMutation>;
export type DeleteRegionFromContextMutationOptions = Apollo.BaseMutationOptions<DeleteRegionFromContextMutation, DeleteRegionFromContextMutationVariables>;
export const DeleteRegionViaShortcutDocument = gql`
    mutation DeleteRegionViaShortcut($regionId: ID!) {
  deleteRegion(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    region {
      id
    }
  }
}
    `;
export type DeleteRegionViaShortcutMutationFn = Apollo.MutationFunction<DeleteRegionViaShortcutMutation, DeleteRegionViaShortcutMutationVariables>;

/**
 * __useDeleteRegionViaShortcutMutation__
 *
 * To run a mutation, you first call `useDeleteRegionViaShortcutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegionViaShortcutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegionViaShortcutMutation, { data, loading, error }] = useDeleteRegionViaShortcutMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useDeleteRegionViaShortcutMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegionViaShortcutMutation, DeleteRegionViaShortcutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegionViaShortcutMutation, DeleteRegionViaShortcutMutationVariables>(DeleteRegionViaShortcutDocument, options);
      }
export type DeleteRegionViaShortcutMutationHookResult = ReturnType<typeof useDeleteRegionViaShortcutMutation>;
export type DeleteRegionViaShortcutMutationResult = Apollo.MutationResult<DeleteRegionViaShortcutMutation>;
export type DeleteRegionViaShortcutMutationOptions = Apollo.BaseMutationOptions<DeleteRegionViaShortcutMutation, DeleteRegionViaShortcutMutationVariables>;
export const CreateRegionDocument = gql`
    mutation CreateRegion($pageId: ID!, $vertices: [InputVertex!]!) {
  createRegion(input: {pageId: $pageId, shape: {vertices: $vertices}}) {
    userErrors {
      code
      path
    }
    region {
      id
    }
  }
}
    `;
export type CreateRegionMutationFn = Apollo.MutationFunction<CreateRegionMutation, CreateRegionMutationVariables>;

/**
 * __useCreateRegionMutation__
 *
 * To run a mutation, you first call `useCreateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegionMutation, { data, loading, error }] = useCreateRegionMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      vertices: // value for 'vertices'
 *   },
 * });
 */
export function useCreateRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegionMutation, CreateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegionMutation, CreateRegionMutationVariables>(CreateRegionDocument, options);
      }
export type CreateRegionMutationHookResult = ReturnType<typeof useCreateRegionMutation>;
export type CreateRegionMutationResult = Apollo.MutationResult<CreateRegionMutation>;
export type CreateRegionMutationOptions = Apollo.BaseMutationOptions<CreateRegionMutation, CreateRegionMutationVariables>;
export const UpdateRegionVerticesDocument = gql`
    mutation UpdateRegionVertices($regionId: ID!, $vertices: [InputVertex!]!) {
  updateRegionShape(input: {regionId: $regionId, shape: {vertices: $vertices}}) {
    userErrors {
      code
      path
    }
    region {
      ...TransformableRegion
      ...ReshapeableRegion
    }
  }
}
    ${TransformableRegionFragmentDoc}
${ReshapeableRegionFragmentDoc}`;
export type UpdateRegionVerticesMutationFn = Apollo.MutationFunction<UpdateRegionVerticesMutation, UpdateRegionVerticesMutationVariables>;

/**
 * __useUpdateRegionVerticesMutation__
 *
 * To run a mutation, you first call `useUpdateRegionVerticesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegionVerticesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegionVerticesMutation, { data, loading, error }] = useUpdateRegionVerticesMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      vertices: // value for 'vertices'
 *   },
 * });
 */
export function useUpdateRegionVerticesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegionVerticesMutation, UpdateRegionVerticesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegionVerticesMutation, UpdateRegionVerticesMutationVariables>(UpdateRegionVerticesDocument, options);
      }
export type UpdateRegionVerticesMutationHookResult = ReturnType<typeof useUpdateRegionVerticesMutation>;
export type UpdateRegionVerticesMutationResult = Apollo.MutationResult<UpdateRegionVerticesMutation>;
export type UpdateRegionVerticesMutationOptions = Apollo.BaseMutationOptions<UpdateRegionVerticesMutation, UpdateRegionVerticesMutationVariables>;
export const UpdateRegionShapeDocument = gql`
    mutation UpdateRegionShape($regionId: ID!, $vertices: [InputVertex!]!) {
  updateRegionShape(input: {regionId: $regionId, shape: {vertices: $vertices}}) {
    userErrors {
      code
      path
    }
    region {
      ...ReshapeableRegion
      ...TransformableRegion
    }
  }
}
    ${ReshapeableRegionFragmentDoc}
${TransformableRegionFragmentDoc}`;
export type UpdateRegionShapeMutationFn = Apollo.MutationFunction<UpdateRegionShapeMutation, UpdateRegionShapeMutationVariables>;

/**
 * __useUpdateRegionShapeMutation__
 *
 * To run a mutation, you first call `useUpdateRegionShapeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegionShapeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegionShapeMutation, { data, loading, error }] = useUpdateRegionShapeMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      vertices: // value for 'vertices'
 *   },
 * });
 */
export function useUpdateRegionShapeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegionShapeMutation, UpdateRegionShapeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegionShapeMutation, UpdateRegionShapeMutationVariables>(UpdateRegionShapeDocument, options);
      }
export type UpdateRegionShapeMutationHookResult = ReturnType<typeof useUpdateRegionShapeMutation>;
export type UpdateRegionShapeMutationResult = Apollo.MutationResult<UpdateRegionShapeMutation>;
export type UpdateRegionShapeMutationOptions = Apollo.BaseMutationOptions<UpdateRegionShapeMutation, UpdateRegionShapeMutationVariables>;
export const DocumentScreenDocument = gql`
    query DocumentScreen($documentId: ID!) {
  node(id: $documentId) {
    ... on Document {
      id
      name
      pages {
        pages {
          id
          ...PageIssuesBadge
          ...PageThumbnail
        }
      }
    }
    ...NavbarMetadataTabContent
    ...NavbarExportTabContent
    ...NavbarNextPageButton
    ...NavbarPreviousPageButton
  }
}
    ${PageIssuesBadgeFragmentDoc}
${PageThumbnailFragmentDoc}
${NavbarMetadataTabContentFragmentDoc}
${NavbarExportTabContentFragmentDoc}
${NavbarNextPageButtonFragmentDoc}
${NavbarPreviousPageButtonFragmentDoc}`;

/**
 * __useDocumentScreenQuery__
 *
 * To run a query within a React component, call `useDocumentScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentScreenQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentScreenQuery(baseOptions: Apollo.QueryHookOptions<DocumentScreenQuery, DocumentScreenQueryVariables> & ({ variables: DocumentScreenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentScreenQuery, DocumentScreenQueryVariables>(DocumentScreenDocument, options);
      }
export function useDocumentScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentScreenQuery, DocumentScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentScreenQuery, DocumentScreenQueryVariables>(DocumentScreenDocument, options);
        }
export function useDocumentScreenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentScreenQuery, DocumentScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentScreenQuery, DocumentScreenQueryVariables>(DocumentScreenDocument, options);
        }
export type DocumentScreenQueryHookResult = ReturnType<typeof useDocumentScreenQuery>;
export type DocumentScreenLazyQueryHookResult = ReturnType<typeof useDocumentScreenLazyQuery>;
export type DocumentScreenSuspenseQueryHookResult = ReturnType<typeof useDocumentScreenSuspenseQuery>;
export type DocumentScreenQueryResult = Apollo.QueryResult<DocumentScreenQuery, DocumentScreenQueryVariables>;
export const DocumentsScreenDocument = gql`
    query DocumentsScreen {
  viewer {
    id
    memberships {
      ...DocumentTable
    }
  }
}
    ${DocumentTableFragmentDoc}`;

/**
 * __useDocumentsScreenQuery__
 *
 * To run a query within a React component, call `useDocumentsScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentsScreenQuery(baseOptions?: Apollo.QueryHookOptions<DocumentsScreenQuery, DocumentsScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsScreenQuery, DocumentsScreenQueryVariables>(DocumentsScreenDocument, options);
      }
export function useDocumentsScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsScreenQuery, DocumentsScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsScreenQuery, DocumentsScreenQueryVariables>(DocumentsScreenDocument, options);
        }
export function useDocumentsScreenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentsScreenQuery, DocumentsScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentsScreenQuery, DocumentsScreenQueryVariables>(DocumentsScreenDocument, options);
        }
export type DocumentsScreenQueryHookResult = ReturnType<typeof useDocumentsScreenQuery>;
export type DocumentsScreenLazyQueryHookResult = ReturnType<typeof useDocumentsScreenLazyQuery>;
export type DocumentsScreenSuspenseQueryHookResult = ReturnType<typeof useDocumentsScreenSuspenseQuery>;
export type DocumentsScreenQueryResult = Apollo.QueryResult<DocumentsScreenQuery, DocumentsScreenQueryVariables>;
export const PageScreenDocument = gql`
    query PageScreen($pageId: ID!) {
  page: node(id: $pageId) {
    ... on Page {
      id
      regions {
        id
        ...ArtifactRegionCreationTab
        ...CaptionRegionCreationTab
        ...FigureRegionCreationTab
        ...FormulaRegionCreationTab
        ...HeadingRegionCreationTab
        ...HybridRegionCreationTab
        ...ImageRegionCreationTab
        ...ListRegionCreationTab
        ...ListItemRegionCreationTab
        ...SublistRegionCreationTab
        ...TableRegionCreationTab
        ...TextRegionCreationTab
        ...TOCRegionCreationTab
        ...RegionUpdateTab
      }
      document {
        id
        name
        ...NavbarMetadataTabContent
        ...NavbarExportTabContent
        ...NavbarOverviewButton
      }
      ...PageEditor
      ...NavbarNextPageButton
      ...NavbarPreviousPageButton
      ...NavbarPagesTabContent
      ...NavbarRegionsTabContent
    }
  }
}
    ${ArtifactRegionCreationTabFragmentDoc}
${CaptionRegionCreationTabFragmentDoc}
${FigureRegionCreationTabFragmentDoc}
${FormulaRegionCreationTabFragmentDoc}
${HeadingRegionCreationTabFragmentDoc}
${HybridRegionCreationTabFragmentDoc}
${ImageRegionCreationTabFragmentDoc}
${ListRegionCreationTabFragmentDoc}
${ListItemRegionCreationTabFragmentDoc}
${SublistRegionCreationTabFragmentDoc}
${TableRegionCreationTabFragmentDoc}
${TextRegionCreationTabFragmentDoc}
${TocRegionCreationTabFragmentDoc}
${RegionUpdateTabFragmentDoc}
${NavbarMetadataTabContentFragmentDoc}
${NavbarExportTabContentFragmentDoc}
${NavbarOverviewButtonFragmentDoc}
${PageEditorFragmentDoc}
${NavbarNextPageButtonFragmentDoc}
${NavbarPreviousPageButtonFragmentDoc}
${NavbarPagesTabContentFragmentDoc}
${NavbarRegionsTabContentFragmentDoc}`;

/**
 * __usePageScreenQuery__
 *
 * To run a query within a React component, call `usePageScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageScreenQuery({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function usePageScreenQuery(baseOptions: Apollo.QueryHookOptions<PageScreenQuery, PageScreenQueryVariables> & ({ variables: PageScreenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageScreenQuery, PageScreenQueryVariables>(PageScreenDocument, options);
      }
export function usePageScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageScreenQuery, PageScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageScreenQuery, PageScreenQueryVariables>(PageScreenDocument, options);
        }
export function usePageScreenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageScreenQuery, PageScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageScreenQuery, PageScreenQueryVariables>(PageScreenDocument, options);
        }
export type PageScreenQueryHookResult = ReturnType<typeof usePageScreenQuery>;
export type PageScreenLazyQueryHookResult = ReturnType<typeof usePageScreenLazyQuery>;
export type PageScreenSuspenseQueryHookResult = ReturnType<typeof usePageScreenSuspenseQuery>;
export type PageScreenQueryResult = Apollo.QueryResult<PageScreenQuery, PageScreenQueryVariables>;
export const SettingsScreenDocument = gql`
    query SettingsScreen {
  viewer {
    id
    username
    avatarUrl
  }
  deployment {
    vcsRef
    vcsUrl
  }
}
    `;

/**
 * __useSettingsScreenQuery__
 *
 * To run a query within a React component, call `useSettingsScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsScreenQuery(baseOptions?: Apollo.QueryHookOptions<SettingsScreenQuery, SettingsScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsScreenQuery, SettingsScreenQueryVariables>(SettingsScreenDocument, options);
      }
export function useSettingsScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsScreenQuery, SettingsScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsScreenQuery, SettingsScreenQueryVariables>(SettingsScreenDocument, options);
        }
export function useSettingsScreenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettingsScreenQuery, SettingsScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettingsScreenQuery, SettingsScreenQueryVariables>(SettingsScreenDocument, options);
        }
export type SettingsScreenQueryHookResult = ReturnType<typeof useSettingsScreenQuery>;
export type SettingsScreenLazyQueryHookResult = ReturnType<typeof useSettingsScreenLazyQuery>;
export type SettingsScreenSuspenseQueryHookResult = ReturnType<typeof useSettingsScreenSuspenseQuery>;
export type SettingsScreenQueryResult = Apollo.QueryResult<SettingsScreenQuery, SettingsScreenQueryVariables>;
export const ArtifactRegionCreationTabDocument = gql`
    query ArtifactRegionCreationTab($regionId: ID!, $paginationArtifactAttributeIds: [ID!]!) {
  region: node(id: $regionId) {
    id
  }
  paginationArtifactAttributes: nodes(ids: $paginationArtifactAttributeIds) {
    ... on PaginationArtifactAttribute {
      id
      type
    }
  }
}
    `;

/**
 * __useArtifactRegionCreationTabQuery__
 *
 * To run a query within a React component, call `useArtifactRegionCreationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactRegionCreationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactRegionCreationTabQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      paginationArtifactAttributeIds: // value for 'paginationArtifactAttributeIds'
 *   },
 * });
 */
export function useArtifactRegionCreationTabQuery(baseOptions: Apollo.QueryHookOptions<ArtifactRegionCreationTabQuery, ArtifactRegionCreationTabQueryVariables> & ({ variables: ArtifactRegionCreationTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArtifactRegionCreationTabQuery, ArtifactRegionCreationTabQueryVariables>(ArtifactRegionCreationTabDocument, options);
      }
export function useArtifactRegionCreationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArtifactRegionCreationTabQuery, ArtifactRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArtifactRegionCreationTabQuery, ArtifactRegionCreationTabQueryVariables>(ArtifactRegionCreationTabDocument, options);
        }
export function useArtifactRegionCreationTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ArtifactRegionCreationTabQuery, ArtifactRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArtifactRegionCreationTabQuery, ArtifactRegionCreationTabQueryVariables>(ArtifactRegionCreationTabDocument, options);
        }
export type ArtifactRegionCreationTabQueryHookResult = ReturnType<typeof useArtifactRegionCreationTabQuery>;
export type ArtifactRegionCreationTabLazyQueryHookResult = ReturnType<typeof useArtifactRegionCreationTabLazyQuery>;
export type ArtifactRegionCreationTabSuspenseQueryHookResult = ReturnType<typeof useArtifactRegionCreationTabSuspenseQuery>;
export type ArtifactRegionCreationTabQueryResult = Apollo.QueryResult<ArtifactRegionCreationTabQuery, ArtifactRegionCreationTabQueryVariables>;
export const CreateArtifactRegionDocument = gql`
    mutation CreateArtifactRegion($regionId: ID!, $type: PaginationArtifactType!, $excessAttributeIds: [ID!]!) {
  createPaginationArtifactAttribute(input: {regionId: $regionId, type: $type}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      type
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...ArtifactRegionTile
      }
    }
  }
  deleteAttributes(input: {attributeIds: $excessAttributeIds}) {
    userErrors {
      code
      path
    }
  }
}
    ${RegionLabelFragmentDoc}
${ArtifactRegionTileFragmentDoc}`;
export type CreateArtifactRegionMutationFn = Apollo.MutationFunction<CreateArtifactRegionMutation, CreateArtifactRegionMutationVariables>;

/**
 * __useCreateArtifactRegionMutation__
 *
 * To run a mutation, you first call `useCreateArtifactRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactRegionMutation, { data, loading, error }] = useCreateArtifactRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      type: // value for 'type'
 *      excessAttributeIds: // value for 'excessAttributeIds'
 *   },
 * });
 */
export function useCreateArtifactRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateArtifactRegionMutation, CreateArtifactRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArtifactRegionMutation, CreateArtifactRegionMutationVariables>(CreateArtifactRegionDocument, options);
      }
export type CreateArtifactRegionMutationHookResult = ReturnType<typeof useCreateArtifactRegionMutation>;
export type CreateArtifactRegionMutationResult = Apollo.MutationResult<CreateArtifactRegionMutation>;
export type CreateArtifactRegionMutationOptions = Apollo.BaseMutationOptions<CreateArtifactRegionMutation, CreateArtifactRegionMutationVariables>;
export const ArtifactRegionEditorDocument = gql`
    query ArtifactRegionEditor($paginationArtifactAttributeId: ID!) {
  paginationArtifactAttr: node(id: $paginationArtifactAttributeId) {
    ... on PaginationArtifactAttribute {
      id
      type
    }
  }
}
    `;

/**
 * __useArtifactRegionEditorQuery__
 *
 * To run a query within a React component, call `useArtifactRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactRegionEditorQuery({
 *   variables: {
 *      paginationArtifactAttributeId: // value for 'paginationArtifactAttributeId'
 *   },
 * });
 */
export function useArtifactRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<ArtifactRegionEditorQuery, ArtifactRegionEditorQueryVariables> & ({ variables: ArtifactRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArtifactRegionEditorQuery, ArtifactRegionEditorQueryVariables>(ArtifactRegionEditorDocument, options);
      }
export function useArtifactRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArtifactRegionEditorQuery, ArtifactRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArtifactRegionEditorQuery, ArtifactRegionEditorQueryVariables>(ArtifactRegionEditorDocument, options);
        }
export function useArtifactRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ArtifactRegionEditorQuery, ArtifactRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArtifactRegionEditorQuery, ArtifactRegionEditorQueryVariables>(ArtifactRegionEditorDocument, options);
        }
export type ArtifactRegionEditorQueryHookResult = ReturnType<typeof useArtifactRegionEditorQuery>;
export type ArtifactRegionEditorLazyQueryHookResult = ReturnType<typeof useArtifactRegionEditorLazyQuery>;
export type ArtifactRegionEditorSuspenseQueryHookResult = ReturnType<typeof useArtifactRegionEditorSuspenseQuery>;
export type ArtifactRegionEditorQueryResult = Apollo.QueryResult<ArtifactRegionEditorQuery, ArtifactRegionEditorQueryVariables>;
export const UpdateArtifactRegionDocument = gql`
    mutation UpdateArtifactRegion($paginationArtifactAttributeId: ID!, $paginationArtifactType: PaginationArtifactType!) {
  updatePaginationArtifactAttribute(
    input: {attributeId: $paginationArtifactAttributeId, type: $paginationArtifactType}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      type
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
}
    `;
export type UpdateArtifactRegionMutationFn = Apollo.MutationFunction<UpdateArtifactRegionMutation, UpdateArtifactRegionMutationVariables>;

/**
 * __useUpdateArtifactRegionMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactRegionMutation, { data, loading, error }] = useUpdateArtifactRegionMutation({
 *   variables: {
 *      paginationArtifactAttributeId: // value for 'paginationArtifactAttributeId'
 *      paginationArtifactType: // value for 'paginationArtifactType'
 *   },
 * });
 */
export function useUpdateArtifactRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArtifactRegionMutation, UpdateArtifactRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArtifactRegionMutation, UpdateArtifactRegionMutationVariables>(UpdateArtifactRegionDocument, options);
      }
export type UpdateArtifactRegionMutationHookResult = ReturnType<typeof useUpdateArtifactRegionMutation>;
export type UpdateArtifactRegionMutationResult = Apollo.MutationResult<UpdateArtifactRegionMutation>;
export type UpdateArtifactRegionMutationOptions = Apollo.BaseMutationOptions<UpdateArtifactRegionMutation, UpdateArtifactRegionMutationVariables>;
export const CaptionRegionCreationTabDocument = gql`
    query CaptionRegionCreationTab($regionId: ID!, $captionAttributeIds: [ID!]!, $textAttributeIds: [ID!]!) {
  region: node(id: $regionId) {
    ... on Region {
      id
      ...CaptionFormField
    }
    ...TextFormField
  }
  captionAttributes: nodes(ids: $captionAttributeIds) {
    ... on CaptionAttribute {
      id
      linkedRegion {
        id
      }
    }
  }
  textAttributes: nodes(ids: $textAttributeIds) {
    ... on TextAttribute {
      id
      text
    }
  }
}
    ${CaptionFormFieldFragmentDoc}
${TextFormFieldFragmentDoc}`;

/**
 * __useCaptionRegionCreationTabQuery__
 *
 * To run a query within a React component, call `useCaptionRegionCreationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaptionRegionCreationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaptionRegionCreationTabQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      captionAttributeIds: // value for 'captionAttributeIds'
 *      textAttributeIds: // value for 'textAttributeIds'
 *   },
 * });
 */
export function useCaptionRegionCreationTabQuery(baseOptions: Apollo.QueryHookOptions<CaptionRegionCreationTabQuery, CaptionRegionCreationTabQueryVariables> & ({ variables: CaptionRegionCreationTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaptionRegionCreationTabQuery, CaptionRegionCreationTabQueryVariables>(CaptionRegionCreationTabDocument, options);
      }
export function useCaptionRegionCreationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaptionRegionCreationTabQuery, CaptionRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaptionRegionCreationTabQuery, CaptionRegionCreationTabQueryVariables>(CaptionRegionCreationTabDocument, options);
        }
export function useCaptionRegionCreationTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CaptionRegionCreationTabQuery, CaptionRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaptionRegionCreationTabQuery, CaptionRegionCreationTabQueryVariables>(CaptionRegionCreationTabDocument, options);
        }
export type CaptionRegionCreationTabQueryHookResult = ReturnType<typeof useCaptionRegionCreationTabQuery>;
export type CaptionRegionCreationTabLazyQueryHookResult = ReturnType<typeof useCaptionRegionCreationTabLazyQuery>;
export type CaptionRegionCreationTabSuspenseQueryHookResult = ReturnType<typeof useCaptionRegionCreationTabSuspenseQuery>;
export type CaptionRegionCreationTabQueryResult = Apollo.QueryResult<CaptionRegionCreationTabQuery, CaptionRegionCreationTabQueryVariables>;
export const CreateCaptionRegionDocument = gql`
    mutation CreateCaptionRegion($regionId: ID!, $linkedRegionId: ID, $text: String!, $excessAttributeIds: [ID!]!) {
  createCaptionAttribute(
    input: {regionId: $regionId, linkedRegionId: $linkedRegionId}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      linkedRegion {
        id
      }
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
  createTextAttribute(input: {regionId: $regionId, text: $text}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      text
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...CaptionRegionTile
      }
    }
  }
  deleteAttributes(input: {attributeIds: $excessAttributeIds}) {
    userErrors {
      code
      path
    }
  }
}
    ${RegionLabelFragmentDoc}
${CaptionRegionTileFragmentDoc}`;
export type CreateCaptionRegionMutationFn = Apollo.MutationFunction<CreateCaptionRegionMutation, CreateCaptionRegionMutationVariables>;

/**
 * __useCreateCaptionRegionMutation__
 *
 * To run a mutation, you first call `useCreateCaptionRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaptionRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaptionRegionMutation, { data, loading, error }] = useCreateCaptionRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      linkedRegionId: // value for 'linkedRegionId'
 *      text: // value for 'text'
 *      excessAttributeIds: // value for 'excessAttributeIds'
 *   },
 * });
 */
export function useCreateCaptionRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaptionRegionMutation, CreateCaptionRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaptionRegionMutation, CreateCaptionRegionMutationVariables>(CreateCaptionRegionDocument, options);
      }
export type CreateCaptionRegionMutationHookResult = ReturnType<typeof useCreateCaptionRegionMutation>;
export type CreateCaptionRegionMutationResult = Apollo.MutationResult<CreateCaptionRegionMutation>;
export type CreateCaptionRegionMutationOptions = Apollo.BaseMutationOptions<CreateCaptionRegionMutation, CreateCaptionRegionMutationVariables>;
export const CaptionRegionEditorDocument = gql`
    query CaptionRegionEditor($captionAttributeId: ID!, $textAttributeId: ID!) {
  captionAttr: node(id: $captionAttributeId) {
    ... on CaptionAttribute {
      id
      linkedRegion {
        id
      }
      region {
        id
        ...CaptionFormField
      }
    }
  }
  textAttr: node(id: $textAttributeId) {
    ... on TextAttribute {
      id
      text
      region {
        id
        ...TextFormField
      }
    }
  }
}
    ${CaptionFormFieldFragmentDoc}
${TextFormFieldFragmentDoc}`;

/**
 * __useCaptionRegionEditorQuery__
 *
 * To run a query within a React component, call `useCaptionRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaptionRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaptionRegionEditorQuery({
 *   variables: {
 *      captionAttributeId: // value for 'captionAttributeId'
 *      textAttributeId: // value for 'textAttributeId'
 *   },
 * });
 */
export function useCaptionRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<CaptionRegionEditorQuery, CaptionRegionEditorQueryVariables> & ({ variables: CaptionRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaptionRegionEditorQuery, CaptionRegionEditorQueryVariables>(CaptionRegionEditorDocument, options);
      }
export function useCaptionRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaptionRegionEditorQuery, CaptionRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaptionRegionEditorQuery, CaptionRegionEditorQueryVariables>(CaptionRegionEditorDocument, options);
        }
export function useCaptionRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CaptionRegionEditorQuery, CaptionRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaptionRegionEditorQuery, CaptionRegionEditorQueryVariables>(CaptionRegionEditorDocument, options);
        }
export type CaptionRegionEditorQueryHookResult = ReturnType<typeof useCaptionRegionEditorQuery>;
export type CaptionRegionEditorLazyQueryHookResult = ReturnType<typeof useCaptionRegionEditorLazyQuery>;
export type CaptionRegionEditorSuspenseQueryHookResult = ReturnType<typeof useCaptionRegionEditorSuspenseQuery>;
export type CaptionRegionEditorQueryResult = Apollo.QueryResult<CaptionRegionEditorQuery, CaptionRegionEditorQueryVariables>;
export const UpdateCaptionRegionDocument = gql`
    mutation UpdateCaptionRegion($captionAttributeId: ID!, $linkedRegionId: ID, $textAttributeId: ID!, $text: String!) {
  updateCaptionAttribute(
    input: {attributeId: $captionAttributeId, linkedRegionId: $linkedRegionId}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      linkedRegion {
        id
      }
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
  updateTextAttribute(input: {attributeId: $textAttributeId, text: $text}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      text
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
}
    `;
export type UpdateCaptionRegionMutationFn = Apollo.MutationFunction<UpdateCaptionRegionMutation, UpdateCaptionRegionMutationVariables>;

/**
 * __useUpdateCaptionRegionMutation__
 *
 * To run a mutation, you first call `useUpdateCaptionRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaptionRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaptionRegionMutation, { data, loading, error }] = useUpdateCaptionRegionMutation({
 *   variables: {
 *      captionAttributeId: // value for 'captionAttributeId'
 *      linkedRegionId: // value for 'linkedRegionId'
 *      textAttributeId: // value for 'textAttributeId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateCaptionRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaptionRegionMutation, UpdateCaptionRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaptionRegionMutation, UpdateCaptionRegionMutationVariables>(UpdateCaptionRegionDocument, options);
      }
export type UpdateCaptionRegionMutationHookResult = ReturnType<typeof useUpdateCaptionRegionMutation>;
export type UpdateCaptionRegionMutationResult = Apollo.MutationResult<UpdateCaptionRegionMutation>;
export type UpdateCaptionRegionMutationOptions = Apollo.BaseMutationOptions<UpdateCaptionRegionMutation, UpdateCaptionRegionMutationVariables>;
export const FigureRegionCreationTabDocument = gql`
    query FigureRegionCreationTab($regionId: ID!, $figureAttributeIds: [ID!]!) {
  region: node(id: $regionId) {
    id
  }
  figureAttributes: nodes(ids: $figureAttributeIds) {
    ... on FigureAttribute {
      id
    }
  }
}
    `;

/**
 * __useFigureRegionCreationTabQuery__
 *
 * To run a query within a React component, call `useFigureRegionCreationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useFigureRegionCreationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFigureRegionCreationTabQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      figureAttributeIds: // value for 'figureAttributeIds'
 *   },
 * });
 */
export function useFigureRegionCreationTabQuery(baseOptions: Apollo.QueryHookOptions<FigureRegionCreationTabQuery, FigureRegionCreationTabQueryVariables> & ({ variables: FigureRegionCreationTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FigureRegionCreationTabQuery, FigureRegionCreationTabQueryVariables>(FigureRegionCreationTabDocument, options);
      }
export function useFigureRegionCreationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FigureRegionCreationTabQuery, FigureRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FigureRegionCreationTabQuery, FigureRegionCreationTabQueryVariables>(FigureRegionCreationTabDocument, options);
        }
export function useFigureRegionCreationTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FigureRegionCreationTabQuery, FigureRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FigureRegionCreationTabQuery, FigureRegionCreationTabQueryVariables>(FigureRegionCreationTabDocument, options);
        }
export type FigureRegionCreationTabQueryHookResult = ReturnType<typeof useFigureRegionCreationTabQuery>;
export type FigureRegionCreationTabLazyQueryHookResult = ReturnType<typeof useFigureRegionCreationTabLazyQuery>;
export type FigureRegionCreationTabSuspenseQueryHookResult = ReturnType<typeof useFigureRegionCreationTabSuspenseQuery>;
export type FigureRegionCreationTabQueryResult = Apollo.QueryResult<FigureRegionCreationTabQuery, FigureRegionCreationTabQueryVariables>;
export const CreateFigureRegionDocument = gql`
    mutation CreateFigureRegion($regionId: ID!, $excessAttributeIds: [ID!]!) {
  createFigureAttribute(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...FigureRegionTile
      }
    }
  }
  deleteAttributes(input: {attributeIds: $excessAttributeIds}) {
    userErrors {
      code
      path
    }
  }
}
    ${RegionLabelFragmentDoc}
${FigureRegionTileFragmentDoc}`;
export type CreateFigureRegionMutationFn = Apollo.MutationFunction<CreateFigureRegionMutation, CreateFigureRegionMutationVariables>;

/**
 * __useCreateFigureRegionMutation__
 *
 * To run a mutation, you first call `useCreateFigureRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFigureRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFigureRegionMutation, { data, loading, error }] = useCreateFigureRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      excessAttributeIds: // value for 'excessAttributeIds'
 *   },
 * });
 */
export function useCreateFigureRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFigureRegionMutation, CreateFigureRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFigureRegionMutation, CreateFigureRegionMutationVariables>(CreateFigureRegionDocument, options);
      }
export type CreateFigureRegionMutationHookResult = ReturnType<typeof useCreateFigureRegionMutation>;
export type CreateFigureRegionMutationResult = Apollo.MutationResult<CreateFigureRegionMutation>;
export type CreateFigureRegionMutationOptions = Apollo.BaseMutationOptions<CreateFigureRegionMutation, CreateFigureRegionMutationVariables>;
export const FigureRegionEditorDocument = gql`
    query FigureRegionEditor($figureAttributeId: ID!) {
  figureAttr: node(id: $figureAttributeId) {
    ... on FigureAttribute {
      id
    }
  }
}
    `;

/**
 * __useFigureRegionEditorQuery__
 *
 * To run a query within a React component, call `useFigureRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFigureRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFigureRegionEditorQuery({
 *   variables: {
 *      figureAttributeId: // value for 'figureAttributeId'
 *   },
 * });
 */
export function useFigureRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<FigureRegionEditorQuery, FigureRegionEditorQueryVariables> & ({ variables: FigureRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FigureRegionEditorQuery, FigureRegionEditorQueryVariables>(FigureRegionEditorDocument, options);
      }
export function useFigureRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FigureRegionEditorQuery, FigureRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FigureRegionEditorQuery, FigureRegionEditorQueryVariables>(FigureRegionEditorDocument, options);
        }
export function useFigureRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FigureRegionEditorQuery, FigureRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FigureRegionEditorQuery, FigureRegionEditorQueryVariables>(FigureRegionEditorDocument, options);
        }
export type FigureRegionEditorQueryHookResult = ReturnType<typeof useFigureRegionEditorQuery>;
export type FigureRegionEditorLazyQueryHookResult = ReturnType<typeof useFigureRegionEditorLazyQuery>;
export type FigureRegionEditorSuspenseQueryHookResult = ReturnType<typeof useFigureRegionEditorSuspenseQuery>;
export type FigureRegionEditorQueryResult = Apollo.QueryResult<FigureRegionEditorQuery, FigureRegionEditorQueryVariables>;
export const FormulaRegionCreationTabDocument = gql`
    query FormulaRegionCreationTab($regionId: ID!, $expressionAttributeIds: [ID!]!) {
  region: node(id: $regionId) {
    id
    ...ExpressionReferenceFormField
    ...ExpressionFormField
  }
  expressionAttributes: nodes(ids: $expressionAttributeIds) {
    ... on ExpressionAttribute {
      id
      expressionLatex
    }
  }
}
    ${ExpressionReferenceFormFieldFragmentDoc}
${ExpressionFormFieldFragmentDoc}`;

/**
 * __useFormulaRegionCreationTabQuery__
 *
 * To run a query within a React component, call `useFormulaRegionCreationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaRegionCreationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaRegionCreationTabQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      expressionAttributeIds: // value for 'expressionAttributeIds'
 *   },
 * });
 */
export function useFormulaRegionCreationTabQuery(baseOptions: Apollo.QueryHookOptions<FormulaRegionCreationTabQuery, FormulaRegionCreationTabQueryVariables> & ({ variables: FormulaRegionCreationTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulaRegionCreationTabQuery, FormulaRegionCreationTabQueryVariables>(FormulaRegionCreationTabDocument, options);
      }
export function useFormulaRegionCreationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulaRegionCreationTabQuery, FormulaRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulaRegionCreationTabQuery, FormulaRegionCreationTabQueryVariables>(FormulaRegionCreationTabDocument, options);
        }
export function useFormulaRegionCreationTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FormulaRegionCreationTabQuery, FormulaRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FormulaRegionCreationTabQuery, FormulaRegionCreationTabQueryVariables>(FormulaRegionCreationTabDocument, options);
        }
export type FormulaRegionCreationTabQueryHookResult = ReturnType<typeof useFormulaRegionCreationTabQuery>;
export type FormulaRegionCreationTabLazyQueryHookResult = ReturnType<typeof useFormulaRegionCreationTabLazyQuery>;
export type FormulaRegionCreationTabSuspenseQueryHookResult = ReturnType<typeof useFormulaRegionCreationTabSuspenseQuery>;
export type FormulaRegionCreationTabQueryResult = Apollo.QueryResult<FormulaRegionCreationTabQuery, FormulaRegionCreationTabQueryVariables>;
export const CreateFormulaRegionDocument = gql`
    mutation CreateFormulaRegion($regionId: ID!, $expressionLatex: String!, $excessAttributeIds: [ID!]!) {
  createExpressionAttribute(
    input: {regionId: $regionId, expressionLatex: $expressionLatex}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      expressionLatex
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...FormulaRegionTile
      }
    }
  }
  deleteAttributes(input: {attributeIds: $excessAttributeIds}) {
    userErrors {
      code
      path
    }
  }
}
    ${RegionLabelFragmentDoc}
${FormulaRegionTileFragmentDoc}`;
export type CreateFormulaRegionMutationFn = Apollo.MutationFunction<CreateFormulaRegionMutation, CreateFormulaRegionMutationVariables>;

/**
 * __useCreateFormulaRegionMutation__
 *
 * To run a mutation, you first call `useCreateFormulaRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormulaRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormulaRegionMutation, { data, loading, error }] = useCreateFormulaRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      expressionLatex: // value for 'expressionLatex'
 *      excessAttributeIds: // value for 'excessAttributeIds'
 *   },
 * });
 */
export function useCreateFormulaRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormulaRegionMutation, CreateFormulaRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormulaRegionMutation, CreateFormulaRegionMutationVariables>(CreateFormulaRegionDocument, options);
      }
export type CreateFormulaRegionMutationHookResult = ReturnType<typeof useCreateFormulaRegionMutation>;
export type CreateFormulaRegionMutationResult = Apollo.MutationResult<CreateFormulaRegionMutation>;
export type CreateFormulaRegionMutationOptions = Apollo.BaseMutationOptions<CreateFormulaRegionMutation, CreateFormulaRegionMutationVariables>;
export const FormulaRegionEditorDocument = gql`
    query FormulaRegionEditor($expressionAttributeId: ID!) {
  expressionAttr: node(id: $expressionAttributeId) {
    ... on ExpressionAttribute {
      id
      expressionLatex
      region {
        id
        ...ExpressionReferenceFormField
        ...ExpressionFormField
      }
    }
  }
}
    ${ExpressionReferenceFormFieldFragmentDoc}
${ExpressionFormFieldFragmentDoc}`;

/**
 * __useFormulaRegionEditorQuery__
 *
 * To run a query within a React component, call `useFormulaRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaRegionEditorQuery({
 *   variables: {
 *      expressionAttributeId: // value for 'expressionAttributeId'
 *   },
 * });
 */
export function useFormulaRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<FormulaRegionEditorQuery, FormulaRegionEditorQueryVariables> & ({ variables: FormulaRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormulaRegionEditorQuery, FormulaRegionEditorQueryVariables>(FormulaRegionEditorDocument, options);
      }
export function useFormulaRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormulaRegionEditorQuery, FormulaRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormulaRegionEditorQuery, FormulaRegionEditorQueryVariables>(FormulaRegionEditorDocument, options);
        }
export function useFormulaRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FormulaRegionEditorQuery, FormulaRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FormulaRegionEditorQuery, FormulaRegionEditorQueryVariables>(FormulaRegionEditorDocument, options);
        }
export type FormulaRegionEditorQueryHookResult = ReturnType<typeof useFormulaRegionEditorQuery>;
export type FormulaRegionEditorLazyQueryHookResult = ReturnType<typeof useFormulaRegionEditorLazyQuery>;
export type FormulaRegionEditorSuspenseQueryHookResult = ReturnType<typeof useFormulaRegionEditorSuspenseQuery>;
export type FormulaRegionEditorQueryResult = Apollo.QueryResult<FormulaRegionEditorQuery, FormulaRegionEditorQueryVariables>;
export const UpdateFormulaRegionDocument = gql`
    mutation UpdateFormulaRegion($expressionAttributeId: ID!, $expressionLatex: String!) {
  updateExpressionAttribute(
    input: {attributeId: $expressionAttributeId, expressionLatex: $expressionLatex}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      expressionLatex
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
}
    `;
export type UpdateFormulaRegionMutationFn = Apollo.MutationFunction<UpdateFormulaRegionMutation, UpdateFormulaRegionMutationVariables>;

/**
 * __useUpdateFormulaRegionMutation__
 *
 * To run a mutation, you first call `useUpdateFormulaRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormulaRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormulaRegionMutation, { data, loading, error }] = useUpdateFormulaRegionMutation({
 *   variables: {
 *      expressionAttributeId: // value for 'expressionAttributeId'
 *      expressionLatex: // value for 'expressionLatex'
 *   },
 * });
 */
export function useUpdateFormulaRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormulaRegionMutation, UpdateFormulaRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormulaRegionMutation, UpdateFormulaRegionMutationVariables>(UpdateFormulaRegionDocument, options);
      }
export type UpdateFormulaRegionMutationHookResult = ReturnType<typeof useUpdateFormulaRegionMutation>;
export type UpdateFormulaRegionMutationResult = Apollo.MutationResult<UpdateFormulaRegionMutation>;
export type UpdateFormulaRegionMutationOptions = Apollo.BaseMutationOptions<UpdateFormulaRegionMutation, UpdateFormulaRegionMutationVariables>;
export const HeadingRegionCreationTabDocument = gql`
    query HeadingRegionCreationTab($regionId: ID!, $headerLevelAttributeIds: [ID!]!, $textAttributeIds: [ID!]!) {
  region: node(id: $regionId) {
    id
    ...TextFormField
  }
  headerLevelAttributes: nodes(ids: $headerLevelAttributeIds) {
    ... on HeaderLevelAttribute {
      id
      level
    }
  }
  textAttributes: nodes(ids: $textAttributeIds) {
    ... on TextAttribute {
      id
      text
    }
  }
}
    ${TextFormFieldFragmentDoc}`;

/**
 * __useHeadingRegionCreationTabQuery__
 *
 * To run a query within a React component, call `useHeadingRegionCreationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeadingRegionCreationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeadingRegionCreationTabQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      headerLevelAttributeIds: // value for 'headerLevelAttributeIds'
 *      textAttributeIds: // value for 'textAttributeIds'
 *   },
 * });
 */
export function useHeadingRegionCreationTabQuery(baseOptions: Apollo.QueryHookOptions<HeadingRegionCreationTabQuery, HeadingRegionCreationTabQueryVariables> & ({ variables: HeadingRegionCreationTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeadingRegionCreationTabQuery, HeadingRegionCreationTabQueryVariables>(HeadingRegionCreationTabDocument, options);
      }
export function useHeadingRegionCreationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeadingRegionCreationTabQuery, HeadingRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeadingRegionCreationTabQuery, HeadingRegionCreationTabQueryVariables>(HeadingRegionCreationTabDocument, options);
        }
export function useHeadingRegionCreationTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeadingRegionCreationTabQuery, HeadingRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeadingRegionCreationTabQuery, HeadingRegionCreationTabQueryVariables>(HeadingRegionCreationTabDocument, options);
        }
export type HeadingRegionCreationTabQueryHookResult = ReturnType<typeof useHeadingRegionCreationTabQuery>;
export type HeadingRegionCreationTabLazyQueryHookResult = ReturnType<typeof useHeadingRegionCreationTabLazyQuery>;
export type HeadingRegionCreationTabSuspenseQueryHookResult = ReturnType<typeof useHeadingRegionCreationTabSuspenseQuery>;
export type HeadingRegionCreationTabQueryResult = Apollo.QueryResult<HeadingRegionCreationTabQuery, HeadingRegionCreationTabQueryVariables>;
export const CreateHeadingRegionDocument = gql`
    mutation CreateHeadingRegion($regionId: ID!, $level: PositiveInt!, $text: String!, $excessAttributeIds: [ID!]!) {
  createHeaderLevelAttribute(input: {regionId: $regionId, level: $level}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      level
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
  createTextAttribute(input: {regionId: $regionId, text: $text}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      text
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...HeadingRegionTile
      }
    }
  }
  deleteAttributes(input: {attributeIds: $excessAttributeIds}) {
    userErrors {
      code
      path
    }
  }
}
    ${RegionLabelFragmentDoc}
${HeadingRegionTileFragmentDoc}`;
export type CreateHeadingRegionMutationFn = Apollo.MutationFunction<CreateHeadingRegionMutation, CreateHeadingRegionMutationVariables>;

/**
 * __useCreateHeadingRegionMutation__
 *
 * To run a mutation, you first call `useCreateHeadingRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHeadingRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHeadingRegionMutation, { data, loading, error }] = useCreateHeadingRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      level: // value for 'level'
 *      text: // value for 'text'
 *      excessAttributeIds: // value for 'excessAttributeIds'
 *   },
 * });
 */
export function useCreateHeadingRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateHeadingRegionMutation, CreateHeadingRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHeadingRegionMutation, CreateHeadingRegionMutationVariables>(CreateHeadingRegionDocument, options);
      }
export type CreateHeadingRegionMutationHookResult = ReturnType<typeof useCreateHeadingRegionMutation>;
export type CreateHeadingRegionMutationResult = Apollo.MutationResult<CreateHeadingRegionMutation>;
export type CreateHeadingRegionMutationOptions = Apollo.BaseMutationOptions<CreateHeadingRegionMutation, CreateHeadingRegionMutationVariables>;
export const HeadingRegionEditorDocument = gql`
    query HeadingRegionEditor($headerLevelAttributeId: ID!, $textAttributeId: ID!) {
  headerLevelAttr: node(id: $headerLevelAttributeId) {
    ... on HeaderLevelAttribute {
      id
      level
    }
  }
  textAttr: node(id: $textAttributeId) {
    ... on TextAttribute {
      id
      text
      region {
        id
        ...TextFormField
      }
    }
  }
}
    ${TextFormFieldFragmentDoc}`;

/**
 * __useHeadingRegionEditorQuery__
 *
 * To run a query within a React component, call `useHeadingRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeadingRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeadingRegionEditorQuery({
 *   variables: {
 *      headerLevelAttributeId: // value for 'headerLevelAttributeId'
 *      textAttributeId: // value for 'textAttributeId'
 *   },
 * });
 */
export function useHeadingRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<HeadingRegionEditorQuery, HeadingRegionEditorQueryVariables> & ({ variables: HeadingRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeadingRegionEditorQuery, HeadingRegionEditorQueryVariables>(HeadingRegionEditorDocument, options);
      }
export function useHeadingRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeadingRegionEditorQuery, HeadingRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeadingRegionEditorQuery, HeadingRegionEditorQueryVariables>(HeadingRegionEditorDocument, options);
        }
export function useHeadingRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HeadingRegionEditorQuery, HeadingRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HeadingRegionEditorQuery, HeadingRegionEditorQueryVariables>(HeadingRegionEditorDocument, options);
        }
export type HeadingRegionEditorQueryHookResult = ReturnType<typeof useHeadingRegionEditorQuery>;
export type HeadingRegionEditorLazyQueryHookResult = ReturnType<typeof useHeadingRegionEditorLazyQuery>;
export type HeadingRegionEditorSuspenseQueryHookResult = ReturnType<typeof useHeadingRegionEditorSuspenseQuery>;
export type HeadingRegionEditorQueryResult = Apollo.QueryResult<HeadingRegionEditorQuery, HeadingRegionEditorQueryVariables>;
export const UpdateHeadingRegionDocument = gql`
    mutation UpdateHeadingRegion($headerLevelAttributeId: ID!, $level: PositiveInt!, $textAttributeId: ID!, $text: String!) {
  updateHeaderLevelAttribute(
    input: {attributeId: $headerLevelAttributeId, level: $level}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      level
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
  updateTextAttribute(input: {attributeId: $textAttributeId, text: $text}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      text
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
}
    `;
export type UpdateHeadingRegionMutationFn = Apollo.MutationFunction<UpdateHeadingRegionMutation, UpdateHeadingRegionMutationVariables>;

/**
 * __useUpdateHeadingRegionMutation__
 *
 * To run a mutation, you first call `useUpdateHeadingRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHeadingRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHeadingRegionMutation, { data, loading, error }] = useUpdateHeadingRegionMutation({
 *   variables: {
 *      headerLevelAttributeId: // value for 'headerLevelAttributeId'
 *      level: // value for 'level'
 *      textAttributeId: // value for 'textAttributeId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateHeadingRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHeadingRegionMutation, UpdateHeadingRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHeadingRegionMutation, UpdateHeadingRegionMutationVariables>(UpdateHeadingRegionDocument, options);
      }
export type UpdateHeadingRegionMutationHookResult = ReturnType<typeof useUpdateHeadingRegionMutation>;
export type UpdateHeadingRegionMutationResult = Apollo.MutationResult<UpdateHeadingRegionMutation>;
export type UpdateHeadingRegionMutationOptions = Apollo.BaseMutationOptions<UpdateHeadingRegionMutation, UpdateHeadingRegionMutationVariables>;
export const HybridRegionEditorDocument = gql`
    query HybridRegionEditor($regionId: ID!) {
  region: node(id: $regionId) {
    ... on Region {
      id
      ...AttributeUpdateSection
      ...AttributeCreationSection
    }
  }
}
    ${AttributeUpdateSectionFragmentDoc}
${AttributeCreationSectionFragmentDoc}`;

/**
 * __useHybridRegionEditorQuery__
 *
 * To run a query within a React component, call `useHybridRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useHybridRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHybridRegionEditorQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useHybridRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<HybridRegionEditorQuery, HybridRegionEditorQueryVariables> & ({ variables: HybridRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HybridRegionEditorQuery, HybridRegionEditorQueryVariables>(HybridRegionEditorDocument, options);
      }
export function useHybridRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HybridRegionEditorQuery, HybridRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HybridRegionEditorQuery, HybridRegionEditorQueryVariables>(HybridRegionEditorDocument, options);
        }
export function useHybridRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HybridRegionEditorQuery, HybridRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HybridRegionEditorQuery, HybridRegionEditorQueryVariables>(HybridRegionEditorDocument, options);
        }
export type HybridRegionEditorQueryHookResult = ReturnType<typeof useHybridRegionEditorQuery>;
export type HybridRegionEditorLazyQueryHookResult = ReturnType<typeof useHybridRegionEditorLazyQuery>;
export type HybridRegionEditorSuspenseQueryHookResult = ReturnType<typeof useHybridRegionEditorSuspenseQuery>;
export type HybridRegionEditorQueryResult = Apollo.QueryResult<HybridRegionEditorQuery, HybridRegionEditorQueryVariables>;
export const ImageRegionCreationTabDocument = gql`
    query ImageRegionCreationTab($regionId: ID!, $imageAttributeIds: [ID!]!, $alternativeTextAttributeIds: [ID!]!) {
  region: node(id: $regionId) {
    id
    ...AlternativeTextFormField
  }
  imageAttributes: nodes(ids: $imageAttributeIds) {
    ... on ImageAttribute {
      id
    }
  }
  alternativeTextAttributes: nodes(ids: $alternativeTextAttributeIds) {
    ... on AlternativeTextAttribute {
      id
      alternativeText
    }
  }
}
    ${AlternativeTextFormFieldFragmentDoc}`;

/**
 * __useImageRegionCreationTabQuery__
 *
 * To run a query within a React component, call `useImageRegionCreationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageRegionCreationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageRegionCreationTabQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      imageAttributeIds: // value for 'imageAttributeIds'
 *      alternativeTextAttributeIds: // value for 'alternativeTextAttributeIds'
 *   },
 * });
 */
export function useImageRegionCreationTabQuery(baseOptions: Apollo.QueryHookOptions<ImageRegionCreationTabQuery, ImageRegionCreationTabQueryVariables> & ({ variables: ImageRegionCreationTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageRegionCreationTabQuery, ImageRegionCreationTabQueryVariables>(ImageRegionCreationTabDocument, options);
      }
export function useImageRegionCreationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageRegionCreationTabQuery, ImageRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageRegionCreationTabQuery, ImageRegionCreationTabQueryVariables>(ImageRegionCreationTabDocument, options);
        }
export function useImageRegionCreationTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImageRegionCreationTabQuery, ImageRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImageRegionCreationTabQuery, ImageRegionCreationTabQueryVariables>(ImageRegionCreationTabDocument, options);
        }
export type ImageRegionCreationTabQueryHookResult = ReturnType<typeof useImageRegionCreationTabQuery>;
export type ImageRegionCreationTabLazyQueryHookResult = ReturnType<typeof useImageRegionCreationTabLazyQuery>;
export type ImageRegionCreationTabSuspenseQueryHookResult = ReturnType<typeof useImageRegionCreationTabSuspenseQuery>;
export type ImageRegionCreationTabQueryResult = Apollo.QueryResult<ImageRegionCreationTabQuery, ImageRegionCreationTabQueryVariables>;
export const CreateImageRegionDocument = gql`
    mutation CreateImageRegion($regionId: ID!, $alternativeText: String!, $excessAttributeIds: [ID!]!) {
  createImageAttribute(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
  createAlternativeTextAttribute(
    input: {regionId: $regionId, alternativeText: $alternativeText}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      alternativeText
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...ImageRegionTile
      }
    }
  }
  deleteAttributes(input: {attributeIds: $excessAttributeIds}) {
    userErrors {
      code
      path
    }
  }
}
    ${RegionLabelFragmentDoc}
${ImageRegionTileFragmentDoc}`;
export type CreateImageRegionMutationFn = Apollo.MutationFunction<CreateImageRegionMutation, CreateImageRegionMutationVariables>;

/**
 * __useCreateImageRegionMutation__
 *
 * To run a mutation, you first call `useCreateImageRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImageRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImageRegionMutation, { data, loading, error }] = useCreateImageRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      alternativeText: // value for 'alternativeText'
 *      excessAttributeIds: // value for 'excessAttributeIds'
 *   },
 * });
 */
export function useCreateImageRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateImageRegionMutation, CreateImageRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImageRegionMutation, CreateImageRegionMutationVariables>(CreateImageRegionDocument, options);
      }
export type CreateImageRegionMutationHookResult = ReturnType<typeof useCreateImageRegionMutation>;
export type CreateImageRegionMutationResult = Apollo.MutationResult<CreateImageRegionMutation>;
export type CreateImageRegionMutationOptions = Apollo.BaseMutationOptions<CreateImageRegionMutation, CreateImageRegionMutationVariables>;
export const ImageRegionEditorDocument = gql`
    query ImageRegionEditor($imageAttributeId: ID!, $alternativeTextAttributeId: ID!) {
  imageAttr: node(id: $imageAttributeId) {
    id
  }
  altTextAttr: node(id: $alternativeTextAttributeId) {
    ... on AlternativeTextAttribute {
      id
      alternativeText
      region {
        id
        ...AlternativeTextFormField
      }
    }
  }
}
    ${AlternativeTextFormFieldFragmentDoc}`;

/**
 * __useImageRegionEditorQuery__
 *
 * To run a query within a React component, call `useImageRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageRegionEditorQuery({
 *   variables: {
 *      imageAttributeId: // value for 'imageAttributeId'
 *      alternativeTextAttributeId: // value for 'alternativeTextAttributeId'
 *   },
 * });
 */
export function useImageRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<ImageRegionEditorQuery, ImageRegionEditorQueryVariables> & ({ variables: ImageRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageRegionEditorQuery, ImageRegionEditorQueryVariables>(ImageRegionEditorDocument, options);
      }
export function useImageRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImageRegionEditorQuery, ImageRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageRegionEditorQuery, ImageRegionEditorQueryVariables>(ImageRegionEditorDocument, options);
        }
export function useImageRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImageRegionEditorQuery, ImageRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImageRegionEditorQuery, ImageRegionEditorQueryVariables>(ImageRegionEditorDocument, options);
        }
export type ImageRegionEditorQueryHookResult = ReturnType<typeof useImageRegionEditorQuery>;
export type ImageRegionEditorLazyQueryHookResult = ReturnType<typeof useImageRegionEditorLazyQuery>;
export type ImageRegionEditorSuspenseQueryHookResult = ReturnType<typeof useImageRegionEditorSuspenseQuery>;
export type ImageRegionEditorQueryResult = Apollo.QueryResult<ImageRegionEditorQuery, ImageRegionEditorQueryVariables>;
export const UpdateImageRegionDocument = gql`
    mutation UpdateImageRegion($alternativeTextAttributeId: ID!, $alternativeText: String!) {
  updateAlternativeTextAttribute(
    input: {attributeId: $alternativeTextAttributeId, alternativeText: $alternativeText}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      alternativeText
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
}
    `;
export type UpdateImageRegionMutationFn = Apollo.MutationFunction<UpdateImageRegionMutation, UpdateImageRegionMutationVariables>;

/**
 * __useUpdateImageRegionMutation__
 *
 * To run a mutation, you first call `useUpdateImageRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageRegionMutation, { data, loading, error }] = useUpdateImageRegionMutation({
 *   variables: {
 *      alternativeTextAttributeId: // value for 'alternativeTextAttributeId'
 *      alternativeText: // value for 'alternativeText'
 *   },
 * });
 */
export function useUpdateImageRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImageRegionMutation, UpdateImageRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImageRegionMutation, UpdateImageRegionMutationVariables>(UpdateImageRegionDocument, options);
      }
export type UpdateImageRegionMutationHookResult = ReturnType<typeof useUpdateImageRegionMutation>;
export type UpdateImageRegionMutationResult = Apollo.MutationResult<UpdateImageRegionMutation>;
export type UpdateImageRegionMutationOptions = Apollo.BaseMutationOptions<UpdateImageRegionMutation, UpdateImageRegionMutationVariables>;
export const ListItemRegionCreationTabDocument = gql`
    query ListItemRegionCreationTab($regionId: ID!, $listItemAttributeIds: [ID!]!, $textAttributeIds: [ID!]!) {
  region: node(id: $regionId) {
    id
    ...TextFormField
  }
  listItemAttributes: nodes(ids: $listItemAttributeIds) {
    ... on ListItemAttribute {
      id
      ordinal
    }
  }
  textAttributes: nodes(ids: $textAttributeIds) {
    ... on TextAttribute {
      id
      text
    }
  }
}
    ${TextFormFieldFragmentDoc}`;

/**
 * __useListItemRegionCreationTabQuery__
 *
 * To run a query within a React component, call `useListItemRegionCreationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useListItemRegionCreationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListItemRegionCreationTabQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      listItemAttributeIds: // value for 'listItemAttributeIds'
 *      textAttributeIds: // value for 'textAttributeIds'
 *   },
 * });
 */
export function useListItemRegionCreationTabQuery(baseOptions: Apollo.QueryHookOptions<ListItemRegionCreationTabQuery, ListItemRegionCreationTabQueryVariables> & ({ variables: ListItemRegionCreationTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListItemRegionCreationTabQuery, ListItemRegionCreationTabQueryVariables>(ListItemRegionCreationTabDocument, options);
      }
export function useListItemRegionCreationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListItemRegionCreationTabQuery, ListItemRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListItemRegionCreationTabQuery, ListItemRegionCreationTabQueryVariables>(ListItemRegionCreationTabDocument, options);
        }
export function useListItemRegionCreationTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListItemRegionCreationTabQuery, ListItemRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListItemRegionCreationTabQuery, ListItemRegionCreationTabQueryVariables>(ListItemRegionCreationTabDocument, options);
        }
export type ListItemRegionCreationTabQueryHookResult = ReturnType<typeof useListItemRegionCreationTabQuery>;
export type ListItemRegionCreationTabLazyQueryHookResult = ReturnType<typeof useListItemRegionCreationTabLazyQuery>;
export type ListItemRegionCreationTabSuspenseQueryHookResult = ReturnType<typeof useListItemRegionCreationTabSuspenseQuery>;
export type ListItemRegionCreationTabQueryResult = Apollo.QueryResult<ListItemRegionCreationTabQuery, ListItemRegionCreationTabQueryVariables>;
export const CreateListItemRegionDocument = gql`
    mutation CreateListItemRegion($regionId: ID!, $ordinal: NonNegativeInt!, $text: String!, $excessAttributeIds: [ID!]!) {
  createListItemAttribute(input: {regionId: $regionId, ordinal: $ordinal}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      ordinal
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
  createTextAttribute(input: {regionId: $regionId, text: $text}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      text
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...ListItemRegionTile
      }
    }
  }
  deleteAttributes(input: {attributeIds: $excessAttributeIds}) {
    userErrors {
      code
      path
    }
  }
}
    ${RegionLabelFragmentDoc}
${ListItemRegionTileFragmentDoc}`;
export type CreateListItemRegionMutationFn = Apollo.MutationFunction<CreateListItemRegionMutation, CreateListItemRegionMutationVariables>;

/**
 * __useCreateListItemRegionMutation__
 *
 * To run a mutation, you first call `useCreateListItemRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListItemRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListItemRegionMutation, { data, loading, error }] = useCreateListItemRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      ordinal: // value for 'ordinal'
 *      text: // value for 'text'
 *      excessAttributeIds: // value for 'excessAttributeIds'
 *   },
 * });
 */
export function useCreateListItemRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateListItemRegionMutation, CreateListItemRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListItemRegionMutation, CreateListItemRegionMutationVariables>(CreateListItemRegionDocument, options);
      }
export type CreateListItemRegionMutationHookResult = ReturnType<typeof useCreateListItemRegionMutation>;
export type CreateListItemRegionMutationResult = Apollo.MutationResult<CreateListItemRegionMutation>;
export type CreateListItemRegionMutationOptions = Apollo.BaseMutationOptions<CreateListItemRegionMutation, CreateListItemRegionMutationVariables>;
export const ListItemRegionEditorDocument = gql`
    query ListItemRegionEditor($listItemAttributeId: ID!, $textAttributeId: ID!) {
  listItemAttr: node(id: $listItemAttributeId) {
    ... on ListItemAttribute {
      id
      ordinal
    }
  }
  textAttr: node(id: $textAttributeId) {
    ... on TextAttribute {
      id
      text
      region {
        id
        ...TextFormField
      }
    }
  }
}
    ${TextFormFieldFragmentDoc}`;

/**
 * __useListItemRegionEditorQuery__
 *
 * To run a query within a React component, call `useListItemRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useListItemRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListItemRegionEditorQuery({
 *   variables: {
 *      listItemAttributeId: // value for 'listItemAttributeId'
 *      textAttributeId: // value for 'textAttributeId'
 *   },
 * });
 */
export function useListItemRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<ListItemRegionEditorQuery, ListItemRegionEditorQueryVariables> & ({ variables: ListItemRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListItemRegionEditorQuery, ListItemRegionEditorQueryVariables>(ListItemRegionEditorDocument, options);
      }
export function useListItemRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListItemRegionEditorQuery, ListItemRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListItemRegionEditorQuery, ListItemRegionEditorQueryVariables>(ListItemRegionEditorDocument, options);
        }
export function useListItemRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListItemRegionEditorQuery, ListItemRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListItemRegionEditorQuery, ListItemRegionEditorQueryVariables>(ListItemRegionEditorDocument, options);
        }
export type ListItemRegionEditorQueryHookResult = ReturnType<typeof useListItemRegionEditorQuery>;
export type ListItemRegionEditorLazyQueryHookResult = ReturnType<typeof useListItemRegionEditorLazyQuery>;
export type ListItemRegionEditorSuspenseQueryHookResult = ReturnType<typeof useListItemRegionEditorSuspenseQuery>;
export type ListItemRegionEditorQueryResult = Apollo.QueryResult<ListItemRegionEditorQuery, ListItemRegionEditorQueryVariables>;
export const UpdateListItemRegionDocument = gql`
    mutation UpdateListItemRegion($listItemAttributeId: ID!, $textAttributeId: ID!, $ordinal: NonNegativeInt!, $text: String!) {
  updateListItemAttribute(
    input: {attributeId: $listItemAttributeId, ordinal: $ordinal}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      ordinal
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
  updateTextAttribute(input: {attributeId: $textAttributeId, text: $text}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      text
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
}
    `;
export type UpdateListItemRegionMutationFn = Apollo.MutationFunction<UpdateListItemRegionMutation, UpdateListItemRegionMutationVariables>;

/**
 * __useUpdateListItemRegionMutation__
 *
 * To run a mutation, you first call `useUpdateListItemRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListItemRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListItemRegionMutation, { data, loading, error }] = useUpdateListItemRegionMutation({
 *   variables: {
 *      listItemAttributeId: // value for 'listItemAttributeId'
 *      textAttributeId: // value for 'textAttributeId'
 *      ordinal: // value for 'ordinal'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateListItemRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListItemRegionMutation, UpdateListItemRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListItemRegionMutation, UpdateListItemRegionMutationVariables>(UpdateListItemRegionDocument, options);
      }
export type UpdateListItemRegionMutationHookResult = ReturnType<typeof useUpdateListItemRegionMutation>;
export type UpdateListItemRegionMutationResult = Apollo.MutationResult<UpdateListItemRegionMutation>;
export type UpdateListItemRegionMutationOptions = Apollo.BaseMutationOptions<UpdateListItemRegionMutation, UpdateListItemRegionMutationVariables>;
export const ListRegionCreationTabDocument = gql`
    query ListRegionCreationTab($regionId: ID!, $listAttributeIds: [ID!]!) {
  region: node(id: $regionId) {
    id
  }
  listAttributes: nodes(ids: $listAttributeIds) {
    ... on ListAttribute {
      id
      listType
    }
  }
}
    `;

/**
 * __useListRegionCreationTabQuery__
 *
 * To run a query within a React component, call `useListRegionCreationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRegionCreationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRegionCreationTabQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      listAttributeIds: // value for 'listAttributeIds'
 *   },
 * });
 */
export function useListRegionCreationTabQuery(baseOptions: Apollo.QueryHookOptions<ListRegionCreationTabQuery, ListRegionCreationTabQueryVariables> & ({ variables: ListRegionCreationTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRegionCreationTabQuery, ListRegionCreationTabQueryVariables>(ListRegionCreationTabDocument, options);
      }
export function useListRegionCreationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRegionCreationTabQuery, ListRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRegionCreationTabQuery, ListRegionCreationTabQueryVariables>(ListRegionCreationTabDocument, options);
        }
export function useListRegionCreationTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListRegionCreationTabQuery, ListRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListRegionCreationTabQuery, ListRegionCreationTabQueryVariables>(ListRegionCreationTabDocument, options);
        }
export type ListRegionCreationTabQueryHookResult = ReturnType<typeof useListRegionCreationTabQuery>;
export type ListRegionCreationTabLazyQueryHookResult = ReturnType<typeof useListRegionCreationTabLazyQuery>;
export type ListRegionCreationTabSuspenseQueryHookResult = ReturnType<typeof useListRegionCreationTabSuspenseQuery>;
export type ListRegionCreationTabQueryResult = Apollo.QueryResult<ListRegionCreationTabQuery, ListRegionCreationTabQueryVariables>;
export const CreateListRegionDocument = gql`
    mutation CreateListRegion($regionId: ID!, $listType: ListType!, $excessAttributeIds: [ID!]!) {
  createListAttribute(input: {regionId: $regionId, listType: $listType}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      listType
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...ListRegionTile
      }
    }
  }
  deleteAttributes(input: {attributeIds: $excessAttributeIds}) {
    userErrors {
      code
      path
    }
  }
}
    ${RegionLabelFragmentDoc}
${ListRegionTileFragmentDoc}`;
export type CreateListRegionMutationFn = Apollo.MutationFunction<CreateListRegionMutation, CreateListRegionMutationVariables>;

/**
 * __useCreateListRegionMutation__
 *
 * To run a mutation, you first call `useCreateListRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListRegionMutation, { data, loading, error }] = useCreateListRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      listType: // value for 'listType'
 *      excessAttributeIds: // value for 'excessAttributeIds'
 *   },
 * });
 */
export function useCreateListRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateListRegionMutation, CreateListRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListRegionMutation, CreateListRegionMutationVariables>(CreateListRegionDocument, options);
      }
export type CreateListRegionMutationHookResult = ReturnType<typeof useCreateListRegionMutation>;
export type CreateListRegionMutationResult = Apollo.MutationResult<CreateListRegionMutation>;
export type CreateListRegionMutationOptions = Apollo.BaseMutationOptions<CreateListRegionMutation, CreateListRegionMutationVariables>;
export const ListRegionEditorDocument = gql`
    query listRegionEditor($listAttributeId: ID!) {
  listAttr: node(id: $listAttributeId) {
    ... on ListAttribute {
      id
      listType
    }
  }
}
    `;

/**
 * __useListRegionEditorQuery__
 *
 * To run a query within a React component, call `useListRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRegionEditorQuery({
 *   variables: {
 *      listAttributeId: // value for 'listAttributeId'
 *   },
 * });
 */
export function useListRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<ListRegionEditorQuery, ListRegionEditorQueryVariables> & ({ variables: ListRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRegionEditorQuery, ListRegionEditorQueryVariables>(ListRegionEditorDocument, options);
      }
export function useListRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRegionEditorQuery, ListRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRegionEditorQuery, ListRegionEditorQueryVariables>(ListRegionEditorDocument, options);
        }
export function useListRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListRegionEditorQuery, ListRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListRegionEditorQuery, ListRegionEditorQueryVariables>(ListRegionEditorDocument, options);
        }
export type ListRegionEditorQueryHookResult = ReturnType<typeof useListRegionEditorQuery>;
export type ListRegionEditorLazyQueryHookResult = ReturnType<typeof useListRegionEditorLazyQuery>;
export type ListRegionEditorSuspenseQueryHookResult = ReturnType<typeof useListRegionEditorSuspenseQuery>;
export type ListRegionEditorQueryResult = Apollo.QueryResult<ListRegionEditorQuery, ListRegionEditorQueryVariables>;
export const UpdateListRegionDocument = gql`
    mutation UpdateListRegion($listAttributeId: ID!, $listType: ListType!) {
  updateListAttribute(input: {attributeId: $listAttributeId, listType: $listType}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      listType
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
}
    `;
export type UpdateListRegionMutationFn = Apollo.MutationFunction<UpdateListRegionMutation, UpdateListRegionMutationVariables>;

/**
 * __useUpdateListRegionMutation__
 *
 * To run a mutation, you first call `useUpdateListRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListRegionMutation, { data, loading, error }] = useUpdateListRegionMutation({
 *   variables: {
 *      listAttributeId: // value for 'listAttributeId'
 *      listType: // value for 'listType'
 *   },
 * });
 */
export function useUpdateListRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListRegionMutation, UpdateListRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListRegionMutation, UpdateListRegionMutationVariables>(UpdateListRegionDocument, options);
      }
export type UpdateListRegionMutationHookResult = ReturnType<typeof useUpdateListRegionMutation>;
export type UpdateListRegionMutationResult = Apollo.MutationResult<UpdateListRegionMutation>;
export type UpdateListRegionMutationOptions = Apollo.BaseMutationOptions<UpdateListRegionMutation, UpdateListRegionMutationVariables>;
export const SublistRegionCreationTabDocument = gql`
    query SublistRegionCreationTab($regionId: ID!, $listAttributeIds: [ID!]!, $listItemAttributeIds: [ID!]!) {
  region: node(id: $regionId) {
    id
  }
  listAttributes: nodes(ids: $listAttributeIds) {
    ... on ListAttribute {
      id
      listType
    }
  }
  listItemAttributes: nodes(ids: $listItemAttributeIds) {
    ... on ListItemAttribute {
      id
      ordinal
    }
  }
}
    `;

/**
 * __useSublistRegionCreationTabQuery__
 *
 * To run a query within a React component, call `useSublistRegionCreationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useSublistRegionCreationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSublistRegionCreationTabQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      listAttributeIds: // value for 'listAttributeIds'
 *      listItemAttributeIds: // value for 'listItemAttributeIds'
 *   },
 * });
 */
export function useSublistRegionCreationTabQuery(baseOptions: Apollo.QueryHookOptions<SublistRegionCreationTabQuery, SublistRegionCreationTabQueryVariables> & ({ variables: SublistRegionCreationTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SublistRegionCreationTabQuery, SublistRegionCreationTabQueryVariables>(SublistRegionCreationTabDocument, options);
      }
export function useSublistRegionCreationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SublistRegionCreationTabQuery, SublistRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SublistRegionCreationTabQuery, SublistRegionCreationTabQueryVariables>(SublistRegionCreationTabDocument, options);
        }
export function useSublistRegionCreationTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SublistRegionCreationTabQuery, SublistRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SublistRegionCreationTabQuery, SublistRegionCreationTabQueryVariables>(SublistRegionCreationTabDocument, options);
        }
export type SublistRegionCreationTabQueryHookResult = ReturnType<typeof useSublistRegionCreationTabQuery>;
export type SublistRegionCreationTabLazyQueryHookResult = ReturnType<typeof useSublistRegionCreationTabLazyQuery>;
export type SublistRegionCreationTabSuspenseQueryHookResult = ReturnType<typeof useSublistRegionCreationTabSuspenseQuery>;
export type SublistRegionCreationTabQueryResult = Apollo.QueryResult<SublistRegionCreationTabQuery, SublistRegionCreationTabQueryVariables>;
export const CreateSublistRegionDocument = gql`
    mutation CreateSublistRegion($regionId: ID!, $listType: ListType!, $ordinal: NonNegativeInt!, $excessAttributeIds: [ID!]!) {
  createListAttribute(input: {regionId: $regionId, listType: $listType}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      listType
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
  createListItemAttribute(input: {regionId: $regionId, ordinal: $ordinal}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      ordinal
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...ListRegionTile
      }
    }
  }
  deleteAttributes(input: {attributeIds: $excessAttributeIds}) {
    userErrors {
      code
      path
    }
  }
}
    ${RegionLabelFragmentDoc}
${ListRegionTileFragmentDoc}`;
export type CreateSublistRegionMutationFn = Apollo.MutationFunction<CreateSublistRegionMutation, CreateSublistRegionMutationVariables>;

/**
 * __useCreateSublistRegionMutation__
 *
 * To run a mutation, you first call `useCreateSublistRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSublistRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSublistRegionMutation, { data, loading, error }] = useCreateSublistRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      listType: // value for 'listType'
 *      ordinal: // value for 'ordinal'
 *      excessAttributeIds: // value for 'excessAttributeIds'
 *   },
 * });
 */
export function useCreateSublistRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSublistRegionMutation, CreateSublistRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSublistRegionMutation, CreateSublistRegionMutationVariables>(CreateSublistRegionDocument, options);
      }
export type CreateSublistRegionMutationHookResult = ReturnType<typeof useCreateSublistRegionMutation>;
export type CreateSublistRegionMutationResult = Apollo.MutationResult<CreateSublistRegionMutation>;
export type CreateSublistRegionMutationOptions = Apollo.BaseMutationOptions<CreateSublistRegionMutation, CreateSublistRegionMutationVariables>;
export const SublistRegionEditorDocument = gql`
    query SublistRegionEditor($listAttributeId: ID!, $listItemAttributeId: ID!) {
  listAttr: node(id: $listAttributeId) {
    ... on ListAttribute {
      id
      listType
    }
  }
  listItemAttr: node(id: $listItemAttributeId) {
    ... on ListItemAttribute {
      id
      ordinal
    }
  }
}
    `;

/**
 * __useSublistRegionEditorQuery__
 *
 * To run a query within a React component, call `useSublistRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSublistRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSublistRegionEditorQuery({
 *   variables: {
 *      listAttributeId: // value for 'listAttributeId'
 *      listItemAttributeId: // value for 'listItemAttributeId'
 *   },
 * });
 */
export function useSublistRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<SublistRegionEditorQuery, SublistRegionEditorQueryVariables> & ({ variables: SublistRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SublistRegionEditorQuery, SublistRegionEditorQueryVariables>(SublistRegionEditorDocument, options);
      }
export function useSublistRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SublistRegionEditorQuery, SublistRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SublistRegionEditorQuery, SublistRegionEditorQueryVariables>(SublistRegionEditorDocument, options);
        }
export function useSublistRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SublistRegionEditorQuery, SublistRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SublistRegionEditorQuery, SublistRegionEditorQueryVariables>(SublistRegionEditorDocument, options);
        }
export type SublistRegionEditorQueryHookResult = ReturnType<typeof useSublistRegionEditorQuery>;
export type SublistRegionEditorLazyQueryHookResult = ReturnType<typeof useSublistRegionEditorLazyQuery>;
export type SublistRegionEditorSuspenseQueryHookResult = ReturnType<typeof useSublistRegionEditorSuspenseQuery>;
export type SublistRegionEditorQueryResult = Apollo.QueryResult<SublistRegionEditorQuery, SublistRegionEditorQueryVariables>;
export const UpdateSublistRegionDocument = gql`
    mutation UpdateSublistRegion($listAttributeId: ID!, $listType: ListType!, $listItemAttributeId: ID!, $ordinal: NonNegativeInt!) {
  updateListAttribute(input: {attributeId: $listAttributeId, listType: $listType}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      listType
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
  updateListItemAttribute(
    input: {attributeId: $listItemAttributeId, ordinal: $ordinal}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      ordinal
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
}
    `;
export type UpdateSublistRegionMutationFn = Apollo.MutationFunction<UpdateSublistRegionMutation, UpdateSublistRegionMutationVariables>;

/**
 * __useUpdateSublistRegionMutation__
 *
 * To run a mutation, you first call `useUpdateSublistRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSublistRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSublistRegionMutation, { data, loading, error }] = useUpdateSublistRegionMutation({
 *   variables: {
 *      listAttributeId: // value for 'listAttributeId'
 *      listType: // value for 'listType'
 *      listItemAttributeId: // value for 'listItemAttributeId'
 *      ordinal: // value for 'ordinal'
 *   },
 * });
 */
export function useUpdateSublistRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSublistRegionMutation, UpdateSublistRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSublistRegionMutation, UpdateSublistRegionMutationVariables>(UpdateSublistRegionDocument, options);
      }
export type UpdateSublistRegionMutationHookResult = ReturnType<typeof useUpdateSublistRegionMutation>;
export type UpdateSublistRegionMutationResult = Apollo.MutationResult<UpdateSublistRegionMutation>;
export type UpdateSublistRegionMutationOptions = Apollo.BaseMutationOptions<UpdateSublistRegionMutation, UpdateSublistRegionMutationVariables>;
export const TableRegionCreationTabDocument = gql`
    query TableRegionCreationTab($regionId: ID!) {
  region: node(id: $regionId) {
    id
    ...TableRegionUpsertForm
  }
}
    ${TableRegionUpsertFormFragmentDoc}`;

/**
 * __useTableRegionCreationTabQuery__
 *
 * To run a query within a React component, call `useTableRegionCreationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableRegionCreationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableRegionCreationTabQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useTableRegionCreationTabQuery(baseOptions: Apollo.QueryHookOptions<TableRegionCreationTabQuery, TableRegionCreationTabQueryVariables> & ({ variables: TableRegionCreationTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TableRegionCreationTabQuery, TableRegionCreationTabQueryVariables>(TableRegionCreationTabDocument, options);
      }
export function useTableRegionCreationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableRegionCreationTabQuery, TableRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TableRegionCreationTabQuery, TableRegionCreationTabQueryVariables>(TableRegionCreationTabDocument, options);
        }
export function useTableRegionCreationTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TableRegionCreationTabQuery, TableRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TableRegionCreationTabQuery, TableRegionCreationTabQueryVariables>(TableRegionCreationTabDocument, options);
        }
export type TableRegionCreationTabQueryHookResult = ReturnType<typeof useTableRegionCreationTabQuery>;
export type TableRegionCreationTabLazyQueryHookResult = ReturnType<typeof useTableRegionCreationTabLazyQuery>;
export type TableRegionCreationTabSuspenseQueryHookResult = ReturnType<typeof useTableRegionCreationTabSuspenseQuery>;
export type TableRegionCreationTabQueryResult = Apollo.QueryResult<TableRegionCreationTabQuery, TableRegionCreationTabQueryVariables>;
export const TableRegionEditorDocument = gql`
    query TableRegionEditor($tableAttributeId: ID!) {
  tableAttr: node(id: $tableAttributeId) {
    ... on TableAttribute {
      id
      region {
        id
        ...TableRegionUpsertForm
      }
    }
  }
}
    ${TableRegionUpsertFormFragmentDoc}`;

/**
 * __useTableRegionEditorQuery__
 *
 * To run a query within a React component, call `useTableRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableRegionEditorQuery({
 *   variables: {
 *      tableAttributeId: // value for 'tableAttributeId'
 *   },
 * });
 */
export function useTableRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<TableRegionEditorQuery, TableRegionEditorQueryVariables> & ({ variables: TableRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TableRegionEditorQuery, TableRegionEditorQueryVariables>(TableRegionEditorDocument, options);
      }
export function useTableRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableRegionEditorQuery, TableRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TableRegionEditorQuery, TableRegionEditorQueryVariables>(TableRegionEditorDocument, options);
        }
export function useTableRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TableRegionEditorQuery, TableRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TableRegionEditorQuery, TableRegionEditorQueryVariables>(TableRegionEditorDocument, options);
        }
export type TableRegionEditorQueryHookResult = ReturnType<typeof useTableRegionEditorQuery>;
export type TableRegionEditorLazyQueryHookResult = ReturnType<typeof useTableRegionEditorLazyQuery>;
export type TableRegionEditorSuspenseQueryHookResult = ReturnType<typeof useTableRegionEditorSuspenseQuery>;
export type TableRegionEditorQueryResult = Apollo.QueryResult<TableRegionEditorQuery, TableRegionEditorQueryVariables>;
export const DeleteTableCellRegionDocument = gql`
    mutation DeleteTableCellRegion($regionId: ID!) {
  deleteRegion(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    region {
      id
    }
  }
}
    `;
export type DeleteTableCellRegionMutationFn = Apollo.MutationFunction<DeleteTableCellRegionMutation, DeleteTableCellRegionMutationVariables>;

/**
 * __useDeleteTableCellRegionMutation__
 *
 * To run a mutation, you first call `useDeleteTableCellRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableCellRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableCellRegionMutation, { data, loading, error }] = useDeleteTableCellRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useDeleteTableCellRegionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTableCellRegionMutation, DeleteTableCellRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTableCellRegionMutation, DeleteTableCellRegionMutationVariables>(DeleteTableCellRegionDocument, options);
      }
export type DeleteTableCellRegionMutationHookResult = ReturnType<typeof useDeleteTableCellRegionMutation>;
export type DeleteTableCellRegionMutationResult = Apollo.MutationResult<DeleteTableCellRegionMutation>;
export type DeleteTableCellRegionMutationOptions = Apollo.BaseMutationOptions<DeleteTableCellRegionMutation, DeleteTableCellRegionMutationVariables>;
export const CreateTableRegionDocument = gql`
    mutation CreateTableRegion($regionId: ID!, $rows: [NonNegativeFloat!]!, $cols: [NonNegativeFloat!]!, $excessAttributeIds: [ID!]!) {
  deleteAttributes(input: {attributeIds: $excessAttributeIds}) {
    userErrors {
      code
      path
    }
  }
  createTableAttribute(
    input: {regionId: $regionId, rows: $rows, columns: $cols, parentColumnOffset: 0, parentRowOffset: 0}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        ...RegionLabel
        ...TableRegionTile
      }
    }
  }
}
    ${RegionLabelFragmentDoc}
${TableRegionTileFragmentDoc}`;
export type CreateTableRegionMutationFn = Apollo.MutationFunction<CreateTableRegionMutation, CreateTableRegionMutationVariables>;

/**
 * __useCreateTableRegionMutation__
 *
 * To run a mutation, you first call `useCreateTableRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableRegionMutation, { data, loading, error }] = useCreateTableRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      rows: // value for 'rows'
 *      cols: // value for 'cols'
 *      excessAttributeIds: // value for 'excessAttributeIds'
 *   },
 * });
 */
export function useCreateTableRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTableRegionMutation, CreateTableRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTableRegionMutation, CreateTableRegionMutationVariables>(CreateTableRegionDocument, options);
      }
export type CreateTableRegionMutationHookResult = ReturnType<typeof useCreateTableRegionMutation>;
export type CreateTableRegionMutationResult = Apollo.MutationResult<CreateTableRegionMutation>;
export type CreateTableRegionMutationOptions = Apollo.BaseMutationOptions<CreateTableRegionMutation, CreateTableRegionMutationVariables>;
export const CreateTableCellRegionDocument = gql`
    mutation CreateTableCellRegion($pageId: ID!, $vertices: [InputVertex!]!) {
  createRegion(input: {pageId: $pageId, shape: {vertices: $vertices}}) {
    userErrors {
      code
      path
    }
    region {
      id
    }
  }
}
    `;
export type CreateTableCellRegionMutationFn = Apollo.MutationFunction<CreateTableCellRegionMutation, CreateTableCellRegionMutationVariables>;

/**
 * __useCreateTableCellRegionMutation__
 *
 * To run a mutation, you first call `useCreateTableCellRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableCellRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableCellRegionMutation, { data, loading, error }] = useCreateTableCellRegionMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      vertices: // value for 'vertices'
 *   },
 * });
 */
export function useCreateTableCellRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTableCellRegionMutation, CreateTableCellRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTableCellRegionMutation, CreateTableCellRegionMutationVariables>(CreateTableCellRegionDocument, options);
      }
export type CreateTableCellRegionMutationHookResult = ReturnType<typeof useCreateTableCellRegionMutation>;
export type CreateTableCellRegionMutationResult = Apollo.MutationResult<CreateTableCellRegionMutation>;
export type CreateTableCellRegionMutationOptions = Apollo.BaseMutationOptions<CreateTableCellRegionMutation, CreateTableCellRegionMutationVariables>;
export const CreateTableDataRegionDocument = gql`
    mutation CreateTableDataRegion($regionId: ID!, $colSpan: PositiveInt!, $rowSpan: PositiveInt!) {
  createTableCellAttribute(
    input: {regionId: $regionId, columnSpan: $colSpan, rowSpan: $rowSpan}
  ) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...HybridRegionTile
      }
    }
  }
}
    ${RegionLabelFragmentDoc}
${HybridRegionTileFragmentDoc}`;
export type CreateTableDataRegionMutationFn = Apollo.MutationFunction<CreateTableDataRegionMutation, CreateTableDataRegionMutationVariables>;

/**
 * __useCreateTableDataRegionMutation__
 *
 * To run a mutation, you first call `useCreateTableDataRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableDataRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableDataRegionMutation, { data, loading, error }] = useCreateTableDataRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      colSpan: // value for 'colSpan'
 *      rowSpan: // value for 'rowSpan'
 *   },
 * });
 */
export function useCreateTableDataRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTableDataRegionMutation, CreateTableDataRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTableDataRegionMutation, CreateTableDataRegionMutationVariables>(CreateTableDataRegionDocument, options);
      }
export type CreateTableDataRegionMutationHookResult = ReturnType<typeof useCreateTableDataRegionMutation>;
export type CreateTableDataRegionMutationResult = Apollo.MutationResult<CreateTableDataRegionMutation>;
export type CreateTableDataRegionMutationOptions = Apollo.BaseMutationOptions<CreateTableDataRegionMutation, CreateTableDataRegionMutationVariables>;
export const CreateTableHeaderRegionDocument = gql`
    mutation CreateTableHeaderRegion($regionId: ID!, $colSpan: PositiveInt!, $rowSpan: PositiveInt!, $scopes: [TableHeaderCellScopeInput!]!) {
  createTableCellAttribute(
    input: {regionId: $regionId, columnSpan: $colSpan, rowSpan: $rowSpan}
  ) {
    userErrors {
      code
      path
    }
  }
  createTableHeaderCellAttribute(input: {regionId: $regionId, scopes: $scopes}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...HybridRegionTile
      }
    }
  }
}
    ${RegionLabelFragmentDoc}
${HybridRegionTileFragmentDoc}`;
export type CreateTableHeaderRegionMutationFn = Apollo.MutationFunction<CreateTableHeaderRegionMutation, CreateTableHeaderRegionMutationVariables>;

/**
 * __useCreateTableHeaderRegionMutation__
 *
 * To run a mutation, you first call `useCreateTableHeaderRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableHeaderRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableHeaderRegionMutation, { data, loading, error }] = useCreateTableHeaderRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      colSpan: // value for 'colSpan'
 *      rowSpan: // value for 'rowSpan'
 *      scopes: // value for 'scopes'
 *   },
 * });
 */
export function useCreateTableHeaderRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTableHeaderRegionMutation, CreateTableHeaderRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTableHeaderRegionMutation, CreateTableHeaderRegionMutationVariables>(CreateTableHeaderRegionDocument, options);
      }
export type CreateTableHeaderRegionMutationHookResult = ReturnType<typeof useCreateTableHeaderRegionMutation>;
export type CreateTableHeaderRegionMutationResult = Apollo.MutationResult<CreateTableHeaderRegionMutation>;
export type CreateTableHeaderRegionMutationOptions = Apollo.BaseMutationOptions<CreateTableHeaderRegionMutation, CreateTableHeaderRegionMutationVariables>;
export const TextRegionCreationTabDocument = gql`
    query TextRegionCreationTab($regionId: ID!, $textAttributeIds: [ID!]!) {
  region: node(id: $regionId) {
    id
    ...TextFormField
  }
  textAttributes: nodes(ids: $textAttributeIds) {
    ... on TextAttribute {
      id
      text
    }
  }
}
    ${TextFormFieldFragmentDoc}`;

/**
 * __useTextRegionCreationTabQuery__
 *
 * To run a query within a React component, call `useTextRegionCreationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useTextRegionCreationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTextRegionCreationTabQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      textAttributeIds: // value for 'textAttributeIds'
 *   },
 * });
 */
export function useTextRegionCreationTabQuery(baseOptions: Apollo.QueryHookOptions<TextRegionCreationTabQuery, TextRegionCreationTabQueryVariables> & ({ variables: TextRegionCreationTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TextRegionCreationTabQuery, TextRegionCreationTabQueryVariables>(TextRegionCreationTabDocument, options);
      }
export function useTextRegionCreationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TextRegionCreationTabQuery, TextRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TextRegionCreationTabQuery, TextRegionCreationTabQueryVariables>(TextRegionCreationTabDocument, options);
        }
export function useTextRegionCreationTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TextRegionCreationTabQuery, TextRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TextRegionCreationTabQuery, TextRegionCreationTabQueryVariables>(TextRegionCreationTabDocument, options);
        }
export type TextRegionCreationTabQueryHookResult = ReturnType<typeof useTextRegionCreationTabQuery>;
export type TextRegionCreationTabLazyQueryHookResult = ReturnType<typeof useTextRegionCreationTabLazyQuery>;
export type TextRegionCreationTabSuspenseQueryHookResult = ReturnType<typeof useTextRegionCreationTabSuspenseQuery>;
export type TextRegionCreationTabQueryResult = Apollo.QueryResult<TextRegionCreationTabQuery, TextRegionCreationTabQueryVariables>;
export const CreateTextRegionDocument = gql`
    mutation CreateTextRegion($regionId: ID!, $text: String!, $excessAttributeIds: [ID!]!) {
  createTextAttribute(input: {regionId: $regionId, text: $text}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      text
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...TextRegionTile
      }
    }
  }
  deleteAttributes(input: {attributeIds: $excessAttributeIds}) {
    userErrors {
      code
      path
    }
  }
}
    ${RegionLabelFragmentDoc}
${TextRegionTileFragmentDoc}`;
export type CreateTextRegionMutationFn = Apollo.MutationFunction<CreateTextRegionMutation, CreateTextRegionMutationVariables>;

/**
 * __useCreateTextRegionMutation__
 *
 * To run a mutation, you first call `useCreateTextRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTextRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTextRegionMutation, { data, loading, error }] = useCreateTextRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      text: // value for 'text'
 *      excessAttributeIds: // value for 'excessAttributeIds'
 *   },
 * });
 */
export function useCreateTextRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTextRegionMutation, CreateTextRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTextRegionMutation, CreateTextRegionMutationVariables>(CreateTextRegionDocument, options);
      }
export type CreateTextRegionMutationHookResult = ReturnType<typeof useCreateTextRegionMutation>;
export type CreateTextRegionMutationResult = Apollo.MutationResult<CreateTextRegionMutation>;
export type CreateTextRegionMutationOptions = Apollo.BaseMutationOptions<CreateTextRegionMutation, CreateTextRegionMutationVariables>;
export const TextRegionEditorDocument = gql`
    query TextRegionEditor($textAttributeId: ID!) {
  textAttr: node(id: $textAttributeId) {
    ... on TextAttribute {
      id
      text
      region {
        id
        issues {
          id
        }
        page {
          id
          issues {
            id
          }
          ...ExtensionFormulaRef
          ...ExtensionFootnoteRef
        }
        ...TextFormField
      }
    }
  }
}
    ${ExtensionFormulaRefFragmentDoc}
${ExtensionFootnoteRefFragmentDoc}
${TextFormFieldFragmentDoc}`;

/**
 * __useTextRegionEditorQuery__
 *
 * To run a query within a React component, call `useTextRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useTextRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTextRegionEditorQuery({
 *   variables: {
 *      textAttributeId: // value for 'textAttributeId'
 *   },
 * });
 */
export function useTextRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<TextRegionEditorQuery, TextRegionEditorQueryVariables> & ({ variables: TextRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TextRegionEditorQuery, TextRegionEditorQueryVariables>(TextRegionEditorDocument, options);
      }
export function useTextRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TextRegionEditorQuery, TextRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TextRegionEditorQuery, TextRegionEditorQueryVariables>(TextRegionEditorDocument, options);
        }
export function useTextRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TextRegionEditorQuery, TextRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TextRegionEditorQuery, TextRegionEditorQueryVariables>(TextRegionEditorDocument, options);
        }
export type TextRegionEditorQueryHookResult = ReturnType<typeof useTextRegionEditorQuery>;
export type TextRegionEditorLazyQueryHookResult = ReturnType<typeof useTextRegionEditorLazyQuery>;
export type TextRegionEditorSuspenseQueryHookResult = ReturnType<typeof useTextRegionEditorSuspenseQuery>;
export type TextRegionEditorQueryResult = Apollo.QueryResult<TextRegionEditorQuery, TextRegionEditorQueryVariables>;
export const UpdateTextRegionDocument = gql`
    mutation UpdateTextRegion($textAttributeId: ID!, $text: String!) {
  updateTextAttribute(input: {attributeId: $textAttributeId, text: $text}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      text
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
      }
    }
  }
}
    `;
export type UpdateTextRegionMutationFn = Apollo.MutationFunction<UpdateTextRegionMutation, UpdateTextRegionMutationVariables>;

/**
 * __useUpdateTextRegionMutation__
 *
 * To run a mutation, you first call `useUpdateTextRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTextRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTextRegionMutation, { data, loading, error }] = useUpdateTextRegionMutation({
 *   variables: {
 *      textAttributeId: // value for 'textAttributeId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateTextRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTextRegionMutation, UpdateTextRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTextRegionMutation, UpdateTextRegionMutationVariables>(UpdateTextRegionDocument, options);
      }
export type UpdateTextRegionMutationHookResult = ReturnType<typeof useUpdateTextRegionMutation>;
export type UpdateTextRegionMutationResult = Apollo.MutationResult<UpdateTextRegionMutation>;
export type UpdateTextRegionMutationOptions = Apollo.BaseMutationOptions<UpdateTextRegionMutation, UpdateTextRegionMutationVariables>;
export const TocRegionCreationTabDocument = gql`
    query TOCRegionCreationTab($regionId: ID!, $tableOfContentsAttributeIds: [ID!]!) {
  region: node(id: $regionId) {
    id
  }
  tableOfContentsAttributes: nodes(ids: $tableOfContentsAttributeIds) {
    ... on TableOfContentsAttribute {
      id
    }
  }
}
    `;

/**
 * __useTocRegionCreationTabQuery__
 *
 * To run a query within a React component, call `useTocRegionCreationTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useTocRegionCreationTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTocRegionCreationTabQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      tableOfContentsAttributeIds: // value for 'tableOfContentsAttributeIds'
 *   },
 * });
 */
export function useTocRegionCreationTabQuery(baseOptions: Apollo.QueryHookOptions<TocRegionCreationTabQuery, TocRegionCreationTabQueryVariables> & ({ variables: TocRegionCreationTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TocRegionCreationTabQuery, TocRegionCreationTabQueryVariables>(TocRegionCreationTabDocument, options);
      }
export function useTocRegionCreationTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TocRegionCreationTabQuery, TocRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TocRegionCreationTabQuery, TocRegionCreationTabQueryVariables>(TocRegionCreationTabDocument, options);
        }
export function useTocRegionCreationTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TocRegionCreationTabQuery, TocRegionCreationTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TocRegionCreationTabQuery, TocRegionCreationTabQueryVariables>(TocRegionCreationTabDocument, options);
        }
export type TocRegionCreationTabQueryHookResult = ReturnType<typeof useTocRegionCreationTabQuery>;
export type TocRegionCreationTabLazyQueryHookResult = ReturnType<typeof useTocRegionCreationTabLazyQuery>;
export type TocRegionCreationTabSuspenseQueryHookResult = ReturnType<typeof useTocRegionCreationTabSuspenseQuery>;
export type TocRegionCreationTabQueryResult = Apollo.QueryResult<TocRegionCreationTabQuery, TocRegionCreationTabQueryVariables>;
export const CreateTocRegionDocument = gql`
    mutation CreateTOCRegion($regionId: ID!, $excessAttributeIds: [ID!]!) {
  createTableOfContentsAttribute(input: {regionId: $regionId}) {
    userErrors {
      code
      path
    }
    attribute {
      id
      region {
        id
        issues {
          id
        }
        page {
          issues {
            id
          }
        }
        ...RegionLabel
        ...TOCRegionTile
      }
    }
  }
  deleteAttributes(input: {attributeIds: $excessAttributeIds}) {
    userErrors {
      code
      path
    }
  }
}
    ${RegionLabelFragmentDoc}
${TocRegionTileFragmentDoc}`;
export type CreateTocRegionMutationFn = Apollo.MutationFunction<CreateTocRegionMutation, CreateTocRegionMutationVariables>;

/**
 * __useCreateTocRegionMutation__
 *
 * To run a mutation, you first call `useCreateTocRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTocRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTocRegionMutation, { data, loading, error }] = useCreateTocRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      excessAttributeIds: // value for 'excessAttributeIds'
 *   },
 * });
 */
export function useCreateTocRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTocRegionMutation, CreateTocRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTocRegionMutation, CreateTocRegionMutationVariables>(CreateTocRegionDocument, options);
      }
export type CreateTocRegionMutationHookResult = ReturnType<typeof useCreateTocRegionMutation>;
export type CreateTocRegionMutationResult = Apollo.MutationResult<CreateTocRegionMutation>;
export type CreateTocRegionMutationOptions = Apollo.BaseMutationOptions<CreateTocRegionMutation, CreateTocRegionMutationVariables>;
export const TocRegionEditorDocument = gql`
    query TOCRegionEditor($tocAttributeId: ID!) {
  tocAttr: node(id: $tocAttributeId) {
    ... on TableOfContentsAttribute {
      id
    }
  }
}
    `;

/**
 * __useTocRegionEditorQuery__
 *
 * To run a query within a React component, call `useTocRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useTocRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTocRegionEditorQuery({
 *   variables: {
 *      tocAttributeId: // value for 'tocAttributeId'
 *   },
 * });
 */
export function useTocRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<TocRegionEditorQuery, TocRegionEditorQueryVariables> & ({ variables: TocRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TocRegionEditorQuery, TocRegionEditorQueryVariables>(TocRegionEditorDocument, options);
      }
export function useTocRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TocRegionEditorQuery, TocRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TocRegionEditorQuery, TocRegionEditorQueryVariables>(TocRegionEditorDocument, options);
        }
export function useTocRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TocRegionEditorQuery, TocRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TocRegionEditorQuery, TocRegionEditorQueryVariables>(TocRegionEditorDocument, options);
        }
export type TocRegionEditorQueryHookResult = ReturnType<typeof useTocRegionEditorQuery>;
export type TocRegionEditorLazyQueryHookResult = ReturnType<typeof useTocRegionEditorLazyQuery>;
export type TocRegionEditorSuspenseQueryHookResult = ReturnType<typeof useTocRegionEditorSuspenseQuery>;
export type TocRegionEditorQueryResult = Apollo.QueryResult<TocRegionEditorQuery, TocRegionEditorQueryVariables>;
export const UntypedRegionEditorDocument = gql`
    query UntypedRegionEditor($regionId: ID!) {
  region: node(id: $regionId) {
    ... on Region {
      id
      ...HeadingRegionTypeCard
      ...TextRegionTypeCard
      ...FormulaRegionTypeCard
      ...TableRegionTypeCard
      ...ImageRegionTypeCard
      ...CaptionRegionTypeCard
      ...ListRegionTypeCard
      ...ListItemRegionTypeCard
      ...SublistRegionTypeCard
      ...ArtifactRegionTypeCard
      ...TOCRegionTypeCard
      ...HybridRegionTypeCard
    }
  }
}
    ${HeadingRegionTypeCardFragmentDoc}
${TextRegionTypeCardFragmentDoc}
${FormulaRegionTypeCardFragmentDoc}
${TableRegionTypeCardFragmentDoc}
${ImageRegionTypeCardFragmentDoc}
${CaptionRegionTypeCardFragmentDoc}
${ListRegionTypeCardFragmentDoc}
${ListItemRegionTypeCardFragmentDoc}
${SublistRegionTypeCardFragmentDoc}
${ArtifactRegionTypeCardFragmentDoc}
${TocRegionTypeCardFragmentDoc}
${HybridRegionTypeCardFragmentDoc}`;

/**
 * __useUntypedRegionEditorQuery__
 *
 * To run a query within a React component, call `useUntypedRegionEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useUntypedRegionEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUntypedRegionEditorQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useUntypedRegionEditorQuery(baseOptions: Apollo.QueryHookOptions<UntypedRegionEditorQuery, UntypedRegionEditorQueryVariables> & ({ variables: UntypedRegionEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UntypedRegionEditorQuery, UntypedRegionEditorQueryVariables>(UntypedRegionEditorDocument, options);
      }
export function useUntypedRegionEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UntypedRegionEditorQuery, UntypedRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UntypedRegionEditorQuery, UntypedRegionEditorQueryVariables>(UntypedRegionEditorDocument, options);
        }
export function useUntypedRegionEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UntypedRegionEditorQuery, UntypedRegionEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UntypedRegionEditorQuery, UntypedRegionEditorQueryVariables>(UntypedRegionEditorDocument, options);
        }
export type UntypedRegionEditorQueryHookResult = ReturnType<typeof useUntypedRegionEditorQuery>;
export type UntypedRegionEditorLazyQueryHookResult = ReturnType<typeof useUntypedRegionEditorLazyQuery>;
export type UntypedRegionEditorSuspenseQueryHookResult = ReturnType<typeof useUntypedRegionEditorSuspenseQuery>;
export type UntypedRegionEditorQueryResult = Apollo.QueryResult<UntypedRegionEditorQuery, UntypedRegionEditorQueryVariables>;